(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7992],{

/***/ 54213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useToast; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ToastContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82827);


var useToast = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_ToastContext__WEBPACK_IMPORTED_MODULE_1__/* .ToastContext */ .u);
};


/***/ }),

/***/ 3024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var photoswipe_dist_photoswipe_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67037);
/* harmony import */ var photoswipe_dist_photoswipe_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(photoswipe_dist_photoswipe_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var photoswipe_dist_default_skin_default_skin_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30880);
/* harmony import */ var photoswipe_dist_default_skin_default_skin_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(photoswipe_dist_default_skin_default_skin_css__WEBPACK_IMPORTED_MODULE_3__);




var NewPhotoSwipe = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "pswp",
        tabIndex: -1,
        role: "dialog",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pswp__bg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "pswp__scroll-wrap",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "pswp__container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "pswp__item"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "pswp__item"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "pswp__item"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "pswp__ui pswp__ui--hidden",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "pswp__top-bar",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pswp__counter"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "pswp__button pswp__button--close",
                                        title: "Close (Esc)"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "pswp__button pswp__button--fs",
                                        title: "Toggle fullscreen"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "pswp__button pswp__button--zoom",
                                        title: "Zoom in/out"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "pswp__preloader",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "pswp__preloader__icn",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "pswp__preloader__cut",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "pswp__preloader__donut"
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "pswp__share-modal pswp__share-modal--hidden pswp__single-tap",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "pswp__share-tooltip"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "pswp__button pswp__button--arrow--left",
                                title: "Previous (arrow left)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "pswp__button pswp__button--arrow--right",
                                title: "Next (arrow right)"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "pswp__caption",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "pswp__caption__center"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NewPhotoSwipe);


/***/ }),

/***/ 98503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _blockHeader_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84632);
/* harmony import */ var _blockHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_blockHeader_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var BlockHeader = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_blockHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["block-header"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            className: (_blockHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["block-header__title__custom"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_blockHeader_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["title-name-fms"]),
                children: title
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlockHeader);


/***/ }),

/***/ 84937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _products_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31351);
/* harmony import */ var _products_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_products_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);
/* harmony import */ var _atoms_Toast_useToast__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54213);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63385);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81043);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _store_wishlist__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84444);
/* harmony import */ var _shared_ProductCard_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77458);














var ProductCard = function(param) {
    var product = param.product, dbName = param.dbName, translationsData = param.translationsData, _selectedCurrItems = param.selectedCurrItems, selectedCurrCode = _selectedCurrItems.selectedCurrCode, selectedCurrRate = _selectedCurrItems.selectedCurrRate, selectedCurrSymbol = _selectedCurrItems.selectedCurrSymbol, selectedLocale = param.selectedLocale, priority = param.priority, _loading = param.loading, loading = _loading === void 0 ? "lazy" : _loading;
    var toast = (0,_atoms_Toast_useToast__WEBPACK_IMPORTED_MODULE_4__/* .useToast */ .p)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)(), routerPush = ref.push;
    var secondImage = product.images[1];
    var cartToken = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.cartToken;
    });
    var customer = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.customer;
    });
    var wishlist = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.wishlist;
    });
    var isProductInWishList = wishlist === null || wishlist === void 0 ? void 0 : wishlist.find(function(item) {
        return item.id === product.id;
    });
    var signed = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)(function(state) {
        return state.customer.authenticated;
    });
    var productId = product.id, tmp = product.flats, ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(tmp === void 0 ? [] : tmp, 1), tmp1 = ref1[0], ref2 = tmp1 === void 0 ? {} : tmp1, _url_key = ref2.url_key, url_key = _url_key === void 0 ? "" : _url_key, tmp2 = ref2.name, productName = tmp2 === void 0 ? "" : tmp2, tmp3 = ref2.short_description, productShortDesc = tmp3 === void 0 ? "" : tmp3, tmp4 = ref2.price, productPrice = tmp4 === void 0 ? "" : tmp4, tmp5 = ref2.special_price, productSpecialPrice = tmp5 === void 0 ? "" : tmp5, tmp6 = product.images, ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(tmp6 === void 0 ? [] : tmp6, 1), imagePath = ref3[0], isProductInStock = product.isProductInStock;
    var addToast = function(error) {
        if (error) {
            toast.open(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "d-flex chek-fms",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .FailSvg */ .as, {}),
                    translationsData.ProductNotAvailable
                ]
            }));
        } else {
            if (isProductInStock) {
                toast.open(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "d-flex chek-fms",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .CheckToastSvg */ .xQ, {}),
                        translationsData.ToastAddToCart
                    ]
                }));
            }
        }
    };
    var cartDataObj = {
        product: product,
        quantity: 1,
        cartToken: cartToken,
        customer: customer,
        selectedLocale: selectedLocale,
        selectedCurrCode: selectedCurrCode,
        optionsObject: null,
        addToast: addToast
    };
    var handleWishIconClick = function(e) {
        e.preventDefault();
        if (!signed) {
            toast.open(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "d-flex faild-toast-fms",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .FailSvg */ .as, {}),
                    translationsData.ToastSignIn
                ]
            }));
        } else {
            !!isProductInWishList ? dispatch((0,_store_wishlist__WEBPACK_IMPORTED_MODULE_10__/* .wishlistRemoveItem */ .uv)(product.id)) : dispatch((0,_store_wishlist__WEBPACK_IMPORTED_MODULE_10__/* .wishlistAddItem */ .c8)(product, selectedLocale));
            var toastChildren = {
                "true": {
                    svg: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .FailSvg */ .as, {}),
                    title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ToastWishListRemove
                },
                "false": {
                    svg: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .CheckToastSvg */ .xQ, {}),
                    title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ToastWishList
                }
            };
            toast.open(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "d-flex faild-toast-fms",
                children: [
                    toastChildren["".concat(!!isProductInWishList)].svg,
                    toastChildren["".concat(!!isProductInWishList)].title
                ]
            }));
        }
    };
    var handleAddCartClickLocal = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,_shared_ProductCard_helpers__WEBPACK_IMPORTED_MODULE_8__/* .handleAddCard */ .x)({
                                openUpCrossProd: function() {
                                    return (0,_shared_ProductCard_helpers__WEBPACK_IMPORTED_MODULE_8__/* .openUpCrossProd */ .Vr)({
                                        dispatch: dispatch,
                                        productId: productId,
                                        selectedLocale: selectedLocale,
                                        selectedRate: {
                                            exchange_rate: {
                                                rate: selectedCurrRate
                                            },
                                            symbol: selectedCurrSymbol,
                                            code: selectedCurrCode
                                        },
                                        product: product
                                    });
                                },
                                dispatch: dispatch,
                                data: cartDataObj,
                                routerPush: routerPush,
                                isProductInStock: isProductInStock
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function handleAddCartClickLocal() {
            return _ref.apply(this, arguments);
        };
    }();
    var positionSymbolHandle = function(whichPrice) {
        if (selectedCurrCode === "AMD") {
            return "".concat(whichPrice !== null && whichPrice !== void 0 ? whichPrice : productPrice, " ").concat(selectedCurrSymbol);
        }
        return "".concat(selectedCurrSymbol, " ").concat(whichPrice !== null && whichPrice !== void 0 ? whichPrice : productPrice);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-card"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "".concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-card__image"])),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: "/".concat(url_key),
                    prefetch: priority,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "".concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-image__body"]), " ").concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-image__body-fms"])),
                        children: [
                            !secondImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default().item_overlay), " ").concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["hide-for-tablet"]))
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default().img_btn_wrapper),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    onClick: function() {
                                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(e) {
                                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        e.preventDefault();
                                                        return [
                                                            4,
                                                            handleAddCartClickLocal()
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(e) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(),
                                    className: "btn btn-primary ".concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-card__addToCart"]), " ").concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["hide-for-tablet"])),
                                    children: translationsData.AddToCartButtonTitle
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default().img_wrapper),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_helper__WEBPACK_IMPORTED_MODULE_5__/* .domainUrl */ .HJ)("".concat(dbName).concat(imagePath)),
                                        alt: "product card image",
                                        loading: loading,
                                        width: "280",
                                        height: "280",
                                        className: "".concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default().first_image), " ").concat(secondImage && (_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default().hide_first_image))
                                    }),
                                    secondImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: (0,_helper__WEBPACK_IMPORTED_MODULE_5__/* .domainUrl */ .HJ)("".concat(dbName).concat(secondImage)),
                                        alt: "product card image",
                                        loading: "lazy",
                                        width: "280",
                                        height: "280",
                                        className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default().second_image)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-card__info"]),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-card__name"]),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: "/".concat(url_key),
                                        prefetch: priority,
                                        children: productName || ""
                                    })
                                })
                            }),
                            productSpecialPrice ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default().prices),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default().new_price),
                                        children: positionSymbolHandle(productSpecialPrice)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default().old_price),
                                        children: positionSymbolHandle()
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default().prices),
                                children: positionSymbolHandle()
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-card__buttons"]),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    onClick: handleWishIconClick,
                                    className: "btn-light btn-svg-icon btn-svg-icon--fake-svg ".concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-card__wishlist"])),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["wishlist-icon-wrapper"]),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .HeartSvg */ .xO, {
                                            className: isProductInWishList ? (_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["inner-wishlist"]) : ""
                                        })
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    onClick: function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(e) {
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_12__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        e.preventDefault();
                                        return [
                                            4,
                                            handleAddCartClickLocal()
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(e) {
                            return _ref.apply(this, arguments);
                        };
                    }(),
                    className: "btn btn-primary ".concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["product-card__addToCart"]), " ").concat((_products_module_scss__WEBPACK_IMPORTED_MODULE_13___default()["hide-for-desktop"])),
                    children: translationsData.AddToCartButtonTitle
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCard);


/***/ }),

/***/ 79316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69587);
/* harmony import */ var _account_account_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67707);
/* harmony import */ var _account_account_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_account_account_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var socials = {
    "Facebook": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_2__/* .Facebook */ .s1, {}),
    "Google": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_2__/* .Google */ .ie, {}),
    "Twitter": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_2__/* .Twitter */ .tL, {}),
    "Linkedin": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_2__/* .Linkedin */ .n6, {}),
    "Github": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_2__/* .Github */ .Ey, {})
};
var CustomSocialLogin = function(param) {
    var translationsData = param.translationsData, isSocialLinksActive = param.isSocialLinksActive, dbName = param.dbName;
    var customerLoginWithProvider = function(provider) {
        try {
            fetch("https://".concat(dbName, "/api/customer/social-login/").concat(provider)).then(function(response) {
                return response.json();
            }).then(function(res) {
                window.location = res.url;
            });
        } catch (err) {
            console.log(err, "-----#############------error-----#############------ in customerLoginWithProvider");
        }
    };
    var showOrNotSocialToggle = {
        "true": /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_account_account_module_scss__WEBPACK_IMPORTED_MODULE_3___default().socials_content),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_account_account_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["social-line-block"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_account_account_module_scss__WEBPACK_IMPORTED_MODULE_3___default().social_line)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_account_account_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["social_line-span"]),
                            children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.SignInWith
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_account_account_module_scss__WEBPACK_IMPORTED_MODULE_3___default().social_line)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_account_account_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["social-links_line"]),
                    children: isSocialLinksActive === null || isSocialLinksActive === void 0 ? void 0 : isSocialLinksActive.map(function(param, index) {
                        var key = param.key;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_account_account_module_scss__WEBPACK_IMPORTED_MODULE_3___default().links_icons),
                            onClick: function() {
                                return customerLoginWithProvider(key.toLowerCase());
                            },
                            children: socials[key]
                        }, index);
                    })
                })
            ]
        }),
        "false": null
    };
    return showOrNotSocialToggle["".concat((isSocialLinksActive === null || isSocialLinksActive === void 0 ? void 0 : isSocialLinksActive.length) > 0)];
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomSocialLogin); //TODO!!! Will check this issue , is my token show in url or this functionality redundant
 // useEffect(() => {
 //     if (router.query.token) {
 //         dispatch(setAuth(true));
 //         dispatch(setToken(router.query.token));
 //         dispatch(setPopup(false));
 //         router.push("/account/profile/");
 //         fetch(
 //             `https://${httpUrl}/api/checkout/cart?token=${router.query.token}&api_token=${cartToken.cartToken}`
 //         )
 //             .then((responce) => responce.json())
 //             .then((resUser) => {
 //                 if (resUser) {
 //                     submitCartData(resUser, router.query.token);
 //                 } else {
 //                     toast.open(
 //                         <span className="d-flex chek-fms">
 //                             <FailSvg/>
 //                             <TranslationKeys type="AddAnAddress"/>
 //                         </span>
 //                     );
 //                 }
 //             }).catch((err) => console.error(err));
 //     }
 // }, [router]);
 // const submitCartData = (products: submitCardProductsType, token: string | string[] | undefined) => {
 //     if (cart.items.length > 0 && products.data !== null) {
 //         cart.items.map((product: { product: { id: number; }; quantity: number; id: number; }) => {
 //             let pro = products.data.items?.find(
 //                 (item) => item.product.id == product.product.id
 //             );
 //             if (pro == undefined) {
 //                 fetch(`https://${httpUrl}/api/checkout/cart/add/${product.product.id}?product_id=${product.product.id}&quantity=${product.quantity
 //                     }&api_token=${cartToken.cartToken}${
 //                         token ? `&token=${token}` : ""
 //                     }`,
 //                     {method: "POST"}
 //                 )
 //                     .then((responce) => responce.json())
 //                     .then((res) => console.log(res))
 //                     .catch((err) => console.error(err));
 //             } else {
 //                 dispatch(cartRemoveItem(product.id, cartToken, customer))
 //             }
 //         });
 //     } else if (cart.items.length > 0 && products.data === null) {
 //         cart.items.map((product) => {
 //
 //             fetch(
 //                 `${url}/api/checkout/cart/add/${product.product.id}?product_id=${
 //                     product.product.id
 //                 }&quantity=${product.quantity}&api_token=${cartToken.cartToken}${
 //                     router.query.token ? `&token=${router.query.token}` : ""
 //                 }`,
 //                 {method: "POST"}
 //             )
 //                 .then((responce) => responce.json())
 //                 .then((res) => {
 //                 })
 //                 .catch((err) => console.error(err));
 //         });
 //     }
 //
 //     if (products.data !== null && products.data.items.length > 0) {
 //         products.data.items.map((product) => {
 //             dispatch(cartRemoveItem(product.product.id, cartToken, customer))
 //         });
 //     }
 // };


/***/ }),

/***/ 84980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Wrappers_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(59637);
// EXTERNAL MODULE: ./components/ForCWV/Wrappers/customTopBar.module.scss
var customTopBar_module = __webpack_require__(474);
var customTopBar_module_default = /*#__PURE__*/__webpack_require__.n(customTopBar_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./store/mobile-menu/index.js + 3 modules
var mobile_menu = __webpack_require__(12051);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(81043);
;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomCurrDropDown.tsx








var CustomCurrDropDown = function(param) {
    var selectedCurr = param.selectedCurr, selectedSymbol = param.selectedSymbol, currencies = param.currencies;
    var ref = (0,react.useState)({
        currOpened: false,
        currClassName: ""
    }), ref1 = ref[0], currOpened = ref1.currOpened, currClassName = ref1.currClassName, setOpenCurr = ref[1];
    var currRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleClassTypes = {
        "false": [
            "",
            "menu-none"
        ],
        "true": [
            "rotT_fms",
            "menu-block"
        ]
    };
    var handleCurrClick = function() {
        setOpenCurr(function(param) {
            var prevOpen = param.currOpened;
            return {
                currOpened: !prevOpen,
                currClassName: handleClassTypes["".concat(!prevOpen)][0]
            };
        });
    };
    (0,react.useEffect)(function() {
        var handleClick = function(e) {
            if (currRef && currRef.current && !currRef.current.contains(e.target)) {
                setOpenCurr({
                    currOpened: false,
                    currClassName: ""
                });
            }
        };
        document.addEventListener("mousedown", handleClick);
        return function() {
            return document.removeEventListener("mousedown", handleClick);
        };
    }, [
        currRef
    ]);
    var handleCurrItemClick = function(currencyCode) {
        js_cookie/* default.set */.Z.set("selectedCurrency", currencyCode);
        if (router.pathname.includes("/catalog") && !router.pathname.includes("/catalog/search/[slug]")) {
            var newUrl = "/catalog";
            if (router.query.slug) {
                newUrl = "/catalog/".concat(router.query.slug);
            }
            router.push(newUrl).then(function() {
                router.reload();
            });
        } else {
            router.reload();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "forCurrency",
        className: (customTopBar_module_default())["language-button"],
        onClick: handleCurrClick,
        ref: currRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (customTopBar_module_default())["mobile-links__item-title"],
                children: selectedCurr
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (customTopBar_module_default()).mobile_currency__symbol,
                children: selectedSymbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DropDownArrow */.s0, {
                className: "".concat((customTopBar_module_default())[currClassName], " ").concat((customTopBar_module_default())[handleClassTypes["".concat(currOpened)][0]])
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customTopBar_module_default())[handleClassTypes["".concat(currOpened)][1]],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (customTopBar_module_default()).menu,
                    children: currencies === null || currencies === void 0 ? void 0 : currencies.map(function(param) {
                        var code = param.code, name = param.name, id = param.id, symbol = param.symbol;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (customTopBar_module_default()).menu_item,
                            onClick: function() {
                                dispatch((0,mobile_menu/* mobileMenuClose */.nA)());
                                handleCurrItemClick(code);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: symbol
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: code
                                })
                            ]
                        }, id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Wrappers_CustomCurrDropDown = (CustomCurrDropDown);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./components/ForCWV/Wrappers/CustomHeader/customHeader.module.scss
var customHeader_module = __webpack_require__(92365);
var customHeader_module_default = /*#__PURE__*/__webpack_require__.n(customHeader_module);
;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomItemList.tsx








var SUBMENU_WIDTH = 300;
var SUBMENU_VIEWPORT_GUTTER = 16;
var CustomItemList = function(param) {
    var items = param.items, toggleSub = param.toggleSub, openMenus = param.openMenus, dbName = param.dbName, domain = param.domain;
    var submenuRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(SUBMENU_WIDTH), submenuWidth = ref[0], setSubmenuWidth = ref[1];
    var updateSubmenuWidth = (0,react.useCallback)(function() {
        if ( false || !submenuRef.current) {
            return;
        }
        var submenuContainer = submenuRef.current.parentElement;
        if (!submenuContainer) {
            return;
        }
        var left = submenuContainer.getBoundingClientRect().left;
        var availableWidth = window.innerWidth - left - SUBMENU_VIEWPORT_GUTTER;
        var nextWidth = Math.min(SUBMENU_WIDTH, Math.max(0, Math.floor(availableWidth)));
        setSubmenuWidth(nextWidth);
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        updateSubmenuWidth();
        var submenuContainer = (ref = submenuRef.current) === null || ref === void 0 ? void 0 : ref.parentElement;
        submenuContainer === null || submenuContainer === void 0 ? void 0 : submenuContainer.addEventListener("mouseenter", updateSubmenuWidth);
        submenuContainer === null || submenuContainer === void 0 ? void 0 : submenuContainer.addEventListener("focusin", updateSubmenuWidth);
        submenuContainer === null || submenuContainer === void 0 ? void 0 : submenuContainer.addEventListener("click", updateSubmenuWidth);
        window.addEventListener("resize", updateSubmenuWidth);
        return function() {
            submenuContainer === null || submenuContainer === void 0 ? void 0 : submenuContainer.removeEventListener("mouseenter", updateSubmenuWidth);
            submenuContainer === null || submenuContainer === void 0 ? void 0 : submenuContainer.removeEventListener("focusin", updateSubmenuWidth);
            submenuContainer === null || submenuContainer === void 0 ? void 0 : submenuContainer.removeEventListener("click", updateSubmenuWidth);
            window.removeEventListener("resize", updateSubmenuWidth);
        };
    }, [
        updateSubmenuWidth
    ]);
    var submenuStyle = {
        "--submenu-dynamic-width": "".concat(submenuWidth, "px")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        ref: submenuRef,
        className: "".concat((customHeader_module_default()).menu__submenu),
        style: submenuStyle,
        onMouseEnter: updateSubmenuWidth,
        onFocus: updateSubmenuWidth,
        children: items.map(function(eachMenu, index) {
            var _name = eachMenu.name, name = _name === void 0 ? "" : _name, id = eachMenu.id, _children = eachMenu.children, children = _children === void 0 ? [] : _children, _url_key = eachMenu.url_key, url_key = _url_key === void 0 ? "" : _url_key, target = eachMenu.target, image = eachMenu.image;
            var existThisMenuId = openMenus.some(function(subId) {
                return subId === id;
            });
            var arrow = null;
            var submenu = null;
            if (children.length) {
                arrow = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((customHeader_module_default()).wrapper__bttn, " ").concat(existThisMenuId && (customHeader_module_default()).closed),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown9x6Svg */.jN, {
                        className: (customHeader_module_default()).menu__arrow
                    })
                });
                submenu = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((customHeader_module_default()).deep__submenu, " ").concat(existThisMenuId && (customHeader_module_default()).opened__drop),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomItemList, {
                        items: children,
                        toggleSub: toggleSub,
                        openMenus: openMenus,
                        dbName: dbName,
                        domain: domain
                    })
                });
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: (customHeader_module_default()).menu__li,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customHeader_module_default()).menu_item__container,
                        onClick: function(e) {
                            toggleSub(id);
                            e.stopPropagation();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "".concat((customHeader_module_default()).link__button, " ").concat(!!children.length && (customHeader_module_default()).only__link),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: url_key,
                                    prefetch: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        className: (customHeader_module_default()).menu__li__a
                                    }, target), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (customHeader_module_default())["name-icon__container"],
                                            children: [
                                                image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (customHeader_module_default()).icon_wrapper,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        width: 25,
                                                        height: 25,
                                                        alt: "menu icon",
                                                        src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(image)),
                                                        loading: "lazy"
                                                    })
                                                }) : null,
                                                name
                                            ]
                                        })
                                    }))
                                })
                            }),
                            arrow
                        ]
                    }),
                    submenu
                ]
            }, index);
        })
    });
};
/* harmony default export */ var CustomHeader_CustomItemList = (CustomItemList);

;// CONCATENATED MODULE: ./components/ForCWV/MenuRenderer.tsx










var MenuRenderer = function(param) {
    var topMenus = param.topMenus, domain = param.domain, dbName = param.dbName, font_family = param.font_family, menusRowWidth = param.menusRowWidth;
    var ref = (0,react.useState)(false), dropOpen = ref[0], setDropOpen = ref[1];
    var dropDownRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)([]), openMenus = ref1[0], setOpenMenus = ref1[1];
    var gap = 34;
    var menusWidth = 60;
    var isOverflow = false;
    var letterSizeObj = {
        "GT America Expanded": 12,
        "GT America Compressed": 6.5,
        "GT America Condensed": 8,
        "GT America Extended": 10,
        "GT America Mono": 9.5,
        "GT America Standard": 9
    };
    var letterSize = letterSizeObj[font_family] || 9; // average number of each letter
    var toggleSub = function(id) {
        if (openMenus.some(function(subId) {
            return subId === id;
        })) {
            setOpenMenus(function(prevState) {
                return prevState.filter(function(subId) {
                    return subId !== id;
                });
            });
        } else {
            setOpenMenus(function(prevState) {
                return (0,_to_consumable_array/* default */.Z)(prevState).concat([
                    id
                ]);
            });
        }
    };
    (0,react.useEffect)(function() {
        var handleClick = function(e) {
            if (dropDownRef.current && !dropDownRef.current.contains(e.target)) {
                setDropOpen(false);
            }
        };
        window.addEventListener("mousedown", handleClick);
        return function() {
            return window.removeEventListener("mousedown", handleClick);
        };
    }, [
        dropDownRef
    ]);
    var toggleDrop = function() {
        setDropOpen(function(prevState) {
            return !prevState;
        });
    };
    var renderMenus = function() {
        var visibleCollection = [];
        var dropdownCollection = [];
        topMenus.forEach(function(item, index) {
            var _name = item.name, name = _name === void 0 ? "" : _name, id = item.id, _children = item.children, children = _children === void 0 ? [] : _children, _url_key = item.url_key, url_key = _url_key === void 0 ? "" : _url_key, target = item.target;
            var existThisMenuId = openMenus.some(function(elem) {
                return elem === id;
            });
            var arrow = null;
            var menu = null;
            var menu2 = null;
            if (children.length) {
                arrow = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((customHeader_module_default()).wrapper__bttn, " ").concat(existThisMenuId && (customHeader_module_default()).closed),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown9x6Svg */.jN, {})
                });
                menu = /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHeader_CustomItemList, {
                    items: children,
                    openMenus: openMenus,
                    toggleSub: toggleSub,
                    dbName: dbName,
                    domain: domain
                });
                menu2 = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((customHeader_module_default()).deep__submenu, " ").concat(existThisMenuId && (customHeader_module_default()).opened__drop),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHeader_CustomItemList, {
                        items: children,
                        openMenus: openMenus,
                        toggleSub: toggleSub,
                        dbName: dbName,
                        domain: domain
                    })
                });
            }
            if (item && item.name) {
                var ref;
                var itemArrow = (((ref = item.children) === null || ref === void 0 ? void 0 : ref.length) ? 15 : 0) + (item.image ? 33 : 0);
                var itemWidth = item.name.length * letterSize + itemArrow + gap;
                var visibleItem = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (customHeader_module_default()).header_nav_menu_item,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: url_key,
                            prefetch: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, target), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (customHeader_module_default())["name-icon__container"],
                                        children: [
                                            item.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (customHeader_module_default()).icon_wrapper,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    width: 25,
                                                    height: 25,
                                                    alt: "menu icon",
                                                    src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(item.image))
                                                })
                                            }) : null,
                                            name
                                        ]
                                    }),
                                    arrow
                                ]
                            }))
                        }),
                        menu
                    ]
                }, index);
                var dropdownItem = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (customHeader_module_default()).header_nav_menu_item,
                    onClick: function() {
                        return toggleSub(id);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (customHeader_module_default()).menu_item__container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "".concat((customHeader_module_default()).link__button, " ").concat(menu && (customHeader_module_default()).only__link),
                                    onClick: function(e) {
                                        return e.stopPropagation();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: url_key,
                                        prefetch: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, target), {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (customHeader_module_default())["name-icon__container"],
                                                children: [
                                                    item.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (customHeader_module_default()).icon_wrapper,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            width: 25,
                                                            height: 25,
                                                            alt: "menu icon",
                                                            src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(item.image)),
                                                            loading: "lazy"
                                                        })
                                                    }) : null,
                                                    name
                                                ]
                                            })
                                        }))
                                    })
                                }),
                                arrow
                            ]
                        }),
                        menu2
                    ]
                }, index);
                if (isOverflow || menusWidth + itemWidth > menusRowWidth) {
                    isOverflow = true;
                    dropdownCollection.push(dropdownItem);
                } else {
                    menusWidth += itemWidth;
                    visibleCollection.push(visibleItem);
                }
            }
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                visibleCollection,
                !!dropdownCollection.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: dropDownRef,
                    className: (customHeader_module_default()).dropMenus__container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (customHeader_module_default()).wrapper__bttn,
                            onClick: toggleDrop,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DropMenusSVG */.Lk, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((customHeader_module_default()).dropMenus__body, " ").concat(dropOpen ? (customHeader_module_default()).opened__drop : null),
                            children: dropdownCollection
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((customHeader_module_default()).header, " ").concat((customHeader_module_default()).top_header, " ").concat((customHeader_module_default()).renderer_header),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (customHeader_module_default()).first_section,
            style: {
                height: "unset"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customHeader_module_default()).header_nav_menu,
                style: {
                    width: "max-content"
                },
                children: renderMenus()
            })
        })
    });
};
/* harmony default export */ var ForCWV_MenuRenderer = (MenuRenderer);

;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomTopBar.tsx











var CustomTopBar = function(param) {
    var telephone = param.telephone, dbName = param.dbName, _locales = param.locales, locales = _locales === void 0 ? [] : _locales, tmp = param.currencies, ref = (0,_to_array/* default */.Z)(tmp === void 0 ? [] : tmp), tmp1 = ref[0], ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1.code, selectedCurr = tmp2 === void 0 ? "" : tmp2, tmp3 = ref1.symbol, selectedSymbol = tmp3 === void 0 ? "" : tmp3, currencies = ref.slice(1), selectedLocaleImg = param.selectedLocaleImg, topMenus = param.topMenus, domain = param.domain, tmp4 = param.themeOptions, ref2 = tmp4 === void 0 ? {} : tmp4, _font_family = ref2.font_family, font_family = _font_family === void 0 ? "" : _font_family, selectedLocale = param.selectedLocale;
    var ref3, ref4;
    var currRef = (0,react.useRef)(null);
    var langRef = (0,react.useRef)(null);
    var leftBarRef = (0,react.useRef)(null);
    var containerRef = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(991), menusRowWidth = ref5[0], setMenusRowWidth = ref5[1];
    (0,react.useEffect)(function() {
        var ref, ref1;
        setMenusRowWidth(((ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.offsetWidth) - (leftBarRef === null || leftBarRef === void 0 ? void 0 : (ref1 = leftBarRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetWidth));
    }, [
        (ref3 = containerRef.current) === null || ref3 === void 0 ? void 0 : ref3.offsetWidth,
        leftBarRef === null || leftBarRef === void 0 ? void 0 : (ref4 = leftBarRef.current) === null || ref4 === void 0 ? void 0 : ref4.offsetWidth
    ]);
    (0,react.useEffect)(function() {
        var handleClick = function(e) {
            if (langRef && langRef.current && !langRef.current.contains(e.target)) {
                setOpenLang({
                    langOpened: false,
                    langClassName: ""
                });
            }
        };
        document.addEventListener("mousedown", handleClick);
        return function() {
            return document.removeEventListener("mousedown", handleClick);
        };
    }, [
        currRef,
        langRef
    ]);
    var ref6 = (0,react.useState)({
        langOpened: false,
        langClassName: ""
    }), ref7 = ref6[0], langOpened = ref7.langOpened, langClassName = ref7.langClassName, setOpenLang = ref6[1];
    var _ref = (0,next_router.useRouter)(), asPath = _ref.asPath, router = (0,_object_without_properties/* default */.Z)(_ref, [
        "asPath"
    ]);
    var handleClassTypes = {
        "false": [
            "",
            "menu-none"
        ],
        "true": [
            "rotT_fms",
            "menu-block"
        ]
    };
    var handleLangClick = function() {
        setOpenLang(function(param) {
            var prevOpen = param.langOpened;
            return {
                langOpened: !prevOpen,
                langClassName: handleClassTypes["".concat(!prevOpen)][0]
            };
        });
    };
    //TODO!!! comment this handleClick remove it after testing is done
    // const handleLangItemClick = (localeCode: string) => {
    //     router.push(asPath, asPath, {locale: localeCode}).then(r => r);
    // }
    var hasDropDown = {
        true: {
            arrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DropDownArrow */.s0, {
                className: (customTopBar_module_default())[langClassName]
            }),
            dropdown: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customTopBar_module_default())[handleClassTypes["".concat(langOpened)][1]],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (customTopBar_module_default()).menu,
                    children: locales === null || locales === void 0 ? void 0 : locales.map(function(param) {
                        var code = param.code, id = param.id, name = param.name, locale_image = param.locale_image;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: asPath,
                            locale: code,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: (customTopBar_module_default()).menu_item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (customTopBar_module_default()).menu__icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(locale_image)),
                                            alt: "Language",
                                            width: 23,
                                            height: 18,
                                            loading: "lazy"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (customTopBar_module_default()).menu__title,
                                        children: code
                                    })
                                ]
                            })
                        }, id);
                    })
                })
            })
        },
        false: {
            arrow: null,
            dropdown: null
        }
    };
    var handleCurrencyDropdown = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers_CustomCurrDropDown, {
            selectedCurr: selectedCurr,
            selectedSymbol: selectedSymbol,
            currencies: currencies
        }),
        false: null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (customTopBar_module_default())["top-bar"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (customTopBar_module_default())["top-bar-main"],
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        ref: leftBarRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "tel:".concat(telephone),
                            prefetch: true,
                            children: telephone
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: "10px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ForCWV_MenuRenderer, {
                                domain: domain,
                                dbName: dbName,
                                topMenus: topMenus,
                                font_family: font_family,
                                menusRowWidth: menusRowWidth
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (customTopBar_module_default()).topbar_buttons,
                                children: [
                                    handleCurrencyDropdown["".concat(!!currencies.length)],
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        id: "forLanguage",
                                        className: (customTopBar_module_default())["language-button"],
                                        onClick: handleLangClick,
                                        ref: langRef,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(selectedLocaleImg)),
                                                alt: "Language",
                                                width: 23,
                                                height: 18,
                                                loading: "lazy"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: selectedLocale
                                            }),
                                            hasDropDown["".concat(locales.length > 0)].arrow,
                                            hasDropDown["".concat(locales.length > 0)].dropdown
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Wrappers_CustomTopBar = (CustomTopBar);

// EXTERNAL MODULE: ./components/ForCWV/Wrappers/CustomFooter/customFooter.module.scss
var customFooter_module = __webpack_require__(77558);
var customFooter_module_default = /*#__PURE__*/__webpack_require__.n(customFooter_module);
;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomFooter/CustomToTop.tsx




var CustomToTop = function() {
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var showFrom = 300;
    var classNameToggle = {
        "true": "toTop--show",
        "false": ""
    };
    var onClick = function() {
        try {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        } catch (e) {
            window.scrollTo(0, 0);
        }
    };
    (0,react.useEffect)(function() {
        var state = false;
        var onScroll = function() {
            var newState = window.pageYOffset >= showFrom;
            if (state !== newState) {
                setShow(state = newState);
            }
        };
        window.addEventListener("scroll", onScroll, {
            passive: true
        });
        return function() {
            return window.removeEventListener("scroll", onScroll, {
                passive: true
            });
        };
    }, [
        setShow
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((customFooter_module_default()).toTop, " ").concat((customFooter_module_default())[classNameToggle["".concat(show)]]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (customFooter_module_default()).toTop__body,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customFooter_module_default()).toTop__end,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: (customFooter_module_default()).toTop__button,
                    onClick: onClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedUp13x8Svg */.aO, {})
                })
            })
        })
    });
};
/* harmony default export */ var CustomFooter_CustomToTop = (CustomToTop);

// EXTERNAL MODULE: ./api/shop.ts + 1 modules
var shop = __webpack_require__(65564);
;// CONCATENATED MODULE: ./hooks/useSubscription.ts


var useSubscription = function() {
    var ref = (0,react.useState)(""), message = ref[0], setMessage = ref[1];
    var ref1 = (0,react.useState)(""), messageClass = ref1[0], setMessageClass = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var subscribe = function(email) {
        if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            setLoading(true);
            shop["default"].setSubscription(email).then(function(data) {
                if (data.success) {
                    setMessage(data.success);
                    setMessageClass("text-success");
                } else {
                    setMessage(data.success);
                    setMessageClass("text-danger");
                }
            }).catch(function(error) {
                console.error(error, "error");
                setMessage("An error occurred");
                setMessageClass("text-danger");
            }).finally(function() {
                setLoading(false);
            });
        } else {
            setMessage("Invalid Email Format");
            setMessageClass("text-danger");
        }
    };
    return {
        message: message,
        messageClass: messageClass,
        loading: loading,
        subscribe: subscribe
    };
};
/* harmony default export */ var hooks_useSubscription = (useSubscription);

// EXTERNAL MODULE: ./services/utils.js
var utils = __webpack_require__(75681);
// EXTERNAL MODULE: ./components/builder/BuilderDataRender.tsx + 30 modules
var BuilderDataRender = __webpack_require__(30068);
// EXTERNAL MODULE: ./atoms/CWV/custom_fields.module.scss
var custom_fields_module = __webpack_require__(87755);
var custom_fields_module_default = /*#__PURE__*/__webpack_require__.n(custom_fields_module);
;// CONCATENATED MODULE: ./atoms/CWV/CustomTextField.tsx



var CustomTextField = function(props) {
    var _className = props.className, className = _className === void 0 ? "" : _className, _id = props.id, id = _id === void 0 ? "" : _id, _type = props.type, type = _type === void 0 ? "" : _type, _placeholder = props.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _autoComplete = props.autoComplete, autoComplete = _autoComplete === void 0 ? "" : _autoComplete, value = props.value, onChange = props.onChange, _name = props.name, name = _name === void 0 ? "" : _name, _disabled = props.disabled, disabled = _disabled === void 0 ? false : _disabled, _required = props.required, required = _required === void 0 ? false : _required, _err = props.err, err = _err === void 0 ? false : _err;
    var inputClasses = {
        true: "".concat((custom_fields_module_default()).custom_input_field, " ").concat((custom_fields_module_default()).err_field),
        false: (custom_fields_module_default()).custom_input_field
    };
    var isRequire = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (custom_fields_module_default())["red-fms"],
            children: " *"
        }),
        false: null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((custom_fields_module_default()).custom_input_checkout, " ").concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: inputClasses["".concat(err)],
                id: id,
                type: type,
                name: name,
                placeholder: " ",
                autoComplete: autoComplete,
                value: value,
                onChange: onChange,
                disabled: disabled,
                required: required
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                className: (custom_fields_module_default()).custom_input_label,
                htmlFor: id,
                children: [
                    placeholder,
                    isRequire["".concat(required)]
                ]
            })
        ]
    });
};
/* harmony default export */ var CWV_CustomTextField = (CustomTextField);

;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomFooter/CustomSubscriptionForm.tsx






var SubscriptionForm = function(param) {
    var translationsData = param.translationsData, showSubscriptionStyle = param.showSubscriptionStyle;
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = hooks_useSubscription(), _message = ref1.message, message = _message === void 0 ? "" : _message, _messageClass = ref1.messageClass, messageClass = _messageClass === void 0 ? "" : _messageClass, subscribe = ref1.subscribe;
    var handleChange = function(e) {
        setEmail(e.target.value);
    };
    var handleClick = function(e) {
        e.preventDefault();
        subscribe(email);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (customFooter_module_default())["newsletter-block"],
        style: {
            display: showSubscriptionStyle
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (customFooter_module_default())["footer-newsletter-container"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: (customFooter_module_default())["footer-newsletter__title"],
                    children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.Subscribe
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                    className: (customFooter_module_default())["footer-newsletter__form"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CWV_CustomTextField, {
                            className: (customFooter_module_default()).custom_input_field,
                            id: "footer_news_email__id",
                            type: "email",
                            name: "email",
                            autoComplete: "off",
                            value: email,
                            onChange: handleChange,
                            placeholder: translationsData === null || translationsData === void 0 ? void 0 : translationsData.Email
                        }),
                        !!message && /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                            id: "passwordHelp",
                            className: messageClass,
                            children: translationsData === null || translationsData === void 0 ? void 0 : translationsData[(0,utils/* generateTranslateKey */.h_)(message)]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "btn-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: handleClick,
                                type: "submit",
                                className: "".concat((customFooter_module_default())["footer-newsletter__form-button"], " btn"),
                                children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.SubscribeButton
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CustomSubscriptionForm = (SubscriptionForm);

;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomFooter/index.tsx













var CustomFooter = function(param) {
    var footerCopyRightValue = param.footerCopyRightValue, footerPoweredValue = param.footerPoweredValue, showSubscriptionStyle = param.showSubscriptionStyle, arrFooterTrack = param.arrFooterTrack, footerMenus = param.footerMenus, showFooterEmailStyle = param.showFooterEmailStyle, showFooterPhoneStyle = param.showFooterPhoneStyle, footerEmailValue = param.footerEmailValue, telephone = param.telephone, showFooterAddressStyle = param.showFooterAddressStyle, footerAddressValue = param.footerAddressValue, dbName = param.dbName, socialsFooter = param.socialsFooter, translationsData = param.translationsData, logoPath = param.logoPath, cacheControlVersion = param.cacheControlVersion, showFooterMenuCls = param.showFooterMenuCls, showFooterContactCls = param.showFooterContactCls, isMobile = param.isMobile, themeOptions = param.themeOptions, selectedLocale = param.selectedLocale, domain = param.domain, getBuilderData = param.getBuilderData, currencies = param.currencies, backOrderValue = param.backOrderValue, recaptchaActive = param.recaptchaActive;
    var ref = (0,react.useState)(""), email = ref[0], SetEmail = ref[1];
    var ref1 = hooks_useSubscription(), _message = ref1.message, message = _message === void 0 ? "" : _message, _messageClass = ref1.messageClass, messageClass = _messageClass === void 0 ? "" : _messageClass, subscribe = ref1.subscribe;
    var handleChange = function(event) {
        SetEmail(event.target.value);
    };
    var handlerClick = function(event) {
        event.preventDefault();
        subscribe(email);
    };
    var smallPassHelpHandle = {
        "true": /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
            id: "passwordHelp",
            className: messageClass,
            children: translationsData === null || translationsData === void 0 ? void 0 : translationsData[(0,utils/* generateTranslateKey */.h_)(message)]
        }),
        "false": null
    };
    var showFooterText = {
        "true": /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (customFooter_module_default()).copyright,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: footerCopyRightValue
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: footerPoweredValue
                    }
                })
            ]
        }),
        "false": null
    };
    var FooterContentHandle = function() {
        //show footer from static store
        if (typeof (themeOptions === null || themeOptions === void 0 ? void 0 : themeOptions.show_footer) !== "boolean" || (themeOptions === null || themeOptions === void 0 ? void 0 : themeOptions.show_footer) || isMobile) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((customFooter_module_default())["footer-container"], " container"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customFooter_module_default())["footer-body"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (customFooter_module_default())["footer-main-info"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (customFooter_module_default()).footer_logo,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/",
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(logoPath, "?v=").concat(cacheControlVersion)),
                                                            alt: "Logo",
                                                            // loading="eager"
                                                            loading: "lazy",
                                                            width: "200",
                                                            height: "45"
                                                        })
                                                    })
                                                })
                                            }),
                                            translationsData.FooterText !== "empty" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (customFooter_module_default()).footer_text,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: translationsData.FooterText
                                                })
                                            }) : null
                                        ]
                                    }),
                                    arrFooterTrack === null || arrFooterTrack === void 0 ? void 0 : arrFooterTrack.map(function(param, index) {
                                        var href = param.href, id = param.id;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (customFooter_module_default())["trackingNumber-fms"],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: href,
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: id
                                                })
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((customFooter_module_default())["footer-first-column"], " ").concat((customFooter_module_default())[showFooterMenuCls]),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (customFooter_module_default())["footer-newsletter__title"],
                                        children: translationsData.FooterMenu
                                    }),
                                    footerMenus === null || footerMenus === void 0 ? void 0 : footerMenus.map(function(param, index) {
                                        var _url_key = param.url_key, url_key = _url_key === void 0 ? "" : _url_key, menuName = param.name, target = param.target;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (customFooter_module_default())["footerLinks-fms"],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: url_key,
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, target), {
                                                    children: menuName
                                                }))
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((customFooter_module_default())["footer-newsletter-hide"], " ").concat((customFooter_module_default())[showFooterContactCls]),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: (customFooter_module_default())["footer-newsletter__title"],
                                        children: translationsData.FooterContacts
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((customFooter_module_default())["footer-newsletter__social-links"], " ").concat((customFooter_module_default())["footer-contacts"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: (customFooter_module_default())["footer-contacts__contacts"],
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: (customFooter_module_default()).contactsAddress_list,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (customFooter_module_default()).contactsAddress,
                                                        style: {
                                                            display: showFooterEmailStyle
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "mailto:".concat(footerEmailValue),
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: footerEmailValue
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (customFooter_module_default()).contactsAddress,
                                                        style: {
                                                            display: showFooterPhoneStyle
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "tel:".concat(telephone),
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: telephone
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (customFooter_module_default()).contactsAddress,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            style: {
                                                                display: showFooterAddressStyle
                                                            },
                                                            children: footerAddressValue
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat((customFooter_module_default())["footer-newsletter__social-links"], " ").concat((customFooter_module_default())["social-links"], " ").concat((customFooter_module_default())["social-links--shape--circle"]),
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                className: (customFooter_module_default())["social-links__list"],
                                                                children: socialsFooter === null || socialsFooter === void 0 ? void 0 : socialsFooter.map(function(param, index) {
                                                                    var socialName = param.name, socialIcon = param.icon, socialLink = param.link;
                                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        className: (customFooter_module_default())["social-links__item"],
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            className: "".concat((customFooter_module_default())["social-links__link"], " ").concat((customFooter_module_default())["social-link-color"]),
                                                                            href: socialLink,
                                                                            prefetch: false,
                                                                            style: {
                                                                                position: "relative",
                                                                                width: "100%",
                                                                                height: "100%"
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                target: "_blank",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                    src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(socialIcon)),
                                                                                    alt: socialName,
                                                                                    loading: "lazy",
                                                                                    width: "30",
                                                                                    height: "30"
                                                                                })
                                                                            })
                                                                        })
                                                                    }, index);
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (customFooter_module_default())["newsletter-block"],
                                style: {
                                    display: showSubscriptionStyle
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSubscriptionForm, {
                                    translationsData: translationsData,
                                    showSubscriptionStyle: showSubscriptionStyle
                                })
                            })
                        ]
                    }),
                    showFooterText["".concat(!!footerCopyRightValue || !!footerPoweredValue)]
                ]
            });
        } else {
            var _currencies = (0,_sliced_to_array/* default */.Z)(currencies, 1), tmp = _currencies[0], ref = tmp === void 0 ? {} : tmp, tmp1 = ref.code, selectedCurrCode = tmp1 === void 0 ? "" : tmp1, tmp2 = ref.symbol, selectedCurrSymbol = tmp2 === void 0 ? "" : tmp2, tmp3 = ref.exchange_rate, ref1 = tmp3 === void 0 ? {} : tmp3, tmp4 = ref1.rate, selectedCurrRate = tmp4 === void 0 ? "1" : tmp4;
            var builderProps = {
                getBuilderData: getBuilderData,
                domain: domain,
                dbName: dbName,
                translationsData: translationsData,
                selectedLocale: selectedLocale,
                currencies: currencies,
                backOrderValue: backOrderValue,
                selectedCurrItems: {
                    selectedCurrCode: selectedCurrCode,
                    selectedCurrRate: selectedCurrRate,
                    selectedCurrSymbol: selectedCurrSymbol
                },
                isMobile: isMobile,
                recaptchaActive: recaptchaActive
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderDataRender/* default */.Z, (0,_object_spread/* default */.Z)({
                tab: 5
            }, builderProps));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (customFooter_module_default())["site-footer"],
        style: (themeOptions === null || themeOptions === void 0 ? void 0 : themeOptions.show_footer) === false && !isMobile ? {
            padding: "unset"
        } : {},
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterContentHandle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFooter_CustomToTop, {})
        ]
    });
};
/* harmony default export */ var Wrappers_CustomFooter = (CustomFooter);

// EXTERNAL MODULE: ./node_modules/react-cookie-consent/build/index.js
var build = __webpack_require__(92491);
var build_default = /*#__PURE__*/__webpack_require__.n(build);
;// CONCATENATED MODULE: ./components/AcceptCookies.tsx




var AcceptCookies = function(param) {
    var translationsData = param.translationsData, gdprTitle = param.gdprTitle, gdprContent = param.gdprContent;
    var ariaAcceptLabel = translationsData.AcceptCookie;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((build_default()), {
        location: "bottom",
        buttonText: translationsData.AcceptCookie,
        visible: "byCookieValue",
        buttonClasses: "cookie_button",
        buttonWrapperClasses: "cookie_button_wrapper",
        expires: 30,
        containerClasses: "cookie_body",
        contentClasses: "cookie_content",
        ariaAcceptLabel: ariaAcceptLabel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cookie_body_elements",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cookie_image",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CookieSVG */.QP, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: gdprTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: gdprContent
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_AcceptCookies = (AcceptCookies);

// EXTERNAL MODULE: ./store/token/index.js + 3 modules
var token = __webpack_require__(46607);
// EXTERNAL MODULE: ./node_modules/jwt-decode/build/jwt-decode.esm.js
var jwt_decode_esm = __webpack_require__(96245);
// EXTERNAL MODULE: ./store/customer/index.js + 3 modules
var store_customer = __webpack_require__(97331);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/FirstSection.tsx














var showPost = function(title) {
    return {
        BlogActive: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (customHeader_module_default()).header_nav_menu_item,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/posts",
                prefetch: true,
                children: title
            })
        }),
        BlogInActive: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    };
};
var schemaSiteHeader = function(dbName, asPath) {
    return {
        "@context": "https://schema.org/",
        "@type": "ItemList",
        "name": "Header Items",
        "description": "contact, change currency and language",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "Telephone"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "name": "Currency"
            },
            {
                "@type": "ListItem",
                "position": 3,
                "name": "Language"
            }, 
        ],
        url: (0,helper/* domainUrl */.HJ)(dbName + asPath)
    };
};
var FirstSection = function(param) {
    var categories = param.categories, logoPath = param.logoPath, dbName = param.dbName, menus = param.menus, hasBlog = param.hasBlog, selectedLocaleImg = param.selectedLocaleImg, translationsData = param.translationsData, _locales = param.locales, locales = _locales === void 0 ? [] : _locales, cacheControlVersion = param.cacheControlVersion, tmp = param.themeOptions, ref = tmp === void 0 ? {} : tmp, _font_family = ref.font_family, font_family = _font_family === void 0 ? "" : _font_family, domain = param.domain;
    var ref1, ref2;
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath;
    var schemaHeader = schemaSiteHeader(dbName, asPath);
    var ref3 = (0,react.useState)({
        langOpened: false,
        langClassName: ""
    }), langOpened = ref3[0].langOpened, setOpenLang = ref3[1];
    var ref4 = (0,react.useState)(false), hydrated = ref4[0], setHydrated = ref4[1];
    (0,react.useEffect)(function() {
        return setHydrated(true);
    }, []);
    var mobileMenu = (0,es/* useSelector */.v9)(function(state) {
        return state.mobileMenu.open;
    });
    var langRef = (0,react.useRef)(null);
    var dropDownRef = (0,react.useRef)(null);
    var containerRef = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(containerRef), width = ref5[0], setWidth = ref5[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref6 = (0,react.useState)(false), dropOpen = ref6[0], setDropOpen = ref6[1];
    var ref7 = (0,react.useState)([]), openMenus = ref7[0], setOpenMenus = ref7[1];
    var ref8 = (0,react.useState)(991), menusRowWidth = ref8[0], setMenusRowWidth = ref8[1];
    var gap = 42;
    var isOverflow = false;
    var letterSizeObj = {
        "GT America Expanded": 12,
        "GT America Compressed": 6.5,
        "GT America Condensed": 8,
        "GT America Extended": 10,
        "GT America Mono": 9.5,
        "GT America Standard": 9
    };
    var letterSize = letterSizeObj[font_family] || 9; // average number of each letter
    var activeBlog = hasBlog === "BlogActive";
    var menusWidth = activeBlog ? (translationsData === null || translationsData === void 0 ? void 0 : translationsData.Posts.length) * letterSize + 60 : 60;
    var handleClassTypes = {
        "false": [
            "",
            "menu-none"
        ],
        "true": [
            "rotT_fms",
            "menu-block"
        ]
    };
    (0,react.useEffect)(function() {
        var ref;
        setMenusRowWidth((ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.offsetWidth);
    }, [
        (ref1 = containerRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetWidth
    ]);
    (0,react.useEffect)(function() {
        var handleClick = function(e) {
            if (langRef && langRef.current && !langRef.current.contains(e.target)) {
                setOpenLang({
                    langOpened: false,
                    langClassName: ""
                });
            }
            if (dropDownRef.current && !dropDownRef.current.contains(e.target)) {
                setDropOpen(false);
            }
        };
        window.addEventListener("mousedown", handleClick);
        return function() {
            return window.removeEventListener("mousedown", handleClick);
        };
    }, [
        langRef,
        dropDownRef
    ]);
    (0,react.useEffect)(function() {
        var handleResize = function() {
            setWidth(containerRef.current.clientWidth);
        };
        window.addEventListener("resize", handleResize);
        return function() {
            return window.removeEventListener("resize", handleResize);
        };
    }, [
        menus,
        width
    ]);
    var handleLangClick = function() {
        setOpenLang(function(param) {
            var prevOpen = param.langOpened;
            return {
                langOpened: !prevOpen,
                langClassName: handleClassTypes["".concat(!prevOpen)][0]
            };
        });
    };
    var toggleDrop = function() {
        setDropOpen(function(prevState) {
            return !prevState;
        });
    };
    var toggleSub = function(id) {
        if (openMenus.some(function(subId) {
            return subId === id;
        })) {
            setOpenMenus(function(prevState) {
                return prevState.filter(function(subId) {
                    return subId !== id;
                });
            });
        } else {
            setOpenMenus(function(prevState) {
                return (0,_to_consumable_array/* default */.Z)(prevState).concat([
                    id
                ]);
            });
        }
    };
    var mobileMenuIcon = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* VektorMenu */.OW, {
            className: (customHeader_module_default()).menu_icon
        }),
        false: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* Cross20Svg */.He, {})
    };
    var handleLangItemClick = function(localeCode) {
        router.push(asPath, asPath, {
            locale: localeCode
        }).then(function(r) {
            return r;
        });
    };
    var hasDropDown = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (customHeader_module_default())[handleClassTypes["".concat(langOpened)][1]],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customHeader_module_default()).menu,
                children: locales === null || locales === void 0 ? void 0 : locales.map(function(param) {
                    var code = param.code, id = param.id, locale_image = param.locale_image;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (customHeader_module_default()).menu_item,
                        onClick: function() {
                            return handleLangItemClick(code);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (customHeader_module_default()).menu__icon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(locale_image)),
                                alt: "Language",
                                width: "30",
                                height: "24",
                                loading: "lazy"
                            })
                        })
                    }, id);
                })
            })
        }),
        false: null
    };
    var renderMenus = function() {
        var visibleCollection = [];
        var dropdownCollection = [];
        menus.forEach(function(item, index) {
            var _name = item.name, name = _name === void 0 ? "" : _name, id = item.id, _children = item.children, children = _children === void 0 ? [] : _children, _url_key = item.url_key, url_key = _url_key === void 0 ? "" : _url_key, target = item.target;
            var existThisMenuId = openMenus.some(function(elem) {
                return elem === id;
            });
            var arrow = null;
            var menu = null;
            var menu2 = null;
            if (children.length) {
                arrow = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((customHeader_module_default()).wrapper__bttn, " ").concat(existThisMenuId && (customHeader_module_default()).closed),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown9x6Svg */.jN, {})
                });
                menu = /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHeader_CustomItemList, {
                    items: children,
                    openMenus: openMenus,
                    toggleSub: toggleSub,
                    dbName: dbName,
                    domain: domain
                });
                menu2 = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((customHeader_module_default()).deep__submenu, " ").concat(existThisMenuId && (customHeader_module_default()).opened__drop),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHeader_CustomItemList, {
                        items: children,
                        openMenus: openMenus,
                        toggleSub: toggleSub,
                        dbName: dbName,
                        domain: domain
                    })
                });
            }
            if (item && item.name) {
                var ref;
                var itemArrow = (((ref = item.children) === null || ref === void 0 ? void 0 : ref.length) ? 15 : 0) + (item.image ? 33 : 0);
                var itemWidth = item.name.length * letterSize + itemArrow + gap;
                var visibleItem = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (customHeader_module_default()).header_nav_menu_item,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: url_key,
                            prefetch: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, target), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (customHeader_module_default())["name-icon__container"],
                                        children: [
                                            item.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (customHeader_module_default()).icon_wrapper,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    width: 25,
                                                    height: 25,
                                                    alt: "menu icon",
                                                    src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(item.image))
                                                })
                                            }) : null,
                                            name
                                        ]
                                    }),
                                    arrow
                                ]
                            }))
                        }),
                        menu
                    ]
                }, index);
                var dropdownItem = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (customHeader_module_default()).header_nav_menu_item,
                    onClick: function() {
                        return toggleSub(id);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (customHeader_module_default()).menu_item__container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "".concat((customHeader_module_default()).link__button, " ").concat(menu && (customHeader_module_default()).only__link),
                                    onClick: function(e) {
                                        return e.stopPropagation();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: url_key,
                                        prefetch: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, target), {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (customHeader_module_default())["name-icon__container"],
                                                children: [
                                                    item.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (customHeader_module_default()).icon_wrapper,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            width: 25,
                                                            height: 25,
                                                            alt: "menu icon",
                                                            src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(item.image)),
                                                            loading: "lazy"
                                                        })
                                                    }) : null,
                                                    name
                                                ]
                                            })
                                        }))
                                    })
                                }),
                                arrow
                            ]
                        }),
                        menu2
                    ]
                }, index);
                if (isOverflow || menusWidth + itemWidth > menusRowWidth) {
                    isOverflow = true;
                    dropdownCollection.push(dropdownItem);
                } else {
                    menusWidth += itemWidth;
                    visibleCollection.push(visibleItem);
                }
            }
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                visibleCollection,
                showPost(translationsData === null || translationsData === void 0 ? void 0 : translationsData.Posts)[hasBlog],
                !!dropdownCollection.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: dropDownRef,
                    className: (customHeader_module_default()).dropMenus__container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (customHeader_module_default()).wrapper__bttn,
                            onClick: toggleDrop,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* DropMenusSVG */.Lk, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((customHeader_module_default()).dropMenus__body, " ").concat(dropOpen ? (customHeader_module_default()).opened__drop : null),
                            children: dropdownCollection
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: schemaHeader.name,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaHeader)
                },
                defer: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (customHeader_module_default()).first_section,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: (customHeader_module_default())["mobile-header__menu-button"],
                            onClick: function() {
                                return dispatch((0,mobile_menu/* mobileMenuOpen */.pk)());
                            },
                            "aria-label": "MobileHeaderBtn",
                            children: hydrated ? mobileMenuIcon["".concat(!mobileMenu)] : /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* VektorMenu */.OW, {
                                className: (customHeader_module_default()).menu_icon
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (customHeader_module_default()).logo_div,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                prefetch: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(logoPath, "?v=").concat(cacheControlVersion)),
                                        alt: "Logo",
                                        // loading="eager"
                                        loading: "lazy",
                                        width: "200",
                                        height: "45"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "forLanguage",
                            className: (customHeader_module_default())["language-button"],
                            onClick: handleLangClick,
                            ref: langRef,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(selectedLocaleImg)),
                                    alt: "Language",
                                    // loading="eager"
                                    loading: "lazy",
                                    width: "30",
                                    height: "24"
                                }),
                                hasDropDown["".concat(locales.length > 0)]
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (customHeader_module_default())["nav-panel__departments"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: (customHeader_module_default())["mobile-header__menu-button"],
                                onClick: function() {
                                    return dispatch((0,mobile_menu/* mobileMenuOpen */.pk)());
                                },
                                "aria-label": "MobileHeaderBtn",
                                children: [
                                    mobileMenuIcon["".concat(!mobileMenu)],
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (customHeader_module_default())["category-title-fms"],
                                        children: categories === null || categories === void 0 ? void 0 : (ref2 = categories[0]) === null || ref2 === void 0 ? void 0 : ref2.name
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (customHeader_module_default()).header_nav_menu,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: containerRef,
                                className: (customHeader_module_default()).header_nav_menu,
                                children: renderMenus()
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var CustomHeader_FirstSection = (FirstSection);

// EXTERNAL MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomSearch/customSearch.module.scss
var customSearch_module = __webpack_require__(66557);
var customSearch_module_default = /*#__PURE__*/__webpack_require__.n(customSearch_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomSearch/CustomSuggestions.tsx






var CustomSuggestions = function(param) {
    var products = param.products, selectedRate = param.selectedRate, dbName = param.dbName, translationsData = param.translationsData, close = param.close;
    var ListJsx = function(param) {
        var product = param.product;
        var ref, ref1;
        var positionSymbolHandle = function() {
            var ref, ref1;
            var ref2;
            var finalPrice = (ref2 = (ref = product.flats[0]) === null || ref === void 0 ? void 0 : ref.special_price) !== null && ref2 !== void 0 ? ref2 : (ref1 = product.flats[0]) === null || ref1 === void 0 ? void 0 : ref1.price;
            if ((selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.code) === "AMD") {
                return finalPrice + " " + (selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.symbol);
            }
            return (selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.symbol) + " " + finalPrice;
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            className: (customSearch_module_default())["suggestions__item-name"],
            href: "/".concat(product.flats[0].url_key),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: (customSearch_module_default()).suggestions__item,
                onClick: function() {
                    return close();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((customSearch_module_default())["suggestions__item-image"], " ").concat((customSearch_module_default())["product-image"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((customSearch_module_default())["search-product-image__body-fms"]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/".concat(product.flats[0].url_key),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(product === null || product === void 0 ? void 0 : product.images[0])),
                                        alt: (ref = product === null || product === void 0 ? void 0 : product.flats[0]) === null || ref === void 0 ? void 0 : ref.name,
                                        width: 50,
                                        height: 50,
                                        priority: true
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customSearch_module_default())["suggestions__item-info"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                children: [
                                    " ",
                                    (ref1 = product === null || product === void 0 ? void 0 : product.flats[0]) === null || ref1 === void 0 ? void 0 : ref1.name
                                ]
                            }),
                            !(product === null || product === void 0 ? void 0 : product.notProduct) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (customSearch_module_default())["suggestions__item-meta"],
                                children: "SKU: ".concat(product === null || product === void 0 ? void 0 : product.sku)
                            })
                        ]
                    }),
                    !(product === null || product === void 0 ? void 0 : product.notProduct) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (customSearch_module_default())["suggestions__item-price"],
                        children: positionSymbolHandle()
                    })
                ]
            })
        }, product.id);
    };
    var ProductsExist = function() {
        if (!products.length) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customSearch_module_default()).search__fm_dr_Message,
                children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.NoMatchingItems
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: products.map(function(product) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListJsx, {
                    product: product
                }, product.id);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((customSearch_module_default()).suggestions, " ").concat((customSearch_module_default())["suggestions--location--header"], " ").concat((customSearch_module_default()).search__suggestions),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: (customSearch_module_default()).suggestions__list,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductsExist, {})
        })
    });
};
/* harmony default export */ var CustomSearch_CustomSuggestions = (CustomSuggestions);

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomSearch/SearchComponent.tsx








var SearchComponent = function(param) {
    var setQuery = param.setQuery, wrapper = param.wrapper, handleFocus = param.handleFocus, handleKeyDown = param.handleKeyDown, suggestedProducts = param.suggestedProducts, handleSearchButt = param.handleSearchButt, handleChangeQuery = param.handleChangeQuery, handleChangeQueryReq = param.handleChangeQueryReq, close = param.close, translationsData = param.translationsData;
    var ref = (0,next_router.useRouter)(), location = ref.asPath, tmp = ref.query, ref1 = tmp === void 0 ? {} : tmp, tmp1 = ref1.search, querySearch = tmp1 === void 0 ? "" : tmp1;
    (0,react.useEffect)(function() {
        var search = query_string.parse(window.location.search).search;
        var hasSearch = {
            "true": function() {
                return setQuery(search);
            },
            "false": function() {}
        };
        hasSearch["".concat(!!search)]();
    }, [
        location
    ]);
    (0,react.useEffect)(function() {
        var onGlobalClick = function(event) {
            if (wrapper.current && !wrapper.current.contains(event.target)) {
                close();
            }
        };
        document.addEventListener("mousedown", onGlobalClick);
        return function() {
            return document.removeEventListener("mousedown", onGlobalClick);
        };
    }, [
        close
    ]);
    var handleClick = function() {
        return {
            "true": /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                handleSearchButt()
                            ];
                        case 1:
                            _state.sent();
                            setQuery("");
                            return [
                                2
                            ];
                    }
                });
            }),
            "false": function() {}
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (customSearch_module_default()).search__form,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                // onBlur={handleChangeQuery}
                onChange: function(event) {
                    handleChangeQuery(event);
                    handleChangeQueryReq(event);
                },
                onFocus: handleFocus,
                onKeyDown: handleKeyDown,
                value: query_string.parse(querySearch).search,
                className: (customSearch_module_default()).search__input,
                name: "search",
                placeholder: translationsData === null || translationsData === void 0 ? void 0 : translationsData.SearchLookingFor,
                "aria-label": "Site search",
                type: "text",
                autoComplete: "off"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "".concat((customSearch_module_default()).search__button, " ").concat((customSearch_module_default())["search__button--type--close"]),
                type: "button",
                onClick: close,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* Cross20Svg */.He, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "".concat((customSearch_module_default()).search__button, " ").concat((customSearch_module_default())["search__button--type--submit"]),
                "aria-label": "CustomSearch",
                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var event;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                event = {
                                    key: "Enter",
                                    preventDefault: function() {}
                                };
                                return [
                                    4,
                                    handleKeyDown(event)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* SearchssSvg */.n8, {})
            })
        ]
    });
};
/* harmony default export */ var CustomSearch_SearchComponent = (SearchComponent);

// EXTERNAL MODULE: ./hooks/useDebounce.js
var useDebounce = __webpack_require__(1601);
;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomSearch/index.tsx











var CustomSearch = function(param) {
    var selectedLocale = param.selectedLocale, backOrderValue = param.backOrderValue, dbName = param.dbName, selectedRate = param.selectedRate, translationsData = param.translationsData, domain = param.domain, searchShowDetails = param.searchShowDetails, defaultLangCode = param.defaultLangCode, metas = param.metas;
    var history = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), query = ref[0], setQuery = ref[1];
    var ref1 = (0,react.useState)(false), suggestionsOpen = ref1[0], setSuggestionsOpen = ref1[1];
    var ref2 = (0,react.useState)(false), hasSuggestions = ref2[0], setHasSuggestions = ref2[1];
    var ref3 = (0,react.useState)([]), suggestedProducts = ref3[0], setSuggestedProducts = ref3[1];
    var wrapper = (0,react.useRef)(null);
    var submitNotAvailable = !(suggestedProducts === null || suggestedProducts === void 0 ? void 0 : suggestedProducts.length) || (suggestedProducts === null || suggestedProducts === void 0 ? void 0 : suggestedProducts.some(function(pr) {
        return pr === null || pr === void 0 ? void 0 : pr.notProduct;
    }));
    var dispatch = (0,es/* useDispatch */.I0)();
    var close = function() {
        dispatch((0,mobile_menu/* mobileSearchClose */.Tc)());
        setSuggestionsOpen(false);
    };
    var handleFocus = function() {
        setSuggestionsOpen(true);
    };
    var handleChangeQuery = function(param) {
        var value = param.target.value;
        setQuery(value);
    };
    var handleChangeQueryReq = (0,useDebounce/* default */.Z)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var value, ref, shopApi;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        value = param.target.value;
                        if (!(value.length >= 2)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 65564))
                        ];
                    case 1:
                        ref = _state.sent(), shopApi = ref.default;
                        shopApi.getSearchProducts(value, selectedLocale, defaultLangCode, selectedRate, domain, searchShowDetails, translationsData === null || translationsData === void 0 ? void 0 : translationsData.Home, metas === null || metas === void 0 ? void 0 : metas.share_pic, backOrderValue, true).then(function(response) {
                            setHasSuggestions(true);
                            setSuggestionsOpen(true);
                            setSuggestedProducts(response);
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setSuggestedProducts([]);
                        setHasSuggestions(false);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), 400);
    var handleBlur = function() {
        setTimeout(function() {
            if (!document.activeElement || document.activeElement === document.body) {
                return;
            }
            if (wrapper.current && !wrapper.current.contains(document.activeElement)) {
                close();
            }
        }, 10);
    };
    var handleKeyDown = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (submitNotAvailable) return [
                            2
                        ];
                        if (event.key === "Escape" || event.key === "Enter") {
                            close();
                        }
                        if (!(event.key === "Enter" && query.length > 0)) return [
                            3,
                            2
                        ];
                        event.preventDefault();
                        return [
                            4,
                            history.push({
                                pathname: "/catalog/search/".concat(query)
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleKeyDown(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSearchButt = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (submitNotAvailable) return [
                            2
                        ];
                        if (!(query.length > 0)) return [
                            3,
                            2
                        ];
                        close();
                        return [
                            4,
                            history.push({
                                pathname: "/catalog/search/" + query
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSearchButt() {
            return _ref.apply(this, arguments);
        };
    }();
    var classSuggestionsOpen = {
        "true": (customSearch_module_default())["search--suggestions-open"],
        "false": ""
    };
    var classHasSuggestions = {
        "true": (customSearch_module_default())["search--has-suggestions"],
        "false": ""
    };
    var concatClasses = "\n        ".concat((customSearch_module_default()).search, "\n        ").concat((customSearch_module_default())["search--location--header"], "\n        ").concat(classSuggestionsOpen["".concat(suggestionsOpen)], "\n        ").concat(classHasSuggestions["".concat(hasSuggestions)], "\n    ");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: concatClasses,
        ref: wrapper,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (customSearch_module_default()).search__body,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSearch_SearchComponent, {
                    setQuery: setQuery,
                    wrapper: wrapper,
                    handleFocus: handleFocus,
                    handleKeyDown: handleKeyDown,
                    suggestedProducts: suggestedProducts,
                    handleSearchButt: handleSearchButt,
                    handleChangeQuery: handleChangeQuery,
                    handleChangeQueryReq: handleChangeQueryReq,
                    close: close,
                    translationsData: translationsData
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSearch_CustomSuggestions, {
                    products: suggestedProducts,
                    dbName: dbName,
                    selectedRate: selectedRate,
                    translationsData: translationsData,
                    close: close
                })
            ]
        })
    });
};
/* harmony default export */ var CustomHeader_CustomSearch = (CustomSearch);

// EXTERNAL MODULE: ./store/cart/index.ts + 2 modules
var cart = __webpack_require__(7597);
// EXTERNAL MODULE: ./store/wishlist/wishlistActions.js
var wishlistActions = __webpack_require__(84444);
;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomIndicators/CustomIndicatorButton.tsx




var IndicatorButton = function(param) {
    var url = param.url, handleButtonClick = param.handleButtonClick, title = param.title, titleSpan = param.titleSpan;
    var handleElementsWithUrl = {
        "true": /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: url,
            onClick: handleButtonClick,
            prefetch: true,
            className: (customHeader_module_default()).indicator__button,
            legacyBehavior: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                "aria-label": url,
                className: (customHeader_module_default()).indicator__button,
                children: title
            })
        }),
        "false": /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            "aria-label": "indicatorButton",
            className: (customHeader_module_default()).indicator__button,
            onClick: handleButtonClick,
            children: title
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: handleElementsWithUrl["".concat(!!url)]
    });
};
/* harmony default export */ var CustomIndicatorButton = (IndicatorButton);

;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomIndicators/CustomIndicator.tsx








var CustomIndicator = function(param) {
    var dropdown = param.dropdown, url = param.url, _className = param.className, className = _className === void 0 ? "" : _className, icon = param.icon, value = param.value, _iconWrapperClassName = param.iconWrapperClassName, iconWrapperClassName = _iconWrapperClassName === void 0 ? "" : _iconWrapperClassName, propsTitle = param.title;
    var companyName = (0,es/* useSelector */.v9)(function(state) {
        return state.customer.companyName;
    });
    var indicatorIcons = function(style) {
        return {
            homeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HomeMobile */.D5, {
                style: (0,_object_spread/* default */.Z)({
                    pointerEvents: "none"
                }, style)
            }),
            homeIcon_active: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HomeMobileActive */.bn, {
                style: (0,_object_spread/* default */.Z)({
                    pointerEvents: "none"
                }, style)
            }),
            cartIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CartFill */.Wx, {
                style: (0,_object_spread/* default */.Z)({
                    pointerEvents: "none"
                }, style)
            }),
            cartIcon_active: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CartActive */.KB, {
                style: (0,_object_spread/* default */.Z)({
                    pointerEvents: "none"
                }, style)
            }),
            heartIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HeartSvg */.xO, {
                style: (0,_object_spread/* default */.Z)({
                    pointerEvents: "none"
                }, style)
            }),
            heartIcon_active: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* HeartActive */.wL, {
                style: (0,_object_spread/* default */.Z)({
                    pointerEvents: "none"
                }, style)
            }),
            userIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* PersonFill */.oS, {
                className: (customHeader_module_default()).user_svg,
                style: (0,_object_spread/* default */.Z)({
                    pointerEvents: "none"
                }, style)
            }),
            userIcon_active: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (customHeader_module_default()).authenticated_item,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ActiveUserSvg */.RP, {
                        style: (0,_object_spread/* default */.Z)({
                            pointerEvents: "none"
                        }, style)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (customHeader_module_default()).company_name,
                        children: companyName
                    })
                ]
            }),
            searchIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* SearchssSvg */.n8, {
                style: {
                    pointerEvents: "none",
                    width: "24px",
                    height: "24px"
                }
            })
        };
    };
    var ref = (0,react.useState)(false), opens = ref[0], setOpen = ref[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        setOpen(false);
    }, [
        router
    ]);
    var wrapperRef = (0,react.useRef)(null);
    var additionalClassName = {
        "true": (customHeader_module_default())[iconWrapperClassName],
        "false": ""
    };
    var valueGreaterThan = {
        "true": "99+",
        "false": value
    };
    var handleClassname = {
        "true": "".concat((customHeader_module_default())["indicator--opened"]),
        "false": ""
    };
    var totalValue = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "".concat((customHeader_module_default()).indicator__value, " ").concat((customHeader_module_default()).mobile_indicator__value),
        children: valueGreaterThan["".concat(value > 99)]
    });
    (0,react.useEffect)(function() {
        var handleOutsideClick = function(e) {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleOutsideClick);
        return function() {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);
    var handleButtonClick = function(event) {
        var hasDropdown = {
            "true": function() {
                return event.preventDefault();
            },
            "false": function() {}
        };
        hasDropdown["".concat(!!dropdown)]();
        setOpen(function(prevState) {
            return !prevState;
        });
    };
    var titleHandler = {
        "true": {
            "true": totalValue,
            "false": totalValue
        },
        "false": {
            "true": totalValue,
            "false": null
        }
    };
    var _props = totalValue.props, tmp = _props.children, totalValChildren = tmp === void 0 ? "" : tmp;
    var title = /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "".concat((customHeader_module_default()).indicator__area, " ").concat(additionalClassName["".concat(!!iconWrapperClassName)]),
        children: [
            indicatorIcons({})["".concat(icon)],
            titleHandler["".concat(totalValChildren > 0)]["".concat(totalValChildren === "99+")]
        ]
    });
    var hasDropDown = {
        "true": /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (customHeader_module_default()).indicator__dropdown,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((customHeader_module_default()).indicator, " ").concat((customHeader_module_default())["indicator--trigger--click"], " ").concat(className, " ").concat(handleClassname["".concat(opens)]),
                children: dropdown
            })
        }),
        "false": null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((customHeader_module_default()).indicator, " ").concat((customHeader_module_default())["indicator--trigger--click"], " ").concat(className, " ").concat(handleClassname["".concat(opens)]),
        ref: wrapperRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicatorButton, {
                titleSpan: propsTitle,
                title: title,
                url: url,
                handleButtonClick: handleButtonClick
            }),
            hasDropDown["".concat(!!dropdown)]
        ]
    });
};
/* harmony default export */ var CustomIndicators_CustomIndicator = (CustomIndicator);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./store/general/index.ts + 3 modules
var general = __webpack_require__(26298);
// EXTERNAL MODULE: ./atoms/Toast/useToast.ts
var useToast = __webpack_require__(54213);
// EXTERNAL MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomIndicators/CustomSocialLogin.tsx
var CustomSocialLogin = __webpack_require__(79316);
// EXTERNAL MODULE: ./store/orders/ordersActions.ts
var ordersActions = __webpack_require__(64514);
;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomIndicators/CustomIndicatorDropDownBody.tsx




















var IndicatorDropDownBody = function(param) {
    var setOpen = param.setOpen, translationsData = param.translationsData, selectedRate = param.selectedRate, selectedLocale = param.selectedLocale, isSocialLinksActive = param.isSocialLinksActive, dbName = param.dbName;
    var ref = (0,next_router.useRouter)(), routerPush = ref.push;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,useToast/* useToast */.p)(), toastOpen = ref1.open;
    var cartToken = (0,es/* useSelector */.v9)(function(state) {
        return state.cartToken.cartToken;
    });
    var ref2 = (0,react.useState)({
        email: "",
        password: ""
    }), ref3 = ref2[0], email = ref3.email, password = ref3.password, setForm = ref2[1];
    var handleForm = function(param) {
        var _target = param.target, name = _target.name, value = _target.value;
        setForm(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, name, value));
        });
    };
    var fetchToLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var response, ref, token, tmp, ref1, tmp1, ref2, tmp2, groupId, tmp3, dataId, tmp4, companyName, handleTokenValue, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fetch((0,helper/* apiUrlWithStore */.St)("/api/customer/login?token=true"), {
                                method: "POST",
                                mode: "cors",
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    email: email,
                                    password: password
                                })
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        ref = _state.sent(), token = ref.token, tmp = ref.data, ref1 = tmp === void 0 ? {} : tmp, tmp1 = ref1.group, ref2 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref2.id, groupId = tmp2 === void 0 ? "" : tmp2, tmp3 = ref1.id, dataId = tmp3 === void 0 ? "" : tmp3, tmp4 = ref1.companyname, companyName = tmp4 === void 0 ? "" : tmp4;
                        handleTokenValue = {
                            "true": /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            dispatch((0,store_customer/* setCustomerGroupID */.KJ)(groupId));
                                            dispatch((0,store_customer/* setAuth */.QV)(true));
                                            dispatch((0,store_customer/* setToken */.o4)(token));
                                            dispatch((0,store_customer/* setCompanyName */._4)(companyName));
                                            dispatch((0,store_customer/* setID */.Px)(dataId));
                                            dispatch((0,general/* setPopup */.ZA)(false));
                                            dispatch((0,ordersActions/* fetchOrders */.AU)(dataId, token));
                                            return [
                                                4,
                                                routerPush("/account/profile/")
                                            ];
                                        case 1:
                                            _state.sent();
                                            submitCartData(token);
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            "false": function() {
                                toastOpen(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "d-flex chek-fms",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                                        translationsData.InvalidEmailOrPassword
                                    ]
                                }));
                            }
                        };
                        handleTokenValue["".concat(!!token)]();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        console.error(err);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchToLogin(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var submitCartData = function(token) {
        dispatch((0,cart/* getCartDataMount */.yU)(cartToken, {
            token: token
        }, selectedLocale, selectedRate === null || selectedRate === void 0 ? void 0 : selectedRate.code));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((customHeader_module_default())["account-menu"]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            className: "".concat((customHeader_module_default())["account-menu__form"]),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((customHeader_module_default())["account-menu__form-title"]),
                    children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.SignIn
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((customHeader_module_default())["account-menu_loginAndPass"]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CWV_CustomTextField, {
                        className: "".concat((customHeader_module_default()).custom_input_field, " "),
                        id: "indicator_email",
                        type: "email",
                        name: "email",
                        autoComplete: "off",
                        value: email,
                        onChange: handleForm,
                        placeholder: translationsData === null || translationsData === void 0 ? void 0 : translationsData.Email
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((customHeader_module_default())["account-menu_loginAndPass"]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CWV_CustomTextField, {
                            className: "".concat((customHeader_module_default()).custom_input_field, " "),
                            id: "indicator_password",
                            type: "password",
                            name: "password",
                            autoComplete: "off",
                            value: password,
                            onChange: handleForm,
                            placeholder: translationsData === null || translationsData === void 0 ? void 0 : translationsData.Password
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/forgot-password",
                            className: "".concat((customHeader_module_default())["account-menu__form-forgot-link"]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                onClick: function() {
                                    dispatch((0,general/* setPopup */.ZA)(false));
                                    setOpen(function(prevState) {
                                        return !prevState;
                                    });
                                },
                                children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ForgotPassword
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "form-group ".concat((customHeader_module_default())["account-menu__form-button"]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: fetchToLogin,
                        type: "submit",
                        className: "btn btn-orange login-drop-btn ".concat((customHeader_module_default())["rounded-pills"]),
                        children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.SignIn
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSocialLogin/* default */.Z, {
                    dbName: dbName,
                    translationsData: translationsData,
                    isSocialLinksActive: isSocialLinksActive
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((customHeader_module_default())["account-menu__form-link"]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "".concat((customHeader_module_default())["new-customer"]),
                            children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.NewCustomer
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/signup",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                onClick: function() {
                                    dispatch((0,general/* setPopup */.ZA)(false));
                                    setOpen(function(prevState) {
                                        return !prevState;
                                    });
                                },
                                children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.SignUp
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CustomIndicatorDropDownBody = (IndicatorDropDownBody);

;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomIndicators/CustomIndicatorAccount.tsx







var CustomIndicatorAccount = function(param) {
    var translationsData = param.translationsData, selectedLocale = param.selectedLocale, selectedRate = param.selectedRate, isSocialLinksActive = param.isSocialLinksActive, dbName = param.dbName;
    var authenticated = (0,es/* useSelector */.v9)(function(state) {
        return state.customer.authenticated;
    });
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)("user_stroke"), iconWrapperClassName = ref1[0], setIconWrapperClassName = ref1[1];
    var ref2 = (0,react.useState)("userIcon"), icon = ref2[0], setIcon = ref2[1];
    var ref3 = (0,react.useState)(translationsData === null || translationsData === void 0 ? void 0 : translationsData.SignIn), title = ref3[0], setTitle = ref3[1];
    (0,react.useEffect)(function() {
        var settersToggle = function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 3), first = _param[0], second = _param[1], third = _param[2];
            setIconWrapperClassName(first);
            setIcon(second);
            setTitle(translationsData === null || translationsData === void 0 ? void 0 : translationsData[third]);
        };
        var isAuthenticated = {
            "true": function() {
                return settersToggle([
                    "desktop_user_active__wrapper",
                    "userIcon_active",
                    "MyAccount"
                ]);
            },
            "false": function() {
                return settersToggle([
                    "user_stroke",
                    "userIcon",
                    "SignIn"
                ]);
            }
        };
        isAuthenticated["".concat(authenticated)]();
    }, [
        authenticated,
        selectedLocale
    ]);
    var dropdown = {
        "false": /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicatorDropDownBody, {
            isSocialLinksActive: isSocialLinksActive,
            setOpen: setOpen,
            translationsData: translationsData,
            selectedLocale: selectedLocale,
            selectedRate: selectedRate,
            dbName: dbName
        }),
        "true": ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicator, {
        iconWrapperClassName: iconWrapperClassName,
        url: authenticated ? "/account/profile" : "",
        className: "".concat((customHeader_module_default())["account-logo-svg"]),
        dropdown: dropdown["".concat(authenticated)],
        icon: icon,
        title: title,
        value: ""
    });
};
/* harmony default export */ var CustomIndicators_CustomIndicatorAccount = (CustomIndicatorAccount);

;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomIndicators/CustomFailPanel.tsx







var CustomFailPanel = function(param) {
    var translationsData = param.translationsData;
    var toast = (0,useToast/* useToast */.p)();
    var wishlist = (0,es/* useSelector */.v9)(function(state) {
        return state.wishlist;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((customHeader_module_default()).indicator, " ").concat((customHeader_module_default())["indicator--trigger--click"]),
        onClick: function(e) {
            e.preventDefault();
            toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex faild-toast-fms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                    translationsData.ToastSignIn
                ]
            }));
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicator, {
            url: "",
            value: wishlist.length,
            icon: "heartIcon",
            title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.WishList,
            className: "",
            dropdown: "",
            iconWrapperClassName: ""
        })
    });
};
/* harmony default export */ var CustomIndicators_CustomFailPanel = (CustomFailPanel);

// EXTERNAL MODULE: ./components/account/AccountNavigationMenu.tsx
var AccountNavigationMenu = __webpack_require__(81111);
;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomIndicators/CustomCartDropDown.tsx







var CustomCartDropDown = function(param) {
    var cart = param.cart, items = param.items, isCheckAllow = param.isCheckAllow, tmp = param.selectedRate, ref = tmp === void 0 ? {} : tmp, selectedCurrSymbol = ref.symbol, translationsData = param.translationsData, allowCheckoutValue = param.allowCheckoutValue;
    var toast = (0,useToast/* useToast */.p)();
    var classNameScrollHandle = {
        "true": (customHeader_module_default())["dropcart__products-list_scroll"],
        "false": (customHeader_module_default())["dropcart__products-list"]
    };
    var hasDownloadableItem = cart.items.some(function(item) {
        return item.type === "downloadable";
    });
    var signed = (0,es/* useSelector */.v9)(function(state) {
        return state.customer.authenticated;
    });
    var checkoutHrefHandle = function() {
        switch(signed){
            case true:
                return "/checkout";
            case false:
                if (hasDownloadableItem || parseFloat(allowCheckoutValue) === 0) {
                    return "/signin";
                }
                return "/checkout";
            default:
                return "/checkout";
        }
    };
    var handleCheckoutClick = function() {
        if (hasDownloadableItem && !signed) {
            toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex faild-toast-fms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                    translationsData.ToastSignIn
                ]
            }));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (customHeader_module_default()).dropcart,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classNameScrollHandle["".concat(cart.items.length > 3)],
                children: items
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customHeader_module_default()).dropcart__totals,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                                    children: [
                                        translationsData === null || translationsData === void 0 ? void 0 : translationsData.Total,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: cart.sub_total
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (customHeader_module_default()).dropcart__buttons,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/cart",
                        prefetch: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "btn btn-orange ".concat((customHeader_module_default())["rounded-pills"]),
                            children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.Cart
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: checkoutHrefHandle(),
                        prefetch: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "btn btn-orange ".concat((customHeader_module_default())["rounded-pills"], " ").concat((customHeader_module_default())["dropcart__buttons-link"]),
                            onClick: handleCheckoutClick,
                            children: [
                                translationsData === null || translationsData === void 0 ? void 0 : translationsData.Checkout,
                                " "
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CustomIndicators_CustomCartDropDown = (CustomCartDropDown);

;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/NotAvailable.tsx



var NotAvailable = function(param) {
    var translationsData = param.translationsData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "faild-toast-fms",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
            translationsData.ToastSignIn
        ]
    });
};
/* harmony default export */ var CustomHeader_NotAvailable = (NotAvailable);

;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomIndicators/CustomIndicatorCart.tsx















var CustomIndicatorCart = function(param) {
    var translationsData = param.translationsData, allowCheckoutValue = param.allowCheckoutValue, dbName = param.dbName, selectedRate = param.selectedRate, locale = param.locale;
    var ref, ref1;
    var ref2 = (0,useToast/* useToast */.p)(), toastOpen = ref2.open;
    var ref3 = (0,next_router.useRouter)(), routerPush = ref3.push;
    var dispatch = (0,es/* useDispatch */.I0)();
    var customerToken = (0,es/* useSelector */.v9)(function(state) {
        return state.customer.token;
    });
    var _ref = (0,es/* useSelector */.v9)(function(state) {
        return state.cart;
    }) || {}, _loading = _ref.loading, loading = _loading === void 0 ? null : _loading, cartData = (0,_object_without_properties/* default */.Z)(_ref, [
        "loading"
    ]);
    var cartToken = (0,es/* useSelector */.v9)(function(state) {
        return state.cartToken;
    });
    var ref4 = (0,react.useState)(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})), dropDown = ref4[0], setDropDown = ref4[1];
    var isCheckAllow = (0,react.useCallback)(function() {
        var openToastHandler = {
            "true": {
                "true": function() {
                    routerPush("/signin?fm=guest").then(function(r) {
                        return r;
                    });
                    toastOpen(/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHeader_NotAvailable, {
                        translationsData: translationsData
                    }));
                },
                "false": function() {}
            },
            "false": {
                "true": function() {},
                "false": function() {}
            }
        };
        openToastHandler["".concat(parseFloat(allowCheckoutValue) === 0)]["".concat(customerToken === "")]();
    }, []);
    (0,react.useEffect)(function() {
        var ref, ref1;
        var cartDropDown = {
            "true": /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomCartDropDown, {
                isCheckAllow: isCheckAllow,
                cart: cartData,
                items: cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                    var ref;
                    var showLoader = {
                        "true": "btn-loading",
                        "false": ""
                    };
                    var trueImageUrl = {
                        "true": "/storage/medium/".concat((ref = item.product.images[0]) === null || ref === void 0 ? void 0 : ref.path),
                        "false": "/admin-themes/wt-admin-theme-one/assets/images/placeholder-icon.svg"
                    };
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customHeader_module_default()).dropcart__product,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((customHeader_module_default())["product-image"], " ").concat((customHeader_module_default())["dropcart__product-image"]),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/".concat(item.product.url_key),
                                    className: (customHeader_module_default())["product-image__body"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(trueImageUrl["".concat(item.product.images.length > 0)])),
                                            alt: item.name,
                                            height: 56,
                                            width: 56,
                                            objectFit: "contain",
                                            priority: true
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (customHeader_module_default())["dropcart__product-info"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (customHeader_module_default())["dropcart__product-name"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/".concat(item.product.url_key),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: item.name
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (customHeader_module_default())["dropcart__product-meta"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (customHeader_module_default())["dropcart__product-quantity"],
                                                children: item.quantity
                                            }),
                                            " \xd7 ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (customHeader_module_default())["dropcart__product-price"],
                                                children: item.formated_base_price
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    return dispatch((0,cart/* cartRemoveItem */.qH)(item.id, cartToken, {
                                        token: customerToken
                                    }));
                                },
                                className: "".concat((customHeader_module_default())["dropcart__product-remove"], " btn-light btn-sm btn-svg-icon ").concat(showLoader["".concat(loading === item.id)]),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* Cross10Svg */.Cm, {})
                            })
                        ]
                    }, item.id);
                }),
                allowCheckoutValue: allowCheckoutValue,
                selectedRate: selectedRate,
                translationsData: translationsData
            }),
            "false": /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customHeader_module_default()).dropcart,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (customHeader_module_default()).dropcart__empty,
                    children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.CartEmpty
                })
            })
        };
        setDropDown(cartDropDown["".concat(!!((ref1 = cartData.items) === null || ref1 === void 0 ? void 0 : ref1.length))]);
    //TODO !!! if this dependencies is wrong , change
    }, [
        (ref = cartData.items) === null || ref === void 0 ? void 0 : ref.length,
        loading,
        locale,
        selectedRate.code,
        cartData.grand_total
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicator, {
        className: (customHeader_module_default())["cart-icon"],
        url: "",
        dropdown: dropDown,
        value: cartData === null || cartData === void 0 ? void 0 : (ref1 = cartData.items) === null || ref1 === void 0 ? void 0 : ref1.length,
        icon: "cartIcon",
        title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.Cart,
        iconWrapperClassName: ""
    });
};
/* harmony default export */ var CustomIndicators_CustomIndicatorCart = (CustomIndicatorCart);

;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomIndicators/CustomIndicatorPanel.tsx






















var CustomIndicatorPanel = function(param) {
    var translationsData = param.translationsData, selectedLocale = param.selectedLocale, selectedRate = param.selectedRate, isSocialLinksActive = param.isSocialLinksActive, dbName = param.dbName, isMobile = param.isMobile, allowCheckoutValue = param.allowCheckoutValue;
    var ref = (0,react.useState)(""), personal = ref[0], setPersonal = ref[1];
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)([]), links = ref1[0], setLinks = ref1[1];
    var customer = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    });
    var cartToken = ((0,es/* useSelector */.v9)(function(state) {
        return state.cartToken;
    }) || {}).cartToken;
    var signed = (0,es/* useSelector */.v9)(function(state) {
        return state.customer.authenticated;
    });
    var wishlist = (0,es/* useSelector */.v9)(function(state) {
        return state.wishlist;
    });
    var isDownloadableOrder = !!(0,es/* useSelector */.v9)(function(state) {
        return state.orders.downloadable;
    }).length;
    var wishIndicator = {
        "true": /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicator, {
            url: "/wishlist",
            value: wishlist.length,
            icon: "heartIcon",
            title: translationsData === null || translationsData === void 0 ? void 0 : translationsData.WishList,
            className: "",
            dropdown: "",
            iconWrapperClassName: ""
        }),
        "false": /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomFailPanel, {
            translationsData: translationsData
        })
    };
    var logout = function(e) {
        e.preventDefault();
        dispatch((0,store_customer/* setAuth */.QV)(false));
        dispatch((0,store_customer/* setCustomerGroupID */.KJ)(1));
        dispatch((0,store_customer/* setToken */.o4)(""));
        dispatch((0,ordersActions/* clearOrders */.oh)());
        shop["default"].getCustomerLogoutToken(customer.token).then(function(item) {
            if (!item.ok) return;
            shop["default"].getCheckoutCartToken().then(function(res) {
                return res.api_token && dispatch((0,token/* AddCartToken */.y)(res.api_token));
            });
        });
        dispatch((0,cart/* getCartDataMount */.yU)(cartToken, {
            token: ""
        }, selectedLocale, selectedRate ? selectedRate.code : ""));
        dispatch((0,wishlistActions/* wishListRemoveAllItems */.XZ)());
        router.push("/");
    };
    (0,react.useEffect)(function() {
        var abortController = new AbortController();
        var signal = abortController.signal;
        if (customer.token) {
            fetch((0,helper/* apiUrlWithStore */.St)("/api/customer/get?token=".concat(customer.token)), {
                signal: signal
            }).then(function(response) {
                return response.json();
            }).then(function(res) {
                return res && setPersonal("".concat(res.data.first_name, " ").concat(res.data.last_name));
            }).catch(function(err) {
                return console.error(err);
            });
        }
        return function() {
            return abortController.abort();
        };
    }, [
        customer.token
    ]);
    (0,react.useEffect)(function() {
        var baseLinks = [
            {
                title: translationsData.PersonalInformation,
                url: "profile",
                id: 1
            },
            {
                title: translationsData.MyOrders,
                url: "orders",
                id: 2
            }
        ].concat((0,_to_consumable_array/* default */.Z)(isDownloadableOrder ? [
            {
                title: translationsData.DownloadableProducts,
                url: "downloadable-products",
                id: 3
            }
        ] : []), [
            {
                title: translationsData.Address,
                url: "addresses",
                id: 4
            },
            {
                title: translationsData.SignOut,
                url: "logout",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* Logout */.RD, {}),
                id: 5
            }
        ]);
        var jsxLinks = baseLinks.map(function(link) {
            var classes = "".concat((customHeader_module_default())["account-nav__item"], " ").concat(router.route.includes(link.url) ? (customHeader_module_default())["account-nav__item--active"] : "");
            var signOutProps = link.url === "logout" ? {
                onClick: logout,
                className: (customHeader_module_default()).logout
            } : {};
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: classes,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/account/".concat(link.url),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, signOutProps), {
                        children: [
                            link.icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: link.icon
                            }) : null,
                            link.title
                        ]
                    }))
                })
            }, link.id);
        });
        setLinks(jsxLinks);
    }, [
        isDownloadableOrder
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((customHeader_module_default())["nav-panel__item_row"], " ").concat((customHeader_module_default())["nav-panel__item-custom"]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicatorAccount, {
                        isSocialLinksActive: isSocialLinksActive,
                        translationsData: translationsData,
                        selectedLocale: selectedLocale,
                        selectedRate: selectedRate,
                        dbName: dbName
                    }),
                    !isMobile && signed ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (customHeader_module_default())["nav-panel__account-nav"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountNavigationMenu/* default */.Z, {
                            links: links,
                            username: personal
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((customHeader_module_default())["nav-panel__item_row"]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicatorCart, {
                    allowCheckoutValue: allowCheckoutValue,
                    translationsData: translationsData,
                    dbName: dbName,
                    selectedRate: selectedRate,
                    locale: selectedLocale
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((customHeader_module_default())["nav-panel__item_row"], " ").concat((customHeader_module_default()).heartButton),
                children: wishIndicator["".concat(signed)]
            })
        ]
    });
};
/* harmony default export */ var CustomIndicators_CustomIndicatorPanel = (CustomIndicatorPanel);

;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/SecondSection.tsx









var SecondSection = function(param) {
    var categories = param.categories, isTwoKings = param.isTwoKings, dbName = param.dbName, selectedRate = param.selectedRate, selectedLocale = param.selectedLocale, translationsData = param.translationsData, backOrderValue = param.backOrderValue, isSocialLinksActive = param.isSocialLinksActive, allowCheckoutValue = param.allowCheckoutValue, logoPath = param.logoPath, cacheControlVersion = param.cacheControlVersion, isMobile = param.isMobile, domain = param.domain, searchShowDetails = param.searchShowDetails, defaultLangCode = param.defaultLangCode, metas = param.metas;
    var openSearch = (0,es/* useSelector */.v9)(function(state) {
        return state.mobileMenu.searchOpen;
    });
    var classSearchOpen = {
        true: "".concat((customHeader_module_default())["mobile-header__search--open"], " ").concat((customHeader_module_default())["mobile-header__search"]),
        false: (customHeader_module_default())["mobile-header__search"]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (customHeader_module_default()).second_section,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((customHeader_module_default())["nav-panel"]),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((customHeader_module_default())["nav-panel__container"], " container"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((customHeader_module_default())["nav-panel__row"]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (customHeader_module_default()).logo_div,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(logoPath, "?v=").concat(cacheControlVersion)),
                                        alt: "Logo",
                                        width: 200,
                                        height: 45,
                                        objectFit: "contain",
                                        objectPosition: "left",
                                        unoptimized: true,
                                        // TODO !!! this is that part which controlling CWV result
                                        priority: true
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((customHeader_module_default())["site-header__search"], " ").concat(classSearchOpen["".concat(openSearch)]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHeader_CustomSearch, {
                                translationsData: translationsData,
                                selectedLocale: selectedLocale,
                                dbName: dbName,
                                selectedRate: selectedRate,
                                backOrderValue: backOrderValue,
                                defaultLangCode: defaultLangCode,
                                domain: domain,
                                searchShowDetails: searchShowDetails,
                                metas: metas
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((customHeader_module_default())["nav-panel__indicators"]),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicatorPanel, {
                                isSocialLinksActive: isSocialLinksActive,
                                translationsData: translationsData,
                                selectedLocale: selectedLocale,
                                selectedRate: selectedRate,
                                dbName: dbName,
                                isMobile: isMobile,
                                allowCheckoutValue: allowCheckoutValue
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var CustomHeader_SecondSection = (SecondSection);

;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/index.tsx







var CustomHeader = function(param) {
    var logoPath = param.logoPath, dbName = param.dbName, domain = param.domain, menus = param.menus, hasBlog = param.hasBlog, selectedRate = param.selectedRate, isTwoKings = param.isTwoKings, categories = param.categories, selectedLocale = param.selectedLocale, translationsData = param.translationsData, backOrderValue = param.backOrderValue, isSocialLinksActive = param.isSocialLinksActive, allowCheckoutValue = param.allowCheckoutValue, selectedLocaleImg = param.selectedLocaleImg, locales = param.locales, cacheControlVersion = param.cacheControlVersion, isMobile = param.isMobile, defaultLangCode = param.defaultLangCode, themeOptions = param.themeOptions, searchShowDetails = param.searchShowDetails, metas = param.metas;
    var openSearch = (0,es/* useSelector */.v9)(function(state) {
        return state.mobileMenu.searchOpen;
    }) || false;
    var secondSectionProps = {
        isMobile: isMobile,
        selectedRate: selectedRate,
        isTwoKings: isTwoKings,
        categories: categories,
        dbName: dbName,
        selectedLocale: selectedLocale,
        translationsData: translationsData,
        backOrderValue: backOrderValue,
        isSocialLinksActive: isSocialLinksActive,
        allowCheckoutValue: allowCheckoutValue,
        defaultLangCode: defaultLangCode,
        cacheControlVersion: cacheControlVersion,
        logoPath: logoPath,
        domain: domain,
        searchShowDetails: searchShowDetails,
        metas: metas
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (customHeader_module_default()).header,
        children: [
            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHeader_SecondSection, (0,_object_spread/* default */.Z)({}, secondSectionProps)) : openSearch ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHeader_SecondSection, (0,_object_spread/* default */.Z)({}, secondSectionProps)) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHeader_FirstSection, {
                categories: categories,
                isTwoKings: isTwoKings,
                dbName: dbName,
                domain: domain,
                logoPath: logoPath,
                menus: menus,
                hasBlog: hasBlog,
                selectedLocaleImg: selectedLocaleImg,
                translationsData: translationsData,
                locales: locales,
                cacheControlVersion: cacheControlVersion,
                themeOptions: themeOptions
            })
        ]
    });
};
/* harmony default export */ var Wrappers_CustomHeader = (CustomHeader);

// EXTERNAL MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomMobileMenu/customMobileMenu.module.scss
var customMobileMenu_module = __webpack_require__(72286);
var customMobileMenu_module_default = /*#__PURE__*/__webpack_require__.n(customMobileMenu_module);
;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomMobileMenu/CustomMobileLinks.tsx








var CustomMobileLink = function(param) {
    var item = param.item, index = param.index, _level = param.level, level = _level === void 0 ? 0 : _level, onItemClick = param.onItemClick, labelRender = param.labelRender, svgRender = param.svgRender, dbName = param.dbName, domain = param.domain;
    var frontLink = item.frontLink, _target = item.target, target = _target === void 0 ? {} : _target, name = item.name, children = item.children, id = item.id, _label = item.label, label = _label === void 0 ? null : _label;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var arrow_subLinksHandle = function(linkChildren) {
        return {
            "true": {
                arrow: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    "aria-label": "toggle menu",
                    className: (customMobileMenu_module_default())["mobile-links__item-toggle"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown12x7Svg */.bD, {
                        className: (customMobileMenu_module_default())["mobile-links__item-arrow"]
                    })
                }),
                subLinks: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (customMobileMenu_module_default())["mobile-links__item-sub-links"],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomMobileLinks, {
                        links: linkChildren,
                        level: level + 1,
                        onItemClick: onItemClick,
                        labelRender: labelRender,
                        svgRender: svgRender,
                        dbName: dbName,
                        domain: domain
                    })
                })
            },
            "false": {
                arrow: null,
                subLinks: null
            }
        };
    };
    var firstLink = {
        "true": {
            className: (customMobileMenu_module_default())["mobile-links__item--open"],
            element: null
        },
        "false": {
            className: "",
            element: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (customMobileMenu_module_default())["mobile-links__item-title"],
                onClick: function() {
                    return setOpen(function(prevOpen) {
                        return !prevOpen;
                    });
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: frontLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            rel: "noopener noreferrer"
                        }, target), {
                            className: (customMobileMenu_module_default())["mobile-links__item-link"],
                            onClick: function() {
                                return onItemClick();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (customMobileMenu_module_default())["name-icon__container"],
                                children: [
                                    item.image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (customMobileMenu_module_default()).icon_wrapper,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            width: 25,
                                            height: 25,
                                            alt: "menu icon",
                                            src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(item.image)),
                                            loading: "lazy"
                                        })
                                    }) : null,
                                    name,
                                    " "
                                ]
                            })
                        }))
                    }),
                    arrow_subLinksHandle(children)["".concat((children === null || children === void 0 ? void 0 : children.length) > 0)].arrow
                ]
            })
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((customMobileMenu_module_default())["mobile-links__item"], " ").concat(firstLink["".concat(id === 1 || open)].className, " "),
            children: [
                firstLink["".concat(id === 1)].element,
                arrow_subLinksHandle(children)["".concat((children === null || children === void 0 ? void 0 : children.length) > 0)].subLinks
            ]
        })
    }, index);
};
var CustomMobileLinks = function(props) {
    var links = props.links, _level = props.level, level = _level === void 0 ? 1 : _level;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "".concat((customMobileMenu_module_default())["mobile-links"], " ").concat((customMobileMenu_module_default())["mobile-links--level--".concat(level)]),
        children: links === null || links === void 0 ? void 0 : links.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomMobileLink, (0,_object_spread/* default */.Z)({
                item: item,
                index: index
            }, props), index);
        })
    });
};
/* harmony default export */ var CustomMobileMenu_CustomMobileLinks = (CustomMobileLinks);

;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomMobileMenu/CustomMobileMenuFooter.tsx







var CustomMobileMenuFooter = function(param) {
    var phoneValue = param.phoneValue, footerAddressValue = param.footerAddressValue, footerEmailValue = param.footerEmailValue, socialsFooter = param.socialsFooter, dbName = param.dbName, translationsData = param.translationsData, showMobileContactsStyle = param.showMobileContactsStyle, showMobileSocialsStyle = param.showMobileSocialsStyle;
    var ref = (0,react.useState)(false), storeOpen = ref[0], setStoreOpen = ref[1];
    var handleFooterContactsDisplay = {
        "true": {
            display: {
                display: "flex"
            },
            arrowClassName: "rotT_fms",
            divClassName: (customMobileMenu_module_default())["footer-title-opened"]
        },
        "false": {
            display: {
                display: "none"
            },
            arrowClassName: "",
            divClassName: ""
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (customMobileMenu_module_default()).mobileMenuFooter,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (customMobileMenu_module_default())["mobile-footer-dropdown"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((customMobileMenu_module_default())["mobile-footer-dropdown-divs"], " ").concat((customMobileMenu_module_default())[showMobileContactsStyle]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customMobileMenu_module_default())["footer-contacts"],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((customMobileMenu_module_default())["footer-title"], " ").concat(handleFooterContactsDisplay["".concat(storeOpen)].divClassName),
                                onClick: function() {
                                    return setStoreOpen(function(prevState) {
                                        return !prevState;
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ContactsSVG */.bX, {
                                        className: (customMobileMenu_module_default())["contacts-path"]
                                    }),
                                    translationsData === null || translationsData === void 0 ? void 0 : translationsData.OurContacts,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (customMobileMenu_module_default())["mobile-footer-arrow"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown12x7Svg */.bD, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                style: handleFooterContactsDisplay["".concat(storeOpen)].display,
                                className: (customMobileMenu_module_default())["footer-contacts__contacts"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (customMobileMenu_module_default()).contactsAddress,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: footerEmailValue
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (customMobileMenu_module_default()).contactsAddress,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "tel:".concat(phoneValue),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: phoneValue
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: (customMobileMenu_module_default()).contactsAddress,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: footerAddressValue
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((customMobileMenu_module_default())["mobile-footer-dropdown-last-divs"], " ").concat((customMobileMenu_module_default())[showMobileSocialsStyle]),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (customMobileMenu_module_default())["footer-newsletter__social-links"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: (customMobileMenu_module_default())["social-links__list"],
                            children: socialsFooter === null || socialsFooter === void 0 ? void 0 : socialsFooter.map(function(param, index) {
                                var name = param.name, link = param.link, icon = param.icon;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: (customMobileMenu_module_default())["social-links__item"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "".concat((customMobileMenu_module_default())["social-links__link"], " ").concat((customMobileMenu_module_default())["social-link-color"]),
                                            "aria-label": "socials",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(icon)),
                                                alt: name,
                                                layout: "fill",
                                                objectFit: "contain"
                                            })
                                        })
                                    })
                                }, index);
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var CustomMobileMenu_CustomMobileMenuFooter = (CustomMobileMenuFooter);

;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomHeader/CustomMobileMenu/index.tsx














var LinksItems = function(param) {
    var linkHref = param.linkHref, key_INTL = param.key_INTL;
    var dispatch = (0,es/* useDispatch */.I0)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (customMobileMenu_module_default())["mob-links__item"],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: linkHref,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                onClick: function() {
                    return dispatch((0,mobile_menu/* mobileMenuClose */.nA)());
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (customMobileMenu_module_default())["mobile-links__blok"],
                    children: key_INTL
                })
            })
        })
    });
};
var CustomMobileMenu = function(param) {
    var menus = param.menus, categories = param.categories, blogValue = param.blogValue, tmp = param.salesActiveSettings, ref = tmp === void 0 ? {} : tmp, _Tracking = ref.Tracking, Tracking = _Tracking === void 0 ? "" : _Tracking, _ContactWithUs = ref.ContactWithUs, ContactWithUs = _ContactWithUs === void 0 ? "" : _ContactWithUs, translationsData = param.translationsData, tmp1 = param.currencies, ref1 = (0,_to_array/* default */.Z)(tmp1 === void 0 ? [] : tmp1), tmp2 = ref1[0], ref2 = tmp2 === void 0 ? {} : tmp2, tmp3 = ref2.code, selectedCurr = tmp3 === void 0 ? "" : tmp3, tmp4 = ref2.symbol, selectedSymbol = tmp4 === void 0 ? "" : tmp4, currencies = ref1.slice(1), phoneValue = param.phoneValue, footerAddressValue = param.footerAddressValue, footerEmailValue = param.footerEmailValue, socialsFooter = param.socialsFooter, dbName = param.dbName, logoPath = param.logoPath, cacheControlVersion = param.cacheControlVersion, showMobileContactsStyle = param.showMobileContactsStyle, showMobileSocialsStyle = param.showMobileSocialsStyle, mobileMenuPagesToggle = param.mobileMenuPagesToggle, domain = param.domain;
    var ref3;
    (0,react.useEffect)(function() {
        var handleEvent = function() {
            dispatch((0,mobile_menu/* mobileMenuClose */.nA)());
        };
        // TODO!!! unload change into pagehide for CWV improvement, remove if it does not work
        // window.addEventListener("unload", handleEvent)
        //
        // return () => window.removeEventListener('unload', handleEvent)
        window.addEventListener("pagehide", handleEvent);
        return function() {
            window.removeEventListener("pagehide", handleEvent);
        };
    }, []);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref4 = (0,react.useState)(false), menuAnim = ref4[0], setMenuAnim = ref4[1];
    var mobileMenuOpen2 = (0,es/* useSelector */.v9)(function(state) {
        return state.mobileMenu.open;
    });
    var classNamesHandler = {
        "true": (customMobileMenu_module_default())["mobilemenu--open"],
        "false": ""
    };
    var hasElement = function(attributes) {
        return {
            "true": /*#__PURE__*/ (0,jsx_runtime.jsx)(LinksItems, (0,_object_spread/* default */.Z)({}, attributes)),
            "false": null
        };
    };
    var handleCurrencyDropdown = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers_CustomCurrDropDown, {
            selectedSymbol: selectedSymbol,
            selectedCurr: selectedCurr,
            currencies: currencies
        }),
        false: null
    };
    (0,react.useEffect)(function() {
        if (menuAnim) {
            var timeout = setTimeout(function() {
                dispatch((0,mobile_menu/* mobileMenuClose */.nA)());
                setMenuAnim(function(prevState) {
                    return !prevState;
                });
            }, 300);
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        menuAnim
    ]);
    var handleMenuClick = function() {
        setMenuAnim(function(prevState) {
            return !prevState;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((customMobileMenu_module_default()).mobilemenu, " ").concat(classNamesHandler["".concat(mobileMenuOpen2)]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((customMobileMenu_module_default()).mobilemenu__backdrop, " ").concat(menuAnim ? "".concat((customMobileMenu_module_default()).backdrop__hide) : ""),
                onClick: handleMenuClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((customMobileMenu_module_default()).mobilemenu__body, " ").concat(menuAnim ? "".concat((customMobileMenu_module_default()).animtrue) : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customMobileMenu_module_default()).menu__header,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (customMobileMenu_module_default()).header__logo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(logoPath, "?v=").concat(cacheControlVersion)),
                                            alt: "Logo",
                                            width: 200,
                                            height: 40,
                                            objectFit: "contain",
                                            objectPosition: "left",
                                            unoptimized: true,
                                            // TODO !!! this is that part which controlling CWV result
                                            priority: true
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: (customMobileMenu_module_default())["mobile-header__menu-button"],
                                onClick: handleMenuClick,
                                "aria-label": "MobileHeaderBtn",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* Cross20Svg */.He, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customMobileMenu_module_default()).mobilemenu__content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomMobileMenu_CustomMobileLinks, {
                                links: categories === null || categories === void 0 ? void 0 : (ref3 = categories[0]) === null || ref3 === void 0 ? void 0 : ref3.children,
                                onItemClick: function() {
                                    return dispatch((0,mobile_menu/* mobileMenuClose */.nA)());
                                },
                                svgRender: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CategorySVG */.p$, {}),
                                dbName: dbName,
                                domain: domain
                            }),
                            mobileMenuPagesToggle && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomMobileMenu_CustomMobileLinks, {
                                links: menus,
                                onItemClick: function() {
                                    return dispatch((0,mobile_menu/* mobileMenuClose */.nA)());
                                },
                                svgRender: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* PagesSVG */.F2, {}),
                                dbName: dbName,
                                domain: domain
                            }),
                            hasElement({
                                linkHref: "/posts",
                                key_INTL: translationsData === null || translationsData === void 0 ? void 0 : translationsData.Posts,
                                svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* BlogSVG */.Jo, {})
                            })["".concat(!!+blogValue)],
                            hasElement({
                                linkHref: "/contactwithus",
                                key_INTL: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ContactWithUs,
                                svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ContactusSVG */.X2, {})
                            })["".concat(!!+ContactWithUs)],
                            hasElement({
                                linkHref: "/tracking",
                                key_INTL: translationsData === null || translationsData === void 0 ? void 0 : translationsData.Tracking,
                                svg: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* TrackingSVG */.sF, {})
                            })["".concat(!!+Tracking)],
                            handleCurrencyDropdown["".concat(currencies.length > 1)]
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomMobileMenu_CustomMobileMenuFooter, {
                        phoneValue: phoneValue,
                        footerAddressValue: footerAddressValue,
                        footerEmailValue: footerEmailValue,
                        socialsFooter: socialsFooter,
                        dbName: dbName,
                        translationsData: translationsData,
                        showMobileContactsStyle: showMobileContactsStyle,
                        showMobileSocialsStyle: showMobileSocialsStyle
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CustomHeader_CustomMobileMenu = (CustomMobileMenu);

;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/CustomFooter/CustomBottomNavigation.tsx












var urlSender = function(url) {
    return {
        "true": url,
        "false": ""
    };
};
var CustomBottomNavigation = function(param) {
    var translationsData = param.translationsData, _activeMobileNavElement = param.activeMobileNavElement, activeMobileNavElement = _activeMobileNavElement === void 0 ? 0 : _activeMobileNavElement;
    var ref = (0,next_router.useRouter)(), routerPush = ref.push;
    var toast = (0,useToast/* useToast */.p)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var cart = (0,es/* useSelector */.v9)(function(state) {
        return state.cart;
    });
    var wishlist = (0,es/* useSelector */.v9)(function(state) {
        return state.wishlist;
    });
    var loggedIn = (0,es/* useSelector */.v9)(function(state) {
        return state.customer.authenticated;
    });
    var mobileMenuState = (0,es/* useSelector */.v9)(function(state) {
        return state.mobileMenu;
    });
    var navRef = (0,react.useRef)(null);
    var scrollTimeout;
    var homeIndicatorProps = {
        url: "/",
        className: "",
        dropdown: "",
        value: "",
        iconWrapperClassName: "",
        title: ""
    };
    var cartIndicatorProps = {
        url: "/cart",
        value: cart === null || cart === void 0 ? void 0 : cart.items.length,
        iconWrapperClassName: "",
        title: "",
        dropdown: ""
    };
    var favouriteIndicatorProps = {
        iconWrapperClassName: "",
        dropdown: "",
        title: "",
        className: (customFooter_module_default())["indicator--mobile"],
        url: urlSender("/wishlist")["".concat(loggedIn)],
        value: wishlist.length
    };
    var signInIndicatorProps = {
        iconWrapperClassName: "user_stroke",
        className: "".concat((customFooter_module_default())["indicator--mobile"], " ").concat((customFooter_module_default()).user_indicator),
        url: urlSender("/account/profile")["".concat(loggedIn)],
        icon: "userIcon",
        dropdown: "",
        title: "",
        value: ""
    };
    var searchIndicatorProps = {
        iconWrapperClassName: "mobile_search_wrapper",
        className: "",
        url: "",
        icon: "searchIcon",
        dropdown: "",
        title: "",
        value: ""
    };
    var openToastForGuest = {
        "true": function() {
            toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "d-flex faild-toast-fms",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {
                        className: (customFooter_module_default())["click-disabled"]
                    }),
                    translationsData.ToastSignIn
                ]
            }));
        },
        "false": function() {
            return routerPush("/wishlist");
        }
    };
    var authenticated = (0,es/* useSelector */.v9)(function(state) {
        return state.customer.authenticated;
    });
    var isThisElementActive = function(activeIcon, icon) {
        return {
            "true": {
                lineClass: (customFooter_module_default()).under_line__active,
                divClass: (customFooter_module_default())["local-item-active"],
                icon: activeIcon
            },
            "false": {
                lineClass: "",
                divClass: "",
                icon: icon
            }
        };
    };
    var bottomNavItems = [
        /*** Home ***/ {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicator, (0,_object_spread/* default */.Z)({
                icon: "homeIcon"
            }, homeIndicatorProps)),
            activeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicator, (0,_object_spread/* default */.Z)({
                icon: "homeIcon"
            }, homeIndicatorProps)),
            param: [
                "/"
            ],
            onClick: function() {
                return routerPush("/");
            }
        },
        /*** Cart ***/ {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicator, (0,_object_spread/* default */.Z)({
                className: (customFooter_module_default())["indicator--mobile"],
                icon: "cartIcon"
            }, cartIndicatorProps)),
            activeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicator, (0,_object_spread/* default */.Z)({
                icon: "cartIcon",
                className: ""
            }, cartIndicatorProps)),
            param: [
                "/cart",
                "/checkout"
            ],
            onClick: function() {
                return routerPush("/cart");
            }
        },
        /*** Divider ***/ {
            param: [],
            onClick: function() {}
        },
        /*** Favourite ***/ {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicator, (0,_object_spread/* default */.Z)({
                icon: "heartIcon"
            }, favouriteIndicatorProps)),
            activeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicator, (0,_object_spread/* default */.Z)({
                icon: "heartIcon"
            }, favouriteIndicatorProps)),
            param: [
                "/wishlist"
            ],
            onClick: function() {
                openToastForGuest["".concat(!loggedIn)]();
            }
        },
        /*** Sign in ***/ {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicator, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, signInIndicatorProps), {
                icon: "".concat(authenticated ? "userIcon_active" : "userIcon")
            })),
            activeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicator, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, signInIndicatorProps), {
                icon: "userIcon_active"
            })),
            param: [
                "/account/profile",
                "/account/addresses",
                "/account/addresses/new",
                "/account/orders",
                "/signin"
            ],
            onClick: function() {
                var openModalForGuest = {
                    "true": function() {
                        (function() {
                            dispatch((0,general/* setPopup */.ZA)(true));
                            dispatch((0,general/* setPopupName */.Sq)("register"));
                        })();
                    },
                    "false": function() {
                        return routerPush("/account/profile");
                    }
                };
                openModalForGuest["".concat(!loggedIn)]();
            }
        }, 
    ];
    (0,react.useEffect)(function() {
        if (!mobileMenuState.open) {
            var prevPos = window.pageYOffset;
            var scrollFunc = function() {
                if (navRef.current) {
                    if (window.pageYOffset > prevPos) {
                        navRef.current.style.transform = "translate(0, 100px)";
                    } else {
                        navRef.current.style.transform = "translate(0, 0)";
                    }
                    prevPos = window.pageYOffset;
                }
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(function() {
                    if (navRef.current) {
                        navRef.current.style.transform = "translate(0, 0)";
                    }
                }, 300);
            };
            window.addEventListener("scroll", scrollFunc);
            return function() {
                window.removeEventListener("scroll", scrollFunc);
                clearTimeout(scrollTimeout);
            };
        }
    }, [
        mobileMenuState.open
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (customFooter_module_default()).bottom_footer,
        ref: navRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customFooter_module_default()).bottom_search,
                onClick: function(e) {
                    e.stopPropagation();
                    dispatch((0,mobile_menu/* mobileSearchOpen */.sO)());
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIndicators_CustomIndicator, (0,_object_spread/* default */.Z)({}, searchIndicatorProps))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customFooter_module_default())["bottomNavigation-wrapper"],
                children: bottomNavItems.map(function(param, index) {
                    var _$param = param.param, onClick = param.onClick, icon = param.icon, activeIcon = param.activeIcon;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((customFooter_module_default())["bottom-nav-item"], " ").concat(isThisElementActive(activeIcon, icon)["".concat(index === activeMobileNavElement)].divClass),
                        id: "nav-item-".concat(_$param),
                        onClick: function() {
                            onClick();
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " ".concat((customFooter_module_default()).indicator, " "),
                                style: {
                                    pointerEvents: "none"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (customFooter_module_default()).indicator__area,
                                    children: isThisElementActive(activeIcon, icon)["".concat(index === activeMobileNavElement)].icon
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: isThisElementActive(activeIcon, icon)["".concat(index === activeMobileNavElement)].lineClass
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var CustomFooter_CustomBottomNavigation = (CustomBottomNavigation);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/ForCWV/Wrappers/MainLayout.tsx




















var PopupModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3997), __webpack_require__.e(2830), __webpack_require__.e(8972), __webpack_require__.e(22)]).then(__webpack_require__.bind(__webpack_require__, 3631));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3631)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Loading..."
        });
    }
});
var MainLayout = function(param) {
    var _children = param.children, children = _children === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : _children, _telephone = param.telephone, telephone = _telephone === void 0 ? "" : _telephone, _dbName = param.dbName, dbName = _dbName === void 0 ? "" : _dbName, _selectedLocale = param.selectedLocale, selectedLocale = _selectedLocale === void 0 ? "en" : _selectedLocale, _domain = param.domain, domain = _domain === void 0 ? "" : _domain, _menus = param.menus, menus = _menus === void 0 ? [] : _menus, _hasBlog = param.hasBlog, hasBlog = _hasBlog === void 0 ? "" : _hasBlog, _blogValue = param.blogValue, blogValue = _blogValue === void 0 ? "0" : _blogValue, _locales = param.locales, locales = _locales === void 0 ? [] : _locales, _currencies = param.currencies, currencies = _currencies === void 0 ? [] : _currencies, _selectedLocaleImg = param.selectedLocaleImg, selectedLocaleImg = _selectedLocaleImg === void 0 ? "" : _selectedLocaleImg, _gdprValue = param.gdprValue, gdprValue = _gdprValue === void 0 ? 0 : _gdprValue, _gdprTitle = param.gdprTitle, gdprTitle = _gdprTitle === void 0 ? "" : _gdprTitle, _gdprContent = param.gdprContent, gdprContent = _gdprContent === void 0 ? "" : _gdprContent, _categories = param.categories, categories = _categories === void 0 ? [] : _categories, _isTwoKings = param.isTwoKings, isTwoKings = _isTwoKings === void 0 ? false : _isTwoKings, _translationsData = param.translationsData, translationsData = _translationsData === void 0 ? {} : _translationsData, _backOrderValue = param.backOrderValue, backOrderValue = _backOrderValue === void 0 ? "" : _backOrderValue, _isSocialLinksActive = param.isSocialLinksActive, isSocialLinksActive = _isSocialLinksActive === void 0 ? [] : _isSocialLinksActive, _allowCheckoutValue = param.allowCheckoutValue, allowCheckoutValue = _allowCheckoutValue === void 0 ? "" : _allowCheckoutValue, _footerCopyRightValue = param.footerCopyRightValue, footerCopyRightValue = _footerCopyRightValue === void 0 ? "" : _footerCopyRightValue, _footerPoweredValue = param.footerPoweredValue, footerPoweredValue = _footerPoweredValue === void 0 ? "" : _footerPoweredValue, _showSubscriptionStyle = param.showSubscriptionStyle, showSubscriptionStyle = _showSubscriptionStyle === void 0 ? "none" : _showSubscriptionStyle, _arrFooterTrack = param.arrFooterTrack, arrFooterTrack = _arrFooterTrack === void 0 ? [] : _arrFooterTrack, _footerMenus = param.footerMenus, footerMenus = _footerMenus === void 0 ? [] : _footerMenus, _showFooterEmailStyle = param.showFooterEmailStyle, showFooterEmailStyle = _showFooterEmailStyle === void 0 ? "none" : _showFooterEmailStyle, _showFooterPhoneStyle = param.showFooterPhoneStyle, showFooterPhoneStyle = _showFooterPhoneStyle === void 0 ? "none" : _showFooterPhoneStyle, _footerEmailValue = param.footerEmailValue, footerEmailValue = _footerEmailValue === void 0 ? "" : _footerEmailValue, _footerAddressValue = param.footerAddressValue, footerAddressValue = _footerAddressValue === void 0 ? "" : _footerAddressValue, _showFooterAddressStyle = param.showFooterAddressStyle, showFooterAddressStyle = _showFooterAddressStyle === void 0 ? "none" : _showFooterAddressStyle, _showMobileContactsStyle = param.showMobileContactsStyle, showMobileContactsStyle = _showMobileContactsStyle === void 0 ? "" : _showMobileContactsStyle, _showMobileSocialsStyle = param.showMobileSocialsStyle, showMobileSocialsStyle = _showMobileSocialsStyle === void 0 ? "" : _showMobileSocialsStyle, _socialsFooter = param.socialsFooter, socialsFooter = _socialsFooter === void 0 ? [] : _socialsFooter, _salesActiveSettings = param.salesActiveSettings, salesActiveSettings = _salesActiveSettings === void 0 ? {
        Tracking: "",
        ContactWithUs: ""
    } : _salesActiveSettings, _activeMobileNavElement = param.activeMobileNavElement, activeMobileNavElement = _activeMobileNavElement === void 0 ? 0 : _activeMobileNavElement, _logoPath = param.logoPath, logoPath = _logoPath === void 0 ? "" : _logoPath, _cacheControlVersion = param.cacheControlVersion, cacheControlVersion = _cacheControlVersion === void 0 ? 0 : _cacheControlVersion, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, tmp = param.currencies, ref = (0,_sliced_to_array/* default */.Z)(tmp === void 0 ? [] : tmp, 1), tmp1 = ref[0], ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1.code, currCode = tmp2 === void 0 ? "" : tmp2, _showFooterMenuCls = param.showFooterMenuCls, showFooterMenuCls = _showFooterMenuCls === void 0 ? "empty_menus" : _showFooterMenuCls, _showFooterContactCls = param.showFooterContactCls, showFooterContactCls = _showFooterContactCls === void 0 ? "" : _showFooterContactCls, defaultLangCode = param.defaultLangCode, themeOptions = param.themeOptions, getBuilderData = param.getBuilderData, recaptchaActive = param.recaptchaActive, mobileMenuPagesToggle = param.mobileMenuPagesToggle, searchShowDetails = param.searchShowDetails, metas = param.metas, mobileMenuMenus = param.mobileMenuMenus, topMenus = param.topMenus, selectedLocaleDirection = param.selectedLocaleDirection, uniqueLayoutId = param.uniqueLayoutId;
    var ref2;
    var popUp = (0,es/* useSelector */.v9)(function(state) {
        return state.general.popUp;
    });
    var customer = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    });
    var cartToken = (0,es/* useSelector */.v9)(function(state) {
        return state.cartToken;
    });
    var searchOpen = (0,es/* useSelector */.v9)(function(state) {
        return state.mobileMenu.searchOpen;
    });
    var ref3 = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    }), tmp3 = ref3.token, customerToken = tmp3 === void 0 ? "" : tmp3;
    var ref4 = (0,react.useState)(false), hydrated = ref4[0], setHydrated = ref4[1];
    (0,react.useEffect)(function() {
        return setHydrated(true);
    }, []);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref5 = (0,next_router.useRouter)(), tmp4 = ref5.query, ref6 = tmp4 === void 0 ? {} : tmp4, tmp5 = ref6.room_id, shortRoomId = tmp5 === void 0 ? null : tmp5;
    var backgroundClass = {
        true: "background_layer",
        false: ""
    };
    (0,react.useEffect)(function() {
        dispatch((0,mobile_menu/* mobileMenuClose */.nA)());
        (0,_async_to_generator/* default */.Z)(function() {
            var response, res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            4,
                            ,
                            5
                        ]);
                        if (!!(cartToken === null || cartToken === void 0 ? void 0 : cartToken.cartToken)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            fetch("/api/checkout/cart/token")
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 2:
                        res = _state.sent();
                        if (res.api_token) {
                            dispatch((0,token/* AddCartToken */.y)(res.api_token));
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        console.error("Error fetching cart token:", error);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
        (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {
                    dispatch((0,cart/* getCartDataMount */.yU)(cartToken === null || cartToken === void 0 ? void 0 : cartToken.cartToken, customer, selectedLocale, currCode));
                } catch (error) {
                    console.error("Error fetching cart mount:", error);
                }
                return [
                    2
                ];
            });
        })();
    }, []);
    (0,react.useEffect)(function() {
        var abortController = new AbortController();
        if (customerToken) {
            var decodedToken = (0,jwt_decode_esm/* default */.Z)(customerToken);
            if (Date.now() >= decodedToken.exp * 1000) {
                dispatch((0,store_customer/* setAuth */.QV)(false));
                dispatch((0,store_customer/* setCustomerGroupID */.KJ)(1));
                dispatch((0,store_customer/* setToken */.o4)(""));
                dispatch((0,ordersActions/* clearOrders */.oh)());
            }
        }
        return function() {
            return abortController.abort();
        };
    }, [
        customerToken
    ]);
    (0,react.useEffect)(function() {
        if (shortRoomId) {
            sessionStorage.setItem("roomID", shortRoomId);
        }
        dispatch((0,mobile_menu/* mobileSearchClose */.Tc)());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "site ".concat(uniqueLayoutId),
        style: {
            direction: selectedLocaleDirection || "ltr"
        },
        children: [
            !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers_CustomTopBar, {
                telephone: telephone,
                dbName: dbName,
                locales: locales,
                currencies: currencies,
                selectedLocaleImg: selectedLocaleImg,
                topMenus: topMenus,
                domain: domain,
                themeOptions: themeOptions,
                selectedLocale: selectedLocale
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers_CustomHeader, {
                logoPath: logoPath,
                dbName: dbName,
                domain: domain,
                menus: menus,
                hasBlog: hasBlog,
                selectedRate: currencies === null || currencies === void 0 ? void 0 : currencies[0],
                isTwoKings: isTwoKings,
                categories: categories,
                selectedLocale: selectedLocale,
                translationsData: translationsData,
                backOrderValue: backOrderValue,
                isSocialLinksActive: isSocialLinksActive,
                allowCheckoutValue: allowCheckoutValue,
                selectedLocaleImg: selectedLocaleImg,
                locales: locales,
                cacheControlVersion: cacheControlVersion,
                isMobile: isMobile,
                defaultLangCode: defaultLangCode,
                themeOptions: themeOptions,
                searchShowDetails: searchShowDetails,
                metas: metas
            }),
            hydrated ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomHeader_CustomMobileMenu, {
                menus: mobileMenuMenus,
                categories: categories,
                blogValue: blogValue,
                salesActiveSettings: salesActiveSettings,
                translationsData: translationsData,
                currencies: currencies,
                phoneValue: telephone,
                footerAddressValue: footerAddressValue,
                footerEmailValue: footerEmailValue,
                socialsFooter: socialsFooter,
                dbName: dbName,
                logoPath: logoPath,
                cacheControlVersion: cacheControlVersion,
                showMobileContactsStyle: showMobileContactsStyle,
                showMobileSocialsStyle: showMobileSocialsStyle,
                mobileMenuPagesToggle: mobileMenuPagesToggle,
                domain: domain
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: backgroundClass["".concat(searchOpen)]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "site_content",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrappers_CustomFooter, {
                selectedLocale: selectedLocale,
                footerCopyRightValue: footerCopyRightValue,
                footerPoweredValue: footerPoweredValue,
                showSubscriptionStyle: showSubscriptionStyle,
                arrFooterTrack: arrFooterTrack,
                footerMenus: footerMenus,
                showFooterEmailStyle: showFooterEmailStyle,
                footerEmailValue: footerEmailValue,
                telephone: telephone,
                footerAddressValue: footerAddressValue,
                showFooterAddressStyle: showFooterAddressStyle,
                socialsFooter: socialsFooter,
                dbName: dbName,
                translationsData: translationsData,
                showFooterMenuCls: showFooterMenuCls,
                logoPath: logoPath,
                cacheControlVersion: cacheControlVersion,
                showFooterContactCls: showFooterContactCls,
                showFooterPhoneStyle: showFooterPhoneStyle,
                isMobile: isMobile,
                themeOptions: themeOptions,
                getBuilderData: getBuilderData,
                currencies: currencies,
                backOrderValue: backOrderValue,
                domain: domain,
                recaptchaActive: recaptchaActive
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFooter_CustomBottomNavigation, {
                activeMobileNavElement: activeMobileNavElement,
                translationsData: translationsData
            }),
            +gdprValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AcceptCookies, {
                translationsData: translationsData,
                gdprTitle: gdprTitle,
                gdprContent: gdprContent
            }) : null,
            popUp ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupModal, {
                active: popUp,
                locale: selectedLocale,
                dbName: dbName,
                translationsData: translationsData,
                selectedCurrSymbol: currencies === null || currencies === void 0 ? void 0 : (ref2 = currencies[0]) === null || ref2 === void 0 ? void 0 : ref2.symbol,
                isSocialLinksActive: isSocialLinksActive
            }) : null
        ]
    });
};
/* harmony default export */ var Wrappers_MainLayout = (MainLayout);


/***/ }),

/***/ 81111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _account_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67707);
/* harmony import */ var _account_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_account_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var AccountNavigationMenu = function(param) {
    var links = param.links, username = param.username;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["account-layout"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["account-nav"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                className: "".concat((_account_module_scss__WEBPACK_IMPORTED_MODULE_2___default().card), " ").concat((_account_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["account-links-body"])),
                children: [
                    username ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: (_account_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["account-nav-username"]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: username
                        })
                    }) : null,
                    links
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccountNavigationMenu);


/***/ }),

/***/ 30068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BuilderDataRender; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/builder/builder.module.scss
var builder_module = __webpack_require__(20426);
var builder_module_default = /*#__PURE__*/__webpack_require__.n(builder_module);
;// CONCATENATED MODULE: ./components/builder/Heading/index.tsx



var Heading = function(param) {
    var _item = param.item, tag = _item.tag, _headingText = _item.headingText, headingText = _headingText === void 0 ? "" : _headingText, customClassNames = _item.customClassNames, tmp = _item.convertedSettings, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.animationAos, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1["data-aos"], dataAos = tmp2 === void 0 ? null : tmp2, _styles = ref.styles, styles = _styles === void 0 ? {} : _styles, _parentStyles = ref.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles, tmp3 = _item.headingSettings, fontSize = (tmp3 === void 0 ? {} : tmp3).fontSize, hoverAnimation = _item.hoverAnimation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-aos": dataAos,
        style: parentStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: styles,
            className: "".concat(customClassNames, " ").concat((builder_module_default())[hoverAnimation !== null && hoverAnimation !== void 0 ? hoverAnimation : "none"]),
            dangerouslySetInnerHTML: {
                __html: "<".concat(tag, ' style="font-size: ').concat(fontSize, 'px;">').concat(headingText, "</").concat(tag, ">")
            }
        })
    });
};
/* harmony default export */ var builder_Heading = (Heading);

;// CONCATENATED MODULE: ./components/builder/HyperLink/index.tsx



var HyperLink = function(param) {
    var _item = param.item, hyperLink = _item.hyperLink, customClassNames = _item.customClassNames, hyperLinkName = _item.hyperLinkName, tmp = _item.convertedSettings, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.animationAos, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1["data-aos"], dataAos = tmp2 === void 0 ? null : tmp2, _styles = ref.styles, styles = _styles === void 0 ? {} : _styles, _parentStyles = ref.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles, hoverAnimation = _item.hoverAnimation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-aos": dataAos,
        style: parentStyles,
        className: "".concat(customClassNames, " ").concat((builder_module_default())[hoverAnimation !== null && hoverAnimation !== void 0 ? hoverAnimation : "none"]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: hyperLink,
            target: "_blank",
            style: styles,
            rel: "noreferrer",
            children: hyperLinkName
        })
    });
};
/* harmony default export */ var builder_HyperLink = (HyperLink);

;// CONCATENATED MODULE: ./components/builder/Editor/index.tsx


var Editor = function(param) {
    var _item = param.item, textEditorValue = _item.textEditorValue, customClassNames = _item.customClassNames, tmp = _item.convertedSettings, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.animationAos, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1["data-aos"], dataAos = tmp2 === void 0 ? null : tmp2, _styles = ref.styles, styles = _styles === void 0 ? {} : _styles, _parentStyles = ref.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-aos": dataAos,
        className: customClassNames,
        style: parentStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (builder_module_default()).editor_content,
            style: styles,
            dangerouslySetInnerHTML: {
                __html: textEditorValue
            }
        })
    });
};
/* harmony default export */ var builder_Editor = (Editor);

// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
;// CONCATENATED MODULE: ./components/builder/Accordion/AccordionLIst.tsx




var AccordionLIst = function(param) {
    var _faq = param.faq, title = _faq.title, description = _faq.description, _styles = param.styles, backgroundColor = _styles.backgroundColor, color = _styles.color, customClassNames = param.customClassNames, tmp = param.accordionSettings, ref = tmp === void 0 ? {} : tmp, _iconType = ref.iconType, iconType = _iconType === void 0 ? "plus" : _iconType, fontSize = ref.fontSize;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var itemRef = (0,react.useRef)(null);
    var bodyRef = (0,react.useRef)(null);
    var handleAccordion = function() {
        if (bodyRef.current) {
            if (bodyRef.current.style.maxHeight) {
                bodyRef.current.style.maxHeight = null;
                bodyRef.current.style.paddingBottom = 0;
            } else {
                bodyRef.current.style.maxHeight = bodyRef.current.scrollHeight + 20 + "px";
                bodyRef.current.style.backgroundColor = "transparent";
                bodyRef.current.style.paddingBottom = "20px";
            }
        }
    };
    (0,react.useEffect)(function() {
        var handleEvent = function(e) {
            if (itemRef && itemRef.current && !itemRef.current.contains(e.target)) {
                setTimeout(function() {
                    setOpen(false);
                    if (bodyRef.current.style.maxHeight) {
                        handleAccordion();
                    }
                }, 100);
            }
        };
        document.addEventListener("mousedown", handleEvent);
        return function() {
            return document.removeEventListener("mousedown", handleEvent);
        };
    }, []);
    var handleOpen = function() {
        setOpen(!open);
        handleAccordion();
    };
    var plusClasses = {
        "true": "".concat((builder_module_default()).plus, " ").concat((builder_module_default()).open),
        "false": "".concat((builder_module_default()).plus)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((builder_module_default()).faq_component_item, " ").concat(customClassNames),
        ref: itemRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (builder_module_default()).faq_title_wrapper,
                style: {
                    backgroundColor: backgroundColor
                },
                onClick: handleOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            fontSize: "".concat(fontSize, "px")
                        },
                        className: (builder_module_default()).faq_title,
                        children: title
                    }),
                    iconType === "arrow" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown12x7Svg */.bD, {
                        className: "".concat((builder_module_default()).arrow_faq_icon, " ").concat(open ? (builder_module_default()).rotated : "")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: plusClasses["".concat(open)]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (builder_module_default()).faq_body,
                ref: bodyRef,
                style: {
                    color: color
                },
                dangerouslySetInnerHTML: {
                    __html: description
                }
            })
        ]
    });
};
/* harmony default export */ var Accordion_AccordionLIst = (AccordionLIst);

// EXTERNAL MODULE: ./components/schemaorg/index.tsx
var schemaorg = __webpack_require__(91257);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/builder/Accordion/index.tsx








var Accordion = function(param) {
    var _item = param.item, id = _item.id, customClassNames = _item.customClassNames, accordionFaq = _item.accordionFaq, tmp = _item.convertedSettings, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.animationAos, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1["data-aos"], dataAos = tmp2 === void 0 ? null : tmp2, _styles = ref.styles, styles = _styles === void 0 ? {} : _styles, _parentStyles = ref.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles, accordionSettings = _item.accordionSettings;
    var schema = (0,schemaorg/* schemaString */.WN)(accordionFaq);
    var faqsRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(schema)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (builder_module_default()).faq_component,
                "data-aos": dataAos,
                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, parentStyles), {
                    margin: styles.margin,
                    padding: styles.padding
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (builder_module_default()).faqs,
                        ref: faqsRef,
                        children: accordionFaq.map(function(faq) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion_AccordionLIst, {
                                styles: styles,
                                faq: faq,
                                customClassNames: customClassNames,
                                accordionSettings: accordionSettings
                            }, faq.id);
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var builder_Accordion = (Accordion);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(81043);
// EXTERNAL MODULE: ./store/general/index.ts + 3 modules
var general = __webpack_require__(26298);
;// CONCATENATED MODULE: ./hooks/useInView.tsx

function useIsInView(ref) {
    var shouldCheck = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var _$ref = (0,react.useState)(false), isInView = _$ref[0], setIsInView = _$ref[1];
    (0,react.useEffect)(function() {
        if (!shouldCheck) {
            setIsInView(true);
            return;
        }
        var handleScroll = function() {
            var _$ref;
            var rect = (_$ref = ref.current) === null || _$ref === void 0 ? void 0 : _$ref.getBoundingClientRect();
            if (rect) {
                var elementTop = rect.top + window.scrollY; // Add scrollY for accurate position
                var elementBottom = elementTop + rect.height;
                var viewportTop = window.scrollY;
                var viewportBottom = viewportTop + window.innerHeight;
                setIsInView(elementTop >= viewportTop && elementBottom <= viewportBottom);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, [
        ref
    ]);
    return isInView || false;
}

// EXTERNAL MODULE: ./components/builder/HoverImage/hoverImage.module.scss
var hoverImage_module = __webpack_require__(78648);
var hoverImage_module_default = /*#__PURE__*/__webpack_require__.n(hoverImage_module);
;// CONCATENATED MODULE: ./components/builder/HoverImage/index.tsx



var HoverImage = function(param) {
    var src = param.src, _css = param.css, css = _css === void 0 ? {} : _css, _className = param.className, className = _className === void 0 ? "" : _className;
    if (!src) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((hoverImage_module_default()).cover, " ").concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: src,
            alt: "hover image",
            loading: "lazy",
            style: css
        })
    });
};
/* harmony default export */ var builder_HoverImage = (HoverImage);

;// CONCATENATED MODULE: ./components/builder/ImageUpload/index.tsx











var ImageUpload = function(param) {
    var _item = param.item, switchValue = _item.switchValue, _linkValue = _item.linkValue, linkValue = _linkValue === void 0 ? "" : _linkValue, linkTarget = _item.linkTarget, customClassNames = _item.customClassNames, tmp = _item.convertedSettings, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.animationAos, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1["data-aos"], dataAos = tmp2 === void 0 ? null : tmp2, _parentStyles = ref.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles, imageSwitchStyles = ref.styles, imageStyles = _item.imageStyles, defaultImage = _item.defaultImage, hoverImage = _item.hoverImage, hoverAnimation = _item.hoverAnimation, isMobile = param.isMobile, lcpElement = param.lcpElement, dbName = param.dbName;
    var ref2 = (0,react.useRef)(null);
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleModalOpen = function() {
        if (switchValue) {
            dispatch((0,general/* setPopupName */.Sq)("zoom_in"));
            dispatch((0,general/* setPopup */.ZA)(true));
            dispatch((0,general/* setBuilderUrl */.dN)(defaultImage));
        }
    };
    var imagePropHandler = {
        "true": {},
        "false": {
            onClick: handleModalOpen
        }
    };
    var LinkLayoutToggle = function(param) {
        var children = param.children;
        var jsxWithLayout = {
            "true": /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: linkValue,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    target: linkTarget,
                    children: children
                })
            }),
            "false": /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: children
            })
        };
        return jsxWithLayout["".concat(!!linkValue)];
    };
    var animationExist = !!dataAos && dataAos !== "none";
    var inView = animationExist ? useIsInView(ref2, !!dataAos) : true;
    var dataAosProp = animationExist ? {
        "data-aos": dataAos
    } : {};
    var handleLcpImageSize = function() {
        if (!lcpElement || !isMobile) return {};
        var ref = (0,_object_spread/* default */.Z)({}, imageSwitchStyles, imageStyles) || {}, _margin = ref.margin, margin = _margin === void 0 ? "" : _margin, _width = ref.width, width = _width === void 0 ? "" : _width;
        if (margin && (!width || width === "unset")) {
            var splittedMargin = margin.split(" ");
            if ((splittedMargin === null || splittedMargin === void 0 ? void 0 : splittedMargin.length) === 1) return {
                width: "calc(100% - ".concat(splittedMargin[0], " - ").concat(splittedMargin[0], ")")
            };
            if ((splittedMargin === null || splittedMargin === void 0 ? void 0 : splittedMargin.length) === 2 || (splittedMargin === null || splittedMargin === void 0 ? void 0 : splittedMargin.length) === 3) {
                return {
                    width: "calc(100% - ".concat(splittedMargin[1], " - ").concat(splittedMargin[1], ")")
                };
            }
            if ((splittedMargin === null || splittedMargin === void 0 ? void 0 : splittedMargin.length) >= 4) {
                var _splittedMargin = (0,_sliced_to_array/* default */.Z)(splittedMargin, 4), _ = _splittedMargin[0], marginRight = _splittedMargin[1], __ = _splittedMargin[2], marginLeft = _splittedMargin[3];
                return {
                    width: "calc(100% - ".concat(marginRight, " - ").concat(marginLeft, ")")
                };
            }
        }
        return {};
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dataAosProp), {
        style: lcpElement && isMobile ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, parentStyles), {
            width: "100%"
        }) : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, parentStyles), {
            position: "relative",
            overflow: "hidden"
        }),
        className: !inView ? "dataAosRef" : "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkLayoutToggle, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(customClassNames, " ").concat((builder_module_default())[hoverAnimation !== null && hoverAnimation !== void 0 ? hoverAnimation : "none"]),
                style: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageSwitchStyles, imageStyles), {
                    maxWidth: "100%",
                    position: "relative"
                }), handleLcpImageSize()),
                ref: ref2,
                children: [
                    lcpElement ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
                        src: defaultImage,
                        alt: "Largest Image",
                        loading: "eager",
                        "data-fetchpriority": "high",
                        width: isMobile ? "500" : "unset",
                        height: isMobile ? "250" : "unset"
                    }, imagePropHandler["".concat(!!linkValue)])) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
                        src: defaultImage,
                        alt: "builder image",
                        loading: "lazy",
                        style: (0,_object_spread/* default */.Z)({}, imageSwitchStyles, imageStyles)
                    }, imagePropHandler["".concat(!!linkValue)])),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_HoverImage, {
                        src: hoverImage,
                        css: (0,_object_spread/* default */.Z)({}, imageSwitchStyles, imageStyles)
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var builder_ImageUpload = (ImageUpload);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./components/builder/SliderComponent/builder_slider.module.scss
var builder_slider_module = __webpack_require__(17478);
var builder_slider_module_default = /*#__PURE__*/__webpack_require__.n(builder_slider_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/builder/SliderComponent/index.tsx









var SliderComponent = function(_param) {
    var _item = _param.item, styles = _item.convertedSettings.styles, item = (0,_object_without_properties/* default */.Z)(_param.item, [
        "convertedSettings"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((builder_slider_module_default()).slider, " ").concat(item.customClassNames),
        "data-aos": item.slider.settings.animation,
        style: {
            height: item.slider.settings.height,
            margin: styles === null || styles === void 0 ? void 0 : styles.margin,
            padding: styles === null || styles === void 0 ? void 0 : styles.padding
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item.slider.settings), {
            nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* SliderNextArrow */.QY, {}),
            prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* SliderPrevArrow */.DY, {}),
            children: item.slider.slides.map(function(slide) {
                var _content = slide.content, _title = _content.title, title = _title === void 0 ? "" : _title, _description = _content.description, description = _description === void 0 ? "" : _description, _buttonText = _content.buttonText, buttonText = _buttonText === void 0 ? "" : _buttonText, _link = _content.link, link = _link === void 0 ? "" : _link, showDescription = _content.showDescription, buttonLinkTarget = _content.buttonLinkTarget, showButtonText = _content.showButtonText;
                var _style = slide.style, contentAnimation = _style.contentAnimation, contentColor = _style.contentColor, horizontal = _style.horizontal, vertical = _style.vertical, textAlign = _style.textAlign;
                var ShowDesc = function() {
                    var descHandler = {
                        "Desc": /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (builder_slider_module_default()).content_description,
                            children: description
                        }),
                        "Empty": null
                    };
                    return descHandler[showDescription];
                };
                var ShowBtn = function() {
                    var btnHandler = {
                        "BtnText": /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: link,
                            target: buttonLinkTarget,
                            className: (builder_slider_module_default()).content_button,
                            children: buttonText
                        }),
                        "Empty": null
                    };
                    return btnHandler[showButtonText];
                };
                var SlideWrapper = function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (builder_slider_module_default()).slide_wrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                alt: "slider image",
                                "aria-hidden": "true",
                                width: 500,
                                height: 500,
                                src: slide.slider_path
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (builder_slider_module_default()).content_wrapper,
                                style: {
                                    justifyContent: horizontal,
                                    alignItems: vertical
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (builder_slider_module_default()).content,
                                    "data-aos": contentAnimation,
                                    style: {
                                        color: contentColor,
                                        alignItems: textAlign
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (builder_slider_module_default()).content_title,
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowDesc, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowBtn, {})
                                    ]
                                })
                            })
                        ]
                    });
                };
                return showButtonText === "Empty" && link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (builder_slider_module_default()).slide_link,
                    href: link,
                    target: buttonLinkTarget,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideWrapper, {})
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideWrapper, {});
            })
        }))
    });
};
/* harmony default export */ var builder_SliderComponent = (SliderComponent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./components/shared/ProductCard/helpers.ts
var helpers = __webpack_require__(77458);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./store/cart/index.ts + 2 modules
var cart = __webpack_require__(7597);
// EXTERNAL MODULE: ./api/shop.ts + 1 modules
var shop = __webpack_require__(65564);
// EXTERNAL MODULE: ./components/builder/Button/FormModal/index.tsx
var FormModal = __webpack_require__(44487);
// EXTERNAL MODULE: ./store/formbuilder/index.ts + 3 modules
var formbuilder = __webpack_require__(11428);
;// CONCATENATED MODULE: ./components/builder/Button/index.tsx
















var Button = function(param) {
    var _item = param.item, buttonType = _item.buttonType, _buttonValue = _item.buttonValue, buttonValue = _buttonValue === void 0 ? "" : _buttonValue, icon = _item.icon, _iconPosition = _item.iconPosition, iconPosition = _iconPosition === void 0 ? "first" : _iconPosition, linkValue = _item.linkValue, targeting = _item.targeting, customClassNames = _item.customClassNames, productForBuyNow = _item.productForBuyNow, hoverSettings = _item.hoverSettings, tmp = _item.convertedSettings, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.animationAos, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1["data-aos"], dataAos = tmp2 === void 0 ? null : tmp2, _styles = ref.styles, styles = _styles === void 0 ? {} : _styles, _parentStyles = ref.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles, hoverAnimation = _item.hoverAnimation, formComponentInfo = _item.formComponentInfo, _selectedLocale = param.selectedLocale, selectedLocale = _selectedLocale === void 0 ? "" : _selectedLocale, _backOrderValue = param.backOrderValue, backOrderValue = _backOrderValue === void 0 ? "" : _backOrderValue, tmp3 = param.currencies, ref2 = (0,_sliced_to_array/* default */.Z)(tmp3 === void 0 ? [] : tmp3, 1), tmp4 = ref2[0], ref3 = tmp4 === void 0 ? {} : tmp4, tmp5 = ref3.code, selectedCurrCode = tmp5 === void 0 ? "" : tmp5, tmp6 = ref3.symbol, selectedCurrSymbol = tmp6 === void 0 ? "" : tmp6, tmp7 = ref3.exchange_rate, ref4 = tmp7 === void 0 ? {} : tmp7, tmp8 = ref4.rate, selectedCurrRate = tmp8 === void 0 ? "1" : tmp8, recaptchaActive = param.recaptchaActive;
    var ref5 = productForBuyNow || {}, tmp9 = ref5.qty, ref6 = (0,_sliced_to_array/* default */.Z)(tmp9 === void 0 ? [] : tmp9, 1), tmp10 = ref6[0], productQuantity = tmp10 === void 0 ? 0 : tmp10, tmp11 = ref5.id, productId = tmp11 === void 0 ? 0 : tmp11, tmp12 = ref5.flats, ref7 = (0,_sliced_to_array/* default */.Z)(tmp12 === void 0 ? [] : tmp12, 1), tmp13 = ref7[0], ref8 = tmp13 === void 0 ? {} : tmp13, _min_qty = ref8.min_qty, min_qty = _min_qty === void 0 ? 1 : _min_qty, _has_up_sell = ref8.has_up_sell, has_up_sell = _has_up_sell === void 0 ? 0 : _has_up_sell, _has_cross_sell = ref8.has_cross_sell, has_cross_sell = _has_cross_sell === void 0 ? 0 : _has_cross_sell, _url_key = ref8.url_key, url_key = _url_key === void 0 ? "" : _url_key, tmp14 = ref5.type, productType = tmp14 === void 0 ? "" : tmp14;
    var ref9 = (0,react.useState)(false), isHovered = ref9[0], setIsHovered = ref9[1];
    var cartToken = (0,es/* useSelector */.v9)(function(state) {
        return state.cartToken;
    });
    var customer = (0,es/* useSelector */.v9)(function(state) {
        return state.customer;
    });
    var popupOpen = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.popup_open;
    });
    var stylesFromBuilder = isHovered ? (0,_object_spread/* default */.Z)({}, styles, hoverSettings) : styles;
    var linkStyles = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, stylesFromBuilder), {
        display: "flex",
        cursor: "pointer",
        alignItems: "center",
        justifyContent: "center",
        gap: icon && buttonValue ? "5px" : "0",
        width: styles.width === "unset" ? "max-content" : styles.width,
        flexDirection: iconPosition === "second" ? "row-reverse" : "row"
    });
    var buyNowStyles = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, stylesFromBuilder), {
        display: "flex",
        cursor: "pointer",
        alignItems: "center",
        justifyContent: "center",
        gap: icon && buttonValue ? "5px" : "0",
        flexDirection: iconPosition === "second" ? "row-reverse" : "row"
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref10 = (0,router.useRouter)(), routerPush = ref10.push;
    var isProductInStock = productQuantity > 0 || !!parseFloat(backOrderValue);
    var cartDataObj = {
        product: productForBuyNow,
        quantity: 1,
        cartToken: cartToken,
        customer: customer,
        selectedLocale: selectedLocale,
        selectedCurrCode: selectedCurrCode,
        optionsObject: null,
        addToast: function() {}
    };
    var upCrossSellHandle = {
        "true": {
            "true": function() {
                dispatch((0,general/* setPopupName */.Sq)("upsell"));
                dispatch((0,cart/* getUpOrCrossProd */.xM)(productId, "up-sell", selectedLocale, {
                    exchange_rate: {
                        rate: selectedCurrRate
                    },
                    symbol: selectedCurrSymbol,
                    code: selectedCurrCode
                }));
                dispatch((0,general/* setTempData */.LH)([
                    productForBuyNow
                ]));
            },
            "false": function() {
                return upCrossSellHandle["true"]["true"]();
            }
        },
        "false": {
            "true": function() {
                dispatch((0,cart/* getUpOrCrossProd */.xM)(productId, "cross-sell", selectedLocale, {
                    exchange_rate: {
                        rate: selectedCurrRate
                    },
                    symbol: selectedCurrSymbol,
                    code: selectedCurrCode
                }));
                dispatch((0,general/* setCrossValid */.TV)(true));
                dispatch((0,general/* setPopupName */.Sq)("crossSell"));
                dispatch((0,general/* setTempData */.LH)([
                    productForBuyNow
                ]));
            },
            "false": function() {}
        }
    };
    var openUpCrossProd = function() {
        return upCrossSellHandle["".concat(!!parseFloat(has_up_sell))]["".concat(!!parseFloat(has_cross_sell))]();
    };
    var handleBuyNow = function(e) {
        e.preventDefault();
        shop["default"].getEmptyCart(customer.authenticated, customer.token, cartToken.cartToken).then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(res) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!res.message) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0,_async_to_generator/* default */.Z)(function() {
                                    var addItemCallback;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                addItemCallback = function() {
                                                    return cart/* cartAddItem.apply */.rg.apply(null, Object.values(cartDataObj));
                                                };
                                                if (!(isProductInStock && min_qty <= 1 && productType !== "downloadable")) return [
                                                    3,
                                                    5
                                                ];
                                                if (!has_up_sell) return [
                                                    3,
                                                    1
                                                ];
                                                openUpCrossProd();
                                                return [
                                                    2
                                                ];
                                            case 1:
                                                if (!has_cross_sell) return [
                                                    3,
                                                    3
                                                ];
                                                openUpCrossProd();
                                                (0,helpers/* addToCartEventPixel */.Gg)(productForBuyNow, 1, {
                                                    code: selectedCurrCode
                                                });
                                                dispatch(addItemCallback());
                                                return [
                                                    4,
                                                    routerPush("/checkout")
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                            case 3:
                                                (0,helpers/* addToCartEventPixel */.Gg)(productForBuyNow, 1, {
                                                    code: selectedCurrCode
                                                });
                                                dispatch(addItemCallback());
                                                return [
                                                    4,
                                                    routerPush("/checkout")
                                                ];
                                            case 4:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                            case 5:
                                                return [
                                                    4,
                                                    routerPush("/".concat(url_key))
                                                ];
                                            case 6:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                })()
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(res) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    var ButtonTypeChecker = function() {
        var IconGlobal = function() {
            if (!icon) return null;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "builder-button",
                dangerouslySetInnerHTML: {
                    __html: icon
                }
            });
        };
        var TextInside = function() {
            if (!linkValue && buttonType !== "Buy now") return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: buttonValue
            });
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: buttonValue
            });
        };
        var CompareInfo = /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconGlobal, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInside, {})
            ]
        });
        var commonProps = {
            className: "".concat(customClassNames, " ").concat((builder_module_default())[hoverAnimation !== null && hoverAnimation !== void 0 ? hoverAnimation : "none"]),
            children: CompareInfo
        };
        if (buttonType === "Buy now") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonProps), {
                style: buyNowStyles,
                onClick: handleBuyNow,
                onMouseEnter: function() {
                    return setIsHovered(true);
                },
                onMouseLeave: function() {
                    return setIsHovered(false);
                }
            }));
        } else if (linkValue) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonProps), {
                style: linkStyles,
                href: linkValue,
                rel: "noreferrer",
                target: targeting,
                onMouseEnter: function() {
                    return setIsHovered(true);
                },
                onMouseLeave: function() {
                    return setIsHovered(false);
                }
            }));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, commonProps), {
            style: linkStyles,
            onMouseEnter: function() {
                return setIsHovered(true);
            },
            onMouseLeave: function() {
                return setIsHovered(false);
            }
        }), buttonType === "Form" ? {
            onClick: function() {
                return dispatch((0,formbuilder/* setFormPopupOpen */.YK)({
                    id: formComponentInfo === null || formComponentInfo === void 0 ? void 0 : formComponentInfo.data.id,
                    open: true
                }));
            }
        } : {}));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-aos": dataAos,
        style: parentStyles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTypeChecker, {}),
            formComponentInfo && popupOpen.open && popupOpen.id === formComponentInfo.data.id ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FormModal/* default */.Z, {
                form: {
                    formComponentInfo: formComponentInfo,
                    customClassNames: customClassNames
                },
                recaptchaActive: recaptchaActive
            }) : null
        ]
    });
};
/* harmony default export */ var builder_Button = (Button);

;// CONCATENATED MODULE: ./components/builder/Video/index.tsx




var Video = function(props) {
    var _item = props.item, customClassNames = _item.customClassNames, tmp = _item.convertedSettings, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.animationAos, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1["data-aos"], dataAos = tmp2 === void 0 ? null : tmp2, _styles = ref.styles, styles = _styles === void 0 ? {} : _styles, _parentStyles = ref.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles, videoLink = _item.videoLink, hoverAnimation = _item.hoverAnimation, hideElements = _item.hideElements;
    var ref2 = (0,react.useState)(null), showIframe = ref2[0], setShowIframe = ref2[1];
    var pointerEventHandle = hideElements ? {
        pointerEvents: "none"
    } : {};
    (0,react.useEffect)(function() {
        setShowIframe(/*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            title: "video",
            src: videoLink,
            loading: "lazy",
            allow: "autoplay",
            width: "100%",
            height: (styles === null || styles === void 0 ? void 0 : styles.height) || "200px",
            style: (0,_object_spread/* default */.Z)({
                border: "none",
                padding: styles === null || styles === void 0 ? void 0 : styles.padding
            }, pointerEventHandle),
            className: "".concat(customClassNames, " ").concat((builder_module_default())[hoverAnimation !== null && hoverAnimation !== void 0 ? hoverAnimation : "none"])
        }));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-aos": dataAos,
        style: (0,_object_spread/* default */.Z)({
            margin: styles === null || styles === void 0 ? void 0 : styles.margin
        }, parentStyles),
        children: showIframe
    });
};
/* harmony default export */ var builder_Video = (/*#__PURE__*/(0,react.memo)(Video));

// EXTERNAL MODULE: ./components/posts/posts.module.scss
var posts_module = __webpack_require__(30406);
var posts_module_default = /*#__PURE__*/__webpack_require__.n(posts_module);
// EXTERNAL MODULE: ./components/posts/PostCard.tsx
var PostCard = __webpack_require__(73519);
;// CONCATENATED MODULE: ./components/builder/PostsComponent/index.tsx





var PostsComponent = function(param) {
    var _item = param.item, customClassNames = _item.customClassNames, tmp = _item.postComponentInfo, renderedPosts = tmp === void 0 ? [] : tmp, qtyPerRow = _item.qtyPerRow, date_checked = _item.date_checked, read_more_checked = _item.read_more_checked, tmp1 = _item.convertedSettings, ref = tmp1 === void 0 ? {} : tmp1, styles = ref.styles, tmp2 = ref.animationAos, ref1 = tmp2 === void 0 ? {} : tmp2, tmp3 = ref1["data-aos"], dataAos = tmp3 === void 0 ? null : tmp3, hoverAnimation = _item.hoverAnimation, translationsData = param.translationsData;
    var postsList = renderedPosts === null || renderedPosts === void 0 ? void 0 : renderedPosts.map(function(post) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (posts_module_default()).post_list_item,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostCard/* default */.Z, {
                post: post,
                category: post.default_category,
                translationsData: translationsData,
                date_checked: date_checked,
                read_more_checked: read_more_checked
            })
        }, post.id);
    });
    var viewPosts = {
        true: postsList,
        false: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "\n            ".concat((posts_module_default()).posts_list, "\n            ").concat(customClassNames, "\n            ").concat((builder_module_default())[hoverAnimation !== null && hoverAnimation !== void 0 ? hoverAnimation : "none"], "\n            ").concat((posts_module_default())["posts_list_row_".concat(qtyPerRow)], "\n        "),
        "data-aos": dataAos,
        style: {
            margin: styles === null || styles === void 0 ? void 0 : styles.margin,
            padding: styles === null || styles === void 0 ? void 0 : styles.padding
        },
        children: viewPosts["".concat(!!(postsList === null || postsList === void 0 ? void 0 : postsList.length))]
    });
};
/* harmony default export */ var builder_PostsComponent = (PostsComponent);

// EXTERNAL MODULE: ./components/builder/FormBuilderComponent/index.tsx + 13 modules
var FormBuilderComponent = __webpack_require__(22978);
// EXTERNAL MODULE: ./components/builder/CarouselComponent/builder_carousel.module.scss
var builder_carousel_module = __webpack_require__(62314);
var builder_carousel_module_default = /*#__PURE__*/__webpack_require__.n(builder_carousel_module);
;// CONCATENATED MODULE: ./components/builder/CarouselComponent/CarouselCards/ImageBoxCard.tsx




var ImageBoxCard = function(param) {
    var card = param.card, eventListeners = param.eventListeners;
    var _image_path = card.image_path, image_path = _image_path === void 0 ? "" : _image_path, _hover_path = card.hover_path, hover_path = _hover_path === void 0 ? "" : _hover_path, _title = card.title, title = _title === void 0 ? "" : _title, _buttonContent = card.buttonContent, buttonContent = _buttonContent === void 0 ? "" : _buttonContent, _linkValue = card.linkValue, linkValue = _linkValue === void 0 ? "" : _linkValue, _targeting = card.targeting, targeting = _targeting === void 0 ? "" : _targeting;
    var contentStyle = eventListeners.contentStyle, buttonStyle = eventListeners.buttonStyle, onMouseOver = eventListeners.onMouseOver, onMouseOut = eventListeners.onMouseOut, onMouseOverButton = eventListeners.onMouseOverButton, onMouseOutButton = eventListeners.onMouseOutButton;
    var handleButton = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: (builder_carousel_module_default()).carousel_card_button,
            style: buttonStyle,
            onMouseOver: function(e) {
                return onMouseOverButton(e, "button");
            },
            onMouseOut: function(e) {
                return onMouseOutButton(e, "button");
            },
            children: buttonContent
        }),
        false: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    };
    var CarouselItem = function(param) {
        var children = param.children;
        if (linkValue) return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: linkValue,
            target: targeting,
            rel: "noreferrer",
            children: children
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: children
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (builder_carousel_module_default()).carousel_card_wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselItem, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (builder_carousel_module_default()).carousel_card,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (builder_carousel_module_default()).carousel_card_image_wrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "carousel card image",
                                "aria-hidden": "true",
                                src: image_path
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_HoverImage, {
                                src: hover_path,
                                className: (builder_carousel_module_default()).carousel_card_hover
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (builder_carousel_module_default()).carousel_card_content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (builder_carousel_module_default()).carousel_card_title,
                                style: contentStyle,
                                onMouseOver: onMouseOver,
                                onMouseOut: onMouseOut,
                                children: title
                            }),
                            handleButton["".concat(!!buttonContent)]
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var CarouselCards_ImageBoxCard = (ImageBoxCard);

;// CONCATENATED MODULE: ./images/default_user.png
/* harmony default export */ var default_user = ({"src":"/_next/static/media/default_user.31c2414b.png","height":120,"width":120,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAdUlEQVR42h2NsQmFQBBEt52txiq+DfxQMDSwCjNtYzEWTBXvPDG/VNxkHOXBg3nJiEjUYNGj0yrfzAkrSQiZKVjCdDdoaCaTzU8M+JEBJzZnODCjJTMOMOy2YLx79PSC3eTSLpf4kxJdvt6fQmurvPLaChV5APghXldMxIfSAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/builder/CarouselComponent/CarouselCards/TestimonialCard.tsx





var TestimonialCard = function(param) {
    var card = param.card, eventListeners = param.eventListeners;
    var _rate = card.rate, rate = _rate === void 0 ? 0 : _rate, _title = card.title, title = _title === void 0 ? "" : _title, _description = card.description, description = _description === void 0 ? "" : _description, _buttonContent = card.buttonContent, buttonContent = _buttonContent === void 0 ? "" : _buttonContent, _linkValue = card.linkValue, linkValue = _linkValue === void 0 ? "" : _linkValue, _targeting = card.targeting, targeting = _targeting === void 0 ? "" : _targeting, _image_path = card.image_path, image_path = _image_path === void 0 ? "" : _image_path;
    var stars = new Array(5).fill(1);
    var contentStyle = eventListeners.contentStyle, buttonStyle = eventListeners.buttonStyle, onMouseOver = eventListeners.onMouseOver, onMouseOut = eventListeners.onMouseOut, onMouseOverButton = eventListeners.onMouseOverButton, onMouseOutButton = eventListeners.onMouseOutButton;
    var handleButton = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: (builder_carousel_module_default()).carousel_card_button,
            style: buttonStyle,
            onMouseOver: function(e) {
                return onMouseOverButton(e, "button");
            },
            onMouseOut: function(e) {
                return onMouseOutButton(e, "button");
            },
            children: buttonContent
        }),
        false: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    };
    var TestimonialItem = function(param) {
        var children = param.children;
        if (linkValue) return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: linkValue,
            target: targeting,
            rel: "noreferrer",
            children: children
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: children
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (builder_carousel_module_default()).carousel_card_wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialItem, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (builder_carousel_module_default()).carousel_card,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((builder_carousel_module_default()).carousel_card_content, " ").concat((builder_carousel_module_default()).testimonials),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (builder_carousel_module_default()).carousel_card_image,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "title",
                                src: image_path || default_user.src,
                                "aria-hidden": "true"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (builder_carousel_module_default()).carousel_card_title,
                            style: contentStyle,
                            onMouseOver: onMouseOver,
                            onMouseOut: onMouseOut,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (builder_carousel_module_default()).carousel_card_description,
                            style: contentStyle,
                            onMouseOver: onMouseOver,
                            onMouseOut: onMouseOut,
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (builder_carousel_module_default()).rate_wrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (builder_carousel_module_default()).rating,
                                children: stars.map(function(el, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ReviewStar */.kG, {
                                        id: index + 1,
                                        className: "".concat(index + 1 <= rate ? (builder_carousel_module_default()).checked : "")
                                    });
                                })
                            })
                        }),
                        handleButton["".concat(!!buttonContent)]
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var CarouselCards_TestimonialCard = (TestimonialCard);

;// CONCATENATED MODULE: ./components/builder/CarouselComponent/CarouselCards/BrandListCard.tsx




var BrandListCard = function(param) {
    var card = param.card;
    var _image_path = card.image_path, image_path = _image_path === void 0 ? "" : _image_path, _linkValue = card.linkValue, linkValue = _linkValue === void 0 ? "" : _linkValue, _targeting = card.targeting, targeting = _targeting === void 0 ? "" : _targeting, _hover_path = card.hover_path, hover_path = _hover_path === void 0 ? "" : _hover_path, _title = card.title, title = _title === void 0 ? "" : _title;
    var BrandListChild = function(param) {
        var children = param.children;
        if (linkValue) return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: linkValue,
            target: targeting,
            rel: "noreferrer",
            children: children
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: children
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (builder_carousel_module_default()).carousel_card_wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandListChild, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (builder_carousel_module_default()).carousel_card,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (builder_carousel_module_default()).carousel_card_image_wrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "carousel card image",
                                "aria-hidden": "true",
                                src: image_path
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_HoverImage, {
                                src: hover_path,
                                className: (builder_carousel_module_default()).carousel_card_hover
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (builder_carousel_module_default()).brand_title,
                children: title
            })
        ]
    });
};
/* harmony default export */ var CarouselCards_BrandListCard = (BrandListCard);

;// CONCATENATED MODULE: ./components/builder/CarouselComponent/index.tsx









var NextArrow = function(param) {
    var onClick = param.onClick, color = param.color, backgroundColor = param.backgroundColor, type = param.type, _eventListeners = param.eventListeners, onMouseOverButton = _eventListeners.onMouseOverButton, onMouseOutButton = _eventListeners.onMouseOutButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((builder_carousel_module_default()).slick_arrow_wrapper, " ").concat((builder_carousel_module_default()).next),
        onClick: onClick,
        onMouseOver: function(e) {
            return onMouseOverButton(e, "svg");
        },
        onMouseOut: function(e) {
            return onMouseOutButton(e, "svg");
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                type !== "BrandList" && /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "32",
                    height: "32",
                    rx: "16",
                    fill: backgroundColor
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13 22L19 16L13 10",
                    stroke: color,
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                })
            ]
        })
    });
};
var PrevArrow = function(param) {
    var onClick = param.onClick, color = param.color, backgroundColor = param.backgroundColor, type = param.type, _eventListeners = param.eventListeners, onMouseOverButton = _eventListeners.onMouseOverButton, onMouseOutButton = _eventListeners.onMouseOutButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((builder_carousel_module_default()).slick_arrow_wrapper, " ").concat((builder_carousel_module_default()).prev),
        onClick: onClick,
        onMouseOver: function(e) {
            return onMouseOverButton(e, "svg");
        },
        onMouseOut: function(e) {
            return onMouseOutButton(e, "svg");
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                type !== "BrandList" && /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "32",
                    height: "32",
                    rx: "16",
                    fill: backgroundColor
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M19 22L13 16L19 10",
                    stroke: color,
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                })
            ]
        })
    });
};
var Carousel = function(param) {
    var item = param.item;
    var _content = item.content, content = _content === void 0 ? "" : _content, customClassNames = item.customClassNames, tmp = item.convertedSettings, ref = tmp === void 0 ? {} : tmp, _styles = ref.styles, styles = _styles === void 0 ? {} : _styles, _carousel = item.carousel, _cards = _carousel.cards, cards = _cards === void 0 ? [
        {}
    ] : _cards, _settings = _carousel.settings, animation = _settings.animation, contentColor = _settings.contentColor, contentHoverColor = _settings.contentHoverColor, buttonFontColor = _settings.buttonFontColor, buttonBgColor = _settings.buttonBgColor, buttonHoverFontColor = _settings.buttonHoverFontColor, buttonHoverBgColor = _settings.buttonHoverBgColor, slidesToShowDesk = _settings.slidesToShowDesk, slidesToShowMobile = _settings.slidesToShowMobile;
    var slidesToShow = content === "BrandList" ? slidesToShowDesk ? slidesToShowDesk : 6 : 3;
    var slidesToShow991 = content === "BrandList" ? slidesToShowMobile ? slidesToShowMobile : 4 : 2;
    var slidesToShow460 = content === "BrandList" ? slidesToShowMobile ? slidesToShowMobile : 2 : 1;
    var carouselSettings = {
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: slidesToShow991
                }
            },
            {
                breakpoint: 460,
                settings: {
                    slidesToShow: slidesToShow460
                }
            }
        ]
    };
    var onMouseOver = function(e) {
        e.target.style.color = contentHoverColor;
    };
    var onMouseOut = function(e) {
        e.target.style.color = contentColor;
    };
    var onMouseOverButton = function(e, type) {
        if (type === "svg") {
            if (content === "BrandList") {
                e.target.children[0].children[0].style.stroke = buttonHoverFontColor;
            } else {
                e.target.children[0].children[0].style.fill = buttonHoverBgColor;
                e.target.children[0].children[1].style.stroke = buttonHoverFontColor;
            }
        } else {
            e.target.style.backgroundColor = buttonHoverBgColor;
            e.target.style.color = buttonHoverFontColor;
        }
    };
    var onMouseOutButton = function(e, type) {
        if (type === "svg") {
            if (content === "BrandList") {
                e.target.children[0].children[0].style.stroke = buttonFontColor;
            } else {
                e.target.children[0].children[0].style.fill = buttonBgColor;
                e.target.children[0].children[1].style.stroke = buttonFontColor;
            }
        } else {
            e.target.style.backgroundColor = buttonBgColor;
            e.target.style.color = buttonFontColor;
        }
    };
    var eventListeners = {
        contentStyle: {
            color: contentColor
        },
        buttonStyle: {
            color: buttonFontColor,
            backgroundColor: buttonBgColor
        },
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseOverButton: onMouseOverButton,
        onMouseOutButton: onMouseOutButton
    };
    var handleCarouselByType = function(card) {
        return {
            "ImageBox": /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselCards_ImageBoxCard, {
                card: card,
                eventListeners: eventListeners
            }),
            "Testimonials": /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselCards_TestimonialCard, {
                card: card,
                eventListeners: eventListeners
            }),
            "BrandList": /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselCards_BrandListCard, {
                card: card
            })
        };
    };
    var addFakeItems = function(items) {
        var fakeItemsQty = slidesToShow - items.length;
        var fakeItemsArray = [];
        for(var i = 0; i < fakeItemsQty; i++){
            fakeItemsArray.push(i);
        }
        return fakeItemsArray.map(function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (builder_carousel_module_default()).carousel_card_wrapper
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((builder_carousel_module_default()).carousel, " ").concat(customClassNames),
        "data-aos": animation,
        style: {
            margin: styles === null || styles === void 0 ? void 0 : styles.margin,
            padding: styles === null || styles === void 0 ? void 0 : styles.padding,
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, carouselSettings), {
            nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextArrow, {
                eventListeners: eventListeners,
                color: buttonFontColor,
                backgroundColor: buttonBgColor,
                type: content
            }),
            prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevArrow, {
                eventListeners: eventListeners,
                color: buttonFontColor,
                backgroundColor: buttonBgColor,
                type: content
            }),
            children: [
                cards.map(function(card) {
                    return handleCarouselByType(card)[content];
                }),
                addFakeItems(cards)
            ]
        }))
    });
};
/* harmony default export */ var CarouselComponent = (Carousel);

// EXTERNAL MODULE: ./components/ForCWV/Products/ProductCard.tsx
var ProductCard = __webpack_require__(84937);
// EXTERNAL MODULE: ./components/ForCWV/Products/products.module.scss
var products_module = __webpack_require__(31351);
var products_module_default = /*#__PURE__*/__webpack_require__.n(products_module);
// EXTERNAL MODULE: ./components/ForCWV/Products/BlockHeader/index.tsx
var BlockHeader = __webpack_require__(98503);
;// CONCATENATED MODULE: ./components/builder/ProductList/index.tsx











var Index = function(_param) {
    var tmp = _param.item, ref = tmp === void 0 ? {} : tmp, tmp1 = ref.productListComponentInfo, ref1 = tmp1 === void 0 ? {} : tmp1, _products = ref1.products, products = _products === void 0 ? [] : _products, _block_title = ref1.block_title, block_title = _block_title === void 0 ? "" : _block_title, showAsSlider = ref1.showAsSlider, _showProductListCls = ref.showProductListCls, showProductListCls = _showProductListCls === void 0 ? "" : _showProductListCls, tmp2 = ref.convertedSettings, ref2 = tmp2 === void 0 ? {} : tmp2, tmp3 = ref2.animationAos, ref3 = tmp3 === void 0 ? {} : tmp3, tmp4 = ref3["data-aos"], dataAos = tmp4 === void 0 ? "none" : tmp4, customClassNames = ref.customClassNames, hoverAnimation = ref.hoverAnimation, isMobile = _param.isMobile, pageProps = (0,_object_without_properties/* default */.Z)(_param, [
        "item",
        "isMobile"
    ]);
    var ref4 = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(false), originalProducts = ref5[0], setOriginalProducts = ref5[1];
    var handleBlockTitle = {
        true: {
            true: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockHeader/* default */.Z, {
                    title: block_title
                })
            }),
            false: null
        },
        false: {
            true: null,
            false: null
        }
    };
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (ref4 && ref4.current) {
                var ref;
                setOriginalProducts(window.scrollY >= ((ref = ref4.current) === null || ref === void 0 ? void 0 : ref.offsetTop) - 2);
            }
        };
        if (!originalProducts && isMobile) {
            window.addEventListener("scroll", handleScroll);
        } else {
            window.removeEventListener("scroll", handleScroll);
        }
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    var sliderResponsiveSettings = {
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }, 
        ]
    };
    var displayedProducts = isMobile && !originalProducts ? products.filter(function(_, index) {
        return index < 4;
    }) : products;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-aos": dataAos,
        className: "".concat(customClassNames, " ").concat((builder_module_default())[hoverAnimation !== null && hoverAnimation !== void 0 ? hoverAnimation : "none"]),
        children: [
            handleBlockTitle["".concat(!!products.length)]["".concat(!!block_title)],
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (products_module_default())["block-products__body"],
                children: showAsSlider && displayedProducts.length > 4 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (products_module_default()).product_list__slider,
                        style: {
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            dots: true,
                            arrows: true,
                            infinite: false,
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CarouselArrowNext */.fL, {}),
                            prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CarouselArrowPrev */.j9, {})
                        }, sliderResponsiveSettings), {
                            children: displayedProducts.map(function(product, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        minHeight: 200
                                    },
                                    className: (products_module_default())["product-card-parent"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: !originalProducts ? ref4 : null,
                                        className: (products_module_default())["block-products__list-item"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, (0,_object_spread/* default */.Z)({
                                            product: product,
                                            priority: index < 2
                                        }, pageProps))
                                    })
                                }, product.id);
                            })
                        }))
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (products_module_default())["block-products__list"],
                    children: displayedProducts.map(function(product, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                minHeight: 200
                            },
                            className: (products_module_default())["product-card-parent"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: !originalProducts ? ref4 : null,
                                className: (products_module_default())["block-products__list-item"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, (0,_object_spread/* default */.Z)({
                                    product: product,
                                    priority: index < 2
                                }, pageProps))
                            })
                        }, product.id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ProductList = (Index);

// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
;// CONCATENATED MODULE: ./components/builder/CountUp/index.tsx




var CountUpComponent = function(param) {
    var tmp = param.item, ref = tmp === void 0 ? {} : tmp, customClassNames = ref.customClassNames, tmp1 = ref.countUpSettings, ref1 = tmp1 === void 0 ? {} : tmp1, _start = ref1.start, start = _start === void 0 ? 0 : _start, _end = ref1.end, end = _end === void 0 ? 1000 : _end, _fontSize = ref1.fontSize, fontSize = _fontSize === void 0 ? 16 : _fontSize, _fontWeight = ref1.fontWeight, fontWeight = _fontWeight === void 0 ? 400 : _fontWeight, _color = ref1.color, color = _color === void 0 ? "#000" : _color, _delay = ref1.delay, delay = _delay === void 0 ? 0 : _delay, _duration = ref1.duration, duration = _duration === void 0 ? 2 : _duration, _prefix = ref1.prefix, prefix = _prefix === void 0 ? "" : _prefix, _suffix = ref1.suffix, suffix = _suffix === void 0 ? "" : _suffix, _scrollSpyDelay = ref1.scrollSpyDelay, scrollSpyDelay = _scrollSpyDelay === void 0 ? 500 : _scrollSpyDelay, _enableScrollSpy = ref1.enableScrollSpy, enableScrollSpy = _enableScrollSpy === void 0 ? false : _enableScrollSpy, _useGrouping = ref1.useGrouping, useGrouping = _useGrouping === void 0 ? false : _useGrouping, _useEasing = ref1.useEasing, useEasing = _useEasing === void 0 ? false : _useEasing, tmp2 = ref.convertedSettings, ref2 = tmp2 === void 0 ? {} : tmp2, tmp3 = ref2.animationAos, ref3 = tmp3 === void 0 ? {} : tmp3, tmp4 = ref3["data-aos"], dataAos = tmp4 === void 0 ? null : tmp4, _parentStyles = ref2.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles, styles = ref2.styles, hoverAnimation = ref.hoverAnimation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "count_up",
        "data-aos": dataAos,
        style: parentStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(customClassNames, " ").concat((builder_module_default())[hoverAnimation !== null && hoverAnimation !== void 0 ? hoverAnimation : "none"]),
            style: styles,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                style: {
                    fontSize: "".concat(fontSize, "px"),
                    fontWeight: fontWeight,
                    color: color
                },
                start: start,
                end: end,
                delay: delay,
                duration: duration,
                prefix: prefix,
                suffix: suffix,
                scrollSpyDelay: scrollSpyDelay,
                enableScrollSpy: enableScrollSpy,
                useGrouping: useGrouping,
                useEasing: useEasing,
                redraw: true
            })
        })
    });
};
/* harmony default export */ var CountUp = (CountUpComponent);

// EXTERNAL MODULE: ./node_modules/react-responsive-masonry/es/index.js + 2 modules
var react_responsive_masonry_es = __webpack_require__(2337);
// EXTERNAL MODULE: ./components/ForCWV/InnerPageProduct/NewPhotoSwipe.tsx
var NewPhotoSwipe = __webpack_require__(3024);
;// CONCATENATED MODULE: ./components/builder/Masonry/index.tsx






var MasonryComponent = function(param) {
    var item = param.item;
    var customClassNames = item.customClassNames, tmp = item.convertedSettings, ref = tmp === void 0 ? {} : tmp, _styles = ref.styles, styles = _styles === void 0 ? {} : _styles, _masonry = item.masonry, _images = _masonry.images, images = _images === void 0 ? [
        {}
    ] : _images, _settings = _masonry.settings, animation = _settings.animation, desktopColumns = _settings.desktopColumns, tabletColumns = _settings.tabletColumns, mobileColumns = _settings.mobileColumns, zoom = _settings.zoom, gap = _settings.gap;
    var ref1 = (0,react.useState)(0), loadedCount = ref1[0], setLoadedCount = ref1[1];
    var allLoaded = loadedCount === images.length;
    (0,react.useEffect)(function() {
        setLoadedCount(0); // reset when images change
    }, [
        images
    ]);
    var ref2 = (0,react.useState)(false), isOpen = ref2[0], setIsOpen = ref2[1];
    var ref3 = (0,react.useState)(0), currentIndex = ref3[0], setCurrentIndex = ref3[1];
    (0,react.useEffect)(function() {
        if (isOpen) {
            var initializeGallery = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var options, items, ref, PhotoSwipe, ref1, PhotoSwipeUI_Default, gallery;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                options = {
                                    index: currentIndex,
                                    bgOpacity: 0.9,
                                    history: false
                                };
                                items = images.map(function(param) {
                                    var image_path = param.image_path;
                                    return {
                                        src: image_path,
                                        msrc: image_path,
                                        w: 1000,
                                        h: 1000
                                    };
                                });
                                return [
                                    4,
                                    __webpack_require__.e(/* import() */ 8832).then(__webpack_require__.t.bind(__webpack_require__, 58832, 23))
                                ];
                            case 1:
                                ref = _state.sent(), PhotoSwipe = ref.default;
                                return [
                                    4,
                                    __webpack_require__.e(/* import() */ 8411).then(__webpack_require__.t.bind(__webpack_require__, 38411, 23))
                                ];
                            case 2:
                                ref1 = _state.sent(), PhotoSwipeUI_Default = ref1.default;
                                gallery = new PhotoSwipe(document.querySelector(".pswp"), PhotoSwipeUI_Default, items, options);
                                gallery.init();
                                gallery.listen("beforeChange", function() {
                                    var index = gallery.getCurrentIndex();
                                    setCurrentIndex(index);
                                });
                                gallery.listen("close", function() {
                                    setIsOpen(false);
                                });
                                return [
                                    2,
                                    function() {
                                        gallery.destroy();
                                    }
                                ];
                        }
                    });
                });
                return function initializeGallery() {
                    return _ref.apply(this, arguments);
                };
            }();
            initializeGallery().then(function(r) {
                return r;
            });
        }
    }, [
        isOpen,
        currentIndex
    ]);
    var openGallery = function(index) {
        setCurrentIndex(index);
        setIsOpen(true);
    };
    var handleImageClick = function(index) {
        if (zoom) openGallery(index);
        return;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-aos": animation,
        className: customClassNames,
        style: {
            margin: styles === null || styles === void 0 ? void 0 : styles.margin,
            padding: styles === null || styles === void 0 ? void 0 : styles.padding
        },
        children: [
            zoom && isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPhotoSwipe/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_masonry_es/* ResponsiveMasonry */.G, {
                columnsCountBreakPoints: {
                    425: mobileColumns,
                    600: tabletColumns,
                    991: desktopColumns
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_responsive_masonry_es/* default */.Z, {
                    gutter: "".concat(gap, "px"),
                    children: images.map(function(param, index) {
                        var id = param.id, image_path = param.image_path;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            onClick: function() {
                                return handleImageClick(index);
                            },
                            style: {
                                height: "unset !important",
                                width: "100%",
                                display: "block",
                                opacity: allLoaded ? 1 : 0,
                                transition: "opacity 0.3s ease-in-out",
                                cursor: zoom ? "pointer" : "default"
                            },
                            alt: "masonry image",
                            "aria-hidden": "true",
                            src: image_path,
                            onLoad: function() {
                                return setLoadedCount(function(c) {
                                    return c + 1;
                                });
                            }
                        }, id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Masonry = (MasonryComponent);

// EXTERNAL MODULE: ./components/builder/TabsComponent/tabs.module.scss
var tabs_module = __webpack_require__(71559);
var tabs_module_default = /*#__PURE__*/__webpack_require__.n(tabs_module);
;// CONCATENATED MODULE: ./components/builder/TabsComponent/index.tsx





var TabsComponent = function(param) {
    var _item = param.item, _convertedSettings = _item.convertedSettings, styles = _convertedSettings.styles, parentStyles = _convertedSettings.parentStyles, customClassNames = _item.customClassNames, tmp = _item.tabSettings, ref = tmp === void 0 ? {} : tmp, gap = ref.gap, fontSize = ref.fontSize, tabHover = ref.tabHover, _tabItems = ref.tabItems, tabItems = _tabItems === void 0 ? [] : _tabItems, _activeTab = ref.activeTab, activeTab = _activeTab === void 0 ? {} : _activeTab, boldTabTitle = ref.boldTabTitle, fullWidthTabs = ref.fullWidthTabs;
    var isOdd = tabItems.length % 2 === 1;
    var ref1 = (0,react.useState)(null), hoveredIndex = ref1[0], setHoveredIndex = ref1[1];
    var boldTitle = boldTabTitle ? {
        fontWeight: "bold"
    } : {};
    var ref2 = (0,react.useState)(null), selected = ref2[0], setSelected = ref2[1];
    var borderWidth = activeTab.borderWidth != null ? activeTab.borderWidth : 1;
    (0,react.useEffect)(function() {
        if (tabItems.length > 0) {
            setSelected({
                content: tabItems[0].content,
                id: 0
            });
        }
    }, [
        tabItems
    ]);
    var getTabStyles = function(index) {
        return hoveredIndex === index ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tabHover), {
            borderWidth: borderWidth,
            fontSize: "".concat(fontSize, "px")
        }) : {
            backgroundColor: styles.backgroundColor,
            borderWidth: borderWidth,
            fontSize: "".concat(fontSize, "px")
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (tabs_module_default()).tabs_component,
        style: parentStyles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                "data-tabs": isOdd,
                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, styles), {
                    gap: "".concat(gap, "px")
                }),
                className: "".concat((tabs_module_default()).tabsList, " ").concat(customClassNames, " ").concat(fullWidthTabs ? (tabs_module_default()).fullWidthTabs : ""),
                children: tabItems.map(function(param, index) {
                    var title = param.title, content = param.content;
                    var selectedTab = (selected === null || selected === void 0 ? void 0 : selected.id) === index;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        onMouseEnter: function() {
                            return setHoveredIndex(index);
                        },
                        onMouseLeave: function() {
                            return setHoveredIndex(null);
                        },
                        onClick: function(ev) {
                            ev.stopPropagation();
                            if (!selectedTab) {
                                setSelected({
                                    content: content,
                                    id: index
                                });
                            }
                        },
                        style: selectedTab ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, activeTab), {
                            fontSize: "".concat(fontSize, "px")
                        }) : getTabStyles(index),
                        className: "".concat((tabs_module_default()).tabsListItem, " ").concat(selectedTab && (tabs_module_default()).selectedItem),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: selectedTab ? boldTitle : {},
                            className: (tabs_module_default()).tabsListItemTitle,
                            children: title
                        })
                    }, index);
                })
            }),
            selected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (tabs_module_default()).dropListItemDecr,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (tabs_module_default()).content,
                    dangerouslySetInnerHTML: {
                        __html: selected.content
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var builder_TabsComponent = (TabsComponent);

// EXTERNAL MODULE: ./components/builder/DropList/dropList.module.scss
var dropList_module = __webpack_require__(46936);
var dropList_module_default = /*#__PURE__*/__webpack_require__.n(dropList_module);
;// CONCATENATED MODULE: ./components/builder/DropList/index.tsx



var DropList = function(param) {
    var _item = param.item, _convertedSettings = _item.convertedSettings, styles = _convertedSettings.styles, parentStyles = _convertedSettings.parentStyles, tmp = _item.dropListSettings, fontSize = (tmp === void 0 ? {} : tmp).fontSize, dropList = _item.dropList, customClassNames = _item.customClassNames;
    var ref = (0,react.useState)(null), selected = ref[0], setSelected = ref[1];
    var containsPDFLink = function(htmlString) {
        if (false) {}
        var parser = new DOMParser();
        var doc = parser.parseFromString(htmlString, "text/html");
        var links = doc.querySelectorAll("a");
        return Array.from(links).some(function(link) {
            return link.href.endsWith(".pdf");
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: parentStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            style: styles,
            className: "".concat((dropList_module_default()).dropList, " ").concat(customClassNames),
            children: [
                dropList.map(function(param, i) {
                    var title = param.title, content = param.content;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (dropList_module_default()).dropListItem,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "".concat((dropList_module_default()).dropListItemTitle, " ").concat((selected === null || selected === void 0 ? void 0 : selected.id) === i && (dropList_module_default()).selectedTitle),
                            onClick: function(ev) {
                                ev.stopPropagation();
                                var isPDF = containsPDFLink(content);
                                setSelected(function(prev) {
                                    return prev === null || (prev === null || prev === void 0 ? void 0 : prev.id) !== i ? {
                                        content: content,
                                        isPDF: isPDF,
                                        id: i
                                    } : null;
                                });
                            },
                            style: {
                                fontSize: "".concat(fontSize, "px")
                            },
                            children: title
                        })
                    }, i);
                }),
                dropList.map(function(elem) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (dropList_module_default()).dropListItemDecr,
                        style: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (dropList_module_default()).content,
                            dangerouslySetInnerHTML: {
                                __html: elem.content
                            }
                        })
                    });
                }),
                selected && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (dropList_module_default()).dropListItemDecr,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (dropList_module_default()).content,
                        dangerouslySetInnerHTML: {
                            __html: selected.content
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var builder_DropList = (DropList);

;// CONCATENATED MODULE: ./components/builder/Icon/index.tsx



var IconComponent = function(param) {
    var tmp = param.item, ref = tmp === void 0 ? {} : tmp, icon = ref.icon, linkValue = ref.linkValue, customClassNames = ref.customClassNames, isLinkChecked = ref.isLinkChecked, tmp1 = ref.convertedSettings, ref1 = tmp1 === void 0 ? {} : tmp1, styles = ref1.styles, _parentStyles = ref1.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles, tmp2 = ref1.animationAos, ref2 = tmp2 === void 0 ? {} : tmp2, tmp3 = ref2["data-aos"], dataAos = tmp3 === void 0 ? null : tmp3, hoverAnimation = ref.hoverAnimation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-aos": dataAos,
        style: parentStyles,
        className: (builder_module_default()).icon_component,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(customClassNames, " ").concat(hoverAnimation),
            children: linkValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: linkValue,
                rel: "noreferrer",
                target: isLinkChecked ? "_blank" : "",
                style: {
                    pointerEvents: linkValue ? "unset" : "none"
                },
                children: icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: styles,
                    className: "builder-icon",
                    dangerouslySetInnerHTML: {
                        __html: icon
                    }
                })
            }) : icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: styles,
                className: "builder-icon",
                dangerouslySetInnerHTML: {
                    __html: icon
                }
            })
        })
    });
};
/* harmony default export */ var Icon = (IconComponent);

;// CONCATENATED MODULE: ./components/builder/Map/index.tsx



var MapComponent = function(param) {
    var tmp = param.item, ref = tmp === void 0 ? {} : tmp, customClassNames = ref.customClassNames, iFrameContent = ref.iFrameContent, tmp1 = ref.convertedSettings, ref1 = tmp1 === void 0 ? {} : tmp1, styles = ref1.styles, _parentStyles = ref1.parentStyles, parentStyles = _parentStyles === void 0 ? {} : _parentStyles, tmp2 = ref1.animationAos, ref2 = tmp2 === void 0 ? {} : tmp2, tmp3 = ref2["data-aos"], dataAos = tmp3 === void 0 ? null : tmp3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-aos": dataAos,
        style: parentStyles,
        className: (builder_module_default()).icon_component,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: customClassNames,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: styles,
                className: "builder-iframe",
                dangerouslySetInnerHTML: {
                    __html: iFrameContent
                }
            })
        })
    });
};
/* harmony default export */ var Map = (MapComponent);

// EXTERNAL MODULE: ./components/builder/TableOfContents/table.module.scss
var table_module = __webpack_require__(1019);
var table_module_default = /*#__PURE__*/__webpack_require__.n(table_module);
;// CONCATENATED MODULE: ./components/builder/TableOfContents/index.tsx




var ContentTable = function(param) {
    var _item = param.item, _convertedSettings = _item.convertedSettings, styles = _convertedSettings.styles, parentStyles = _convertedSettings.parentStyles, customClassNames = _item.customClassNames, tmp = _item.contentTableSettings, ref = tmp === void 0 ? {} : tmp, gap = ref.gap, fontSize = ref.fontSize, activeStyles = ref.activeStyles, hoveredStyles = ref.hoveredStyles, _tableItems = ref.tableItems, tableItems = _tableItems === void 0 ? [] : _tableItems, _boldTitle = ref.boldTitle, boldTitle = _boldTitle === void 0 ? false : _boldTitle, _boldTitleHover = ref.boldTitleHover, boldTitleHover = _boldTitleHover === void 0 ? false : _boldTitleHover, _boldTitleActive = ref.boldTitleActive, boldTitleActive = _boldTitleActive === void 0 ? false : _boldTitleActive, _tablePosition = ref.tablePosition, tablePosition = _tablePosition === void 0 ? "start" : _tablePosition;
    var ref1 = (0,react.useState)(null), activeTitle = ref1[0], setActiveTitle = ref1[1];
    var ref2 = (0,react.useState)(null), hoveredIndex = ref2[0], setHoveredIndex = ref2[1];
    var alignment = {
        "start": {
            left: "25px"
        },
        "end": {
            right: "25px"
        }
    };
    var containerStyles = (0,_object_spread/* default */.Z)({}, styles, alignment[tablePosition]);
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (window.scrollY === 0) {
                if (activeTitle !== null) {
                    setActiveTitle(null);
                }
                return;
            }
            var closestIndex = null;
            var minDistance = Number.POSITIVE_INFINITY;
            tableItems.forEach(function(param, index) {
                var rowId = param.rowId;
                var element = document.getElementById(rowId);
                if (element) {
                    var rect = element.getBoundingClientRect();
                    var headerOffset = 130;
                    var distanceFromTop = Math.abs(rect.top - headerOffset);
                    if (rect.top <= window.innerHeight / 2 && distanceFromTop < minDistance) {
                        minDistance = distanceFromTop;
                        closestIndex = index;
                    }
                }
            });
            if (closestIndex !== null && closestIndex !== activeTitle) {
                setActiveTitle(closestIndex);
            }
        };
        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        tableItems,
        activeTitle
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(customClassNames, " ").concat((table_module_default()).main__container),
        style: containerStyles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                gap: "".concat(gap, "px")
            },
            className: (table_module_default()).contents__table,
            children: tableItems.map(function(param, index) {
                var rowId = param.rowId, rowName = param.rowName;
                var isActive = activeTitle === index;
                var isHovered = hoveredIndex === index;
                var bold = boldTitle ? {
                    fontWeight: "bold"
                } : {};
                var boldHover = boldTitleHover ? {
                    fontWeight: "bold"
                } : {};
                var boldActive = boldTitleActive ? {
                    fontWeight: "bold"
                } : {};
                var itemStyle = (0,_object_spread/* default */.Z)({
                    fontSize: "".concat(fontSize, "px")
                }, bold, isActive ? (0,_object_spread/* default */.Z)({}, activeStyles, boldActive) : {}, isHovered && !isActive ? (0,_object_spread/* default */.Z)({}, hoveredStyles, boldHover) : {});
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (table_module_default()).content__item,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#".concat(rowId),
                        style: itemStyle,
                        onClick: function(e) {
                            e.stopPropagation();
                            setActiveTitle(index);
                        },
                        onMouseEnter: function() {
                            return setHoveredIndex(index);
                        },
                        onMouseLeave: function() {
                            return setHoveredIndex(null);
                        },
                        children: rowName
                    })
                }, index);
            })
        })
    });
};
/* harmony default export */ var TableOfContents = (ContentTable);

// EXTERNAL MODULE: ./components/builder/TimelineChart/timeline.module.scss
var timeline_module = __webpack_require__(20017);
var timeline_module_default = /*#__PURE__*/__webpack_require__.n(timeline_module);
;// CONCATENATED MODULE: ./components/builder/TimelineChart/index.tsx






var TimelineChart = function(param) {
    var _item = param.item, customClassNames = _item.customClassNames, _timelineSettings = _item.timelineSettings, points = _timelineSettings.points, _settings = _timelineSettings.settings, iconColor = _settings.iconColor, lineColor = _settings.lineColor, dotsColor = _settings.dotsColor, headingColor = _settings.headingColor, _convertedSettings = _item.convertedSettings, styles = _convertedSettings.styles, parentStyles = _convertedSettings.parentStyles;
    var chartWidthHandle = function() {
        var margin = (styles === null || styles === void 0 ? void 0 : styles.margin) || "0px";
        var splittedMargins = margin.split(" ");
        var _splittedMargins = (0,_sliced_to_array/* default */.Z)(splittedMargins, 4), tmp = _splittedMargins[0], top = tmp === void 0 ? "0px" : tmp, tmp1 = _splittedMargins[1], right = tmp1 === void 0 ? "0px" : tmp1, tmp2 = _splittedMargins[2], bottom = tmp2 === void 0 ? "0px" : tmp2, tmp3 = _splittedMargins[3], left = tmp3 === void 0 ? "0px" : tmp3;
        var isZeroMargin = [
            top,
            right,
            bottom,
            left
        ].every(function(val) {
            return val === "0px";
        });
        return isZeroMargin ? "100%" : "calc(100% - ".concat(right, " - ").concat(left, ")");
    };
    var timelineLines = Array.from({
        length: 10
    }, function(_, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            style: {
                background: lineColor
            },
            className: (timeline_module_default()).timeline__line
        }, index);
    });
    var startX = (0,react.useRef)(0);
    var scrollLeft = (0,react.useRef)(0);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), dragging = ref[0], setDragging = ref[1];
    var isDragging = (0,react.useRef)(false);
    var scrollRef = (0,react.useRef)(null);
    //TODO!!! Vertical page scroll should ALWAYS work
    // useEffect(() => {
    //     const el = scrollRef.current;
    //     if (!el) return;
    //
    //     //TODO!!! for timeline not scrollable functionality
    //     // const handleWheel = (e: WheelEvent) => {
    //     //     const el = scrollRef.current;
    //     //     if (!el) return;
    //     //
    //     //     const isScrollable = el.scrollWidth > el.clientWidth;
    //     //
    //     //     if (!isScrollable) return;
    //     //
    //     //     const rect = el.getBoundingClientRect();
    //     //     const inView = rect.top < window.innerHeight && rect.bottom > 0;
    //     //
    //     //     if (inView && Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
    //     //         e.preventDefault();
    //     //         el.scrollLeft = el.scrollLeft + e.deltaY;
    //     //     }
    //     // };
    //     const handleWheel = (e: WheelEvent) => {
    //         if (!isDragging.current) {
    //             e.preventDefault();   // block wheel scrolling
    //             return;
    //         }
    //     };
    //
    //
    //     el.addEventListener("wheel", handleWheel, { passive: false });
    //
    //     return () => {
    //         el.removeEventListener("wheel", handleWheel);
    //     };
    // }, []);
    var handleMouseDown = function(e) {
        var ref, ref1;
        isDragging.current = true;
        startX.current = e.pageX - (((ref = scrollRef.current) === null || ref === void 0 ? void 0 : ref.offsetLeft) || 0);
        scrollLeft.current = ((ref1 = scrollRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollLeft) || 0;
        setDragging(true);
    };
    var handleMouseLeave = function() {
        isDragging.current = false;
        setDragging(false);
    };
    var handleMouseUp = function() {
        isDragging.current = false;
        setDragging(false);
    };
    var handleMouseMove = function(e) {
        var ref;
        if (!isDragging.current) return;
        e.preventDefault();
        var x = e.pageX - (((ref = scrollRef.current) === null || ref === void 0 ? void 0 : ref.offsetLeft) || 0);
        var walk = x - startX.current;
        if (scrollRef.current) {
            scrollRef.current.scrollLeft = scrollLeft.current - walk;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: parentStyles,
        className: customClassNames,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: scrollRef,
            className: (timeline_module_default())["timeline-chart"],
            style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, styles), {
                width: chartWidthHandle(),
                cursor: dragging ? "grabbing" : "grab"
            }),
            onMouseDown: handleMouseDown,
            onMouseLeave: handleMouseLeave,
            onMouseUp: handleMouseUp,
            onMouseMove: handleMouseMove,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (timeline_module_default()).first_and_last_timeline,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (timeline_module_default()).timeline_heading,
                            style: {
                                color: headingColor
                            },
                            children: points[0].heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (timeline_module_default()).timeline_content,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (timeline_module_default()).text,
                                dangerouslySetInnerHTML: {
                                    __html: points[0].content
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (timeline_module_default())["timeline-chart-inner"],
                    children: points.map(function(param, index) {
                        var icon = param.icon, heading = param.heading, content = param.content, iconSize = param.iconSize, headingPosition = param.headingPosition;
                        var headingStyles;
                        var contentStyles;
                        var isFirstPoint = index === 0;
                        var isLastPoint = index === points.length - 1;
                        var iconStyles = {
                            color: iconColor,
                            width: "".concat(iconSize, "px"),
                            height: "".concat(iconSize, "px")
                        };
                        if (headingPosition === "bottom") {
                            contentStyles = {
                                bottom: "80px"
                            };
                            headingStyles = {
                                top: "80px",
                                color: headingColor
                            };
                        } else {
                            contentStyles = {
                                top: "80px"
                            };
                            headingStyles = {
                                bottom: "80px",
                                color: headingColor
                            };
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((timeline_module_default())["timeline-point"], " ").concat(isFirstPoint ? (timeline_module_default()).first__point : "", " ").concat(isLastPoint ? (timeline_module_default()).last__point : ""),
                            children: [
                                !isFirstPoint && !isLastPoint && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (timeline_module_default())["timeline-label"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (timeline_module_default()).timeline_heading,
                                            style: headingStyles,
                                            children: heading
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (timeline_module_default()).timeline_content,
                                            style: contentStyles,
                                            children: [
                                                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (timeline_module_default()).icon_container,
                                                    style: {
                                                        borderColor: dotsColor
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: iconStyles,
                                                        className: "".concat((timeline_module_default()).point_icon),
                                                        dangerouslySetInnerHTML: {
                                                            __html: icon
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (timeline_module_default()).text,
                                                    dangerouslySetInnerHTML: {
                                                        __html: content
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (timeline_module_default()).lines,
                                    children: [
                                        isFirstPoint && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                background: dotsColor
                                            },
                                            className: (timeline_module_default()).point__line
                                        }),
                                        !isLastPoint && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        background: lineColor
                                                    },
                                                    className: (timeline_module_default()).timeline_lines,
                                                    children: timelineLines
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    style: {
                                                        background: dotsColor
                                                    },
                                                    className: (timeline_module_default()).point__line
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (timeline_module_default()).first_and_last_timeline,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (timeline_module_default()).timeline_heading,
                            style: {
                                color: headingColor
                            },
                            children: points[points.length - 1].heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (timeline_module_default()).timeline_content,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (timeline_module_default()).text,
                                dangerouslySetInnerHTML: {
                                    __html: points[points.length - 1].content
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var builder_TimelineChart = (TimelineChart);

;// CONCATENATED MODULE: ./components/builder/RenderCustomElements.tsx























var RenderBuilderComponent = function(param) {
    var data = param.data, dbName = param.dbName, translationsData = param.translationsData, selectedLocale = param.selectedLocale, selectedCurrItems = param.selectedCurrItems, currencies = param.currencies, backOrderValue = param.backOrderValue, isMobile = param.isMobile, recaptchaActive = param.recaptchaActive, lcpElement = param.lcpElement, productInfo = param.productInfo;
    var VideoComponentLayout = function(param) {
        var children = param.children;
        var videoToggle = {
            "true": /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (builder_module_default()).video_wrapper,
                children: children
            }),
            "false": /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: children
            })
        };
        return videoToggle["".concat(!!(data === null || data === void 0 ? void 0 : data.fullScreen))];
    };
    var builderComponents = {
        Heading: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_Heading, {
            item: data
        }),
        HyperLink: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_HyperLink, {
            item: data
        }),
        Editor: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_Editor, {
            item: data
        }),
        Accordion: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_Accordion, {
            item: data
        }),
        DropList: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_DropList, {
            item: data
        }),
        ImageUpload: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_ImageUpload, {
            item: data,
            dbName: dbName,
            lcpElement: lcpElement,
            isMobile: isMobile
        }),
        Slider: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_SliderComponent, {
            item: data
        }),
        Button: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_Button, {
            item: data,
            selectedLocale: selectedLocale,
            currencies: currencies,
            backOrderValue: backOrderValue,
            recaptchaActive: recaptchaActive
        }),
        Video: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoComponentLayout, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_Video, {
                item: data
            })
        }),
        Posts: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_PostsComponent, {
            item: data,
            translationsData: translationsData
        }),
        FormBuilder: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormBuilderComponent/* default */.Z, {
            item: data,
            recaptchaActive: recaptchaActive,
            productInfo: productInfo
        }),
        ImageBox: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselComponent, {
            item: data
        }),
        Testimonials: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselComponent, {
            item: data
        }),
        BrandList: /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselComponent, {
            item: data
        }),
        ProductList: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList, {
            item: data,
            dbName: dbName,
            translationsData: translationsData,
            backOrderValue: backOrderValue,
            selectedCurrItems: selectedCurrItems,
            selectedLocale: selectedLocale,
            isMobile: isMobile
        }),
        CountUp: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountUp, {
            item: data
        }),
        Masonry: /*#__PURE__*/ (0,jsx_runtime.jsx)(Masonry, {
            item: data
        }),
        Icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
            item: data
        }),
        Map: /*#__PURE__*/ (0,jsx_runtime.jsx)(Map, {
            item: data
        }),
        Tab: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_TabsComponent, {
            item: data
        }),
        ContentTable: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOfContents, {
            item: data
        }),
        TimelineChart: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_TimelineChart, {
            item: data
        }),
        Grid: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    };
    return builderComponents[data === null || data === void 0 ? void 0 : data.content] || /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var RenderCustomElements = (RenderBuilderComponent);

// EXTERNAL MODULE: ./components/builder/VideoBackground/videoBackground.module.scss
var videoBackground_module = __webpack_require__(20279);
var videoBackground_module_default = /*#__PURE__*/__webpack_require__.n(videoBackground_module);
;// CONCATENATED MODULE: ./components/builder/VideoBackground/index.tsx


var VideoBackground = function(param) {
    var src = param.src;
    if (!src) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (videoBackground_module_default()).backVideoBlock,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            title: "video",
            className: (videoBackground_module_default()).videoFrame,
            src: src,
            width: "100%",
            height: "100%"
        })
    });
};

;// CONCATENATED MODULE: ./components/builder/Column.tsx








var Column = function(param) {
    var animation = param.animation, columnClassname = param.columnClassname, columnStyles = param.columnStyles, videoSource = param.videoSource, childIdArray = param.childIdArray, showOneComponentChild = param.showOneComponentChild, BuilderJSX = param.BuilderJSX, lcpElement = param.lcpElement, isMobile = param.isMobile;
    var columnRef = (0,react.useRef)(null);
    var inView = useIsInView(columnRef, !!animation && animation !== "none");
    var dataAosPropShow = !!animation && animation !== "none" ? {
        "data-aos": animation
    } : {};
    var ChildComponentShow = function() {
        if (showOneComponentChild) return /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderJSX, {
            dataKey: showOneComponentChild
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
            children: childIdArray === null || childIdArray === void 0 ? void 0 : childIdArray.map(function(elInEl, indElInEl) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (builder_module_default()).builder_component,
                    style: lcpElement && isMobile ? {
                        width: "100%"
                    } : {},
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderJSX, {
                        dataKey: elInEl
                    })
                }, indElInEl);
            })
        });
    };
    var _ref = columnStyles || {}, padding = _ref.padding, otherClass = (0,_object_without_properties/* default */.Z)(_ref, [
        "padding"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(columnClassname, " ").concat(!inView ? "dataAosRef" : ""),
        style: {
            padding: padding
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: columnRef
        }, dataAosPropShow), {
            style: lcpElement && isMobile ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherClass), {
                width: "100%"
            }) : otherClass,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoBackground, {
                    src: videoSource
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildComponentShow, {})
            ]
        }))
    });
};
/* harmony default export */ var builder_Column = (Column);

// EXTERNAL MODULE: ./node_modules/react-scroll-parallax/dist/react-scroll-parallax.esm.js + 1 modules
var react_scroll_parallax_esm = __webpack_require__(72141);
;// CONCATENATED MODULE: ./components/builder/Parallax/index.tsx



var ParallaxEffect = function(param) {
    var backgroundAttachment = param.backgroundAttachment, children = param.children, backgroundImage = param.backgroundImage, isMobile = param.isMobile;
    if (backgroundAttachment === "fixed") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_scroll_parallax_esm/* ParallaxProvider */.Xu, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_scroll_parallax_esm/* ParallaxBanner */.UG, {
                        style: {
                            aspectRatio: "2 / 1",
                            position: "absolute",
                            height: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_scroll_parallax_esm/* ParallaxBannerLayer */.mU, {
                            image: backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.replace(/^url\((.*)\)$/, "$1"),
                            speed: isMobile ? -20 : -35
                        })
                    }),
                    children
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: children
    });
};
/* harmony default export */ var Parallax = (ParallaxEffect);

;// CONCATENATED MODULE: ./components/builder/BuilderDataRender.tsx










var BuilderSection = function(_param) {
    var clientShowMap = _param.getBuilderData, tab = _param.tab, showAllBuilderComponents = _param.showAllBuilderComponents, builderComponentProps = (0,_object_without_properties/* default */.Z)(_param, [
        "getBuilderData",
        "tab",
        "showAllBuilderComponents"
    ]);
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(!!showAllBuilderComponents), originalBuilderSections = ref5[0], setOriginalBuilderSections = ref5[1];
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (ref4 && ref4.current) {
                setOriginalBuilderSections(window.scrollY >= 1);
            }
        };
        if (!originalBuilderSections && builderComponentProps.isMobile) {
            window.addEventListener("scroll", handleScroll);
        } else {
            window.removeEventListener("scroll", handleScroll);
        }
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    var BuilderJSX = function(param) {
        var dataKey = param.dataKey;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderCustomElements, (0,_object_spread/* default */.Z)({
            data: dataKey
        }, builderComponentProps));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "block-products",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: !originalBuilderSections ? ref4 : null,
            className: "\n                    ".concat(tab !== 5 && (clientShowMap === null || clientShowMap === void 0 ? void 0 : (ref = clientShowMap[tab]) === null || ref === void 0 ? void 0 : ref.length) ? (builder_module_default())["home-product-container"] : "", "\n                    ").concat((clientShowMap === null || clientShowMap === void 0 ? void 0 : (ref1 = clientShowMap[tab]) === null || ref1 === void 0 ? void 0 : ref1.length) ? (builder_module_default())["b-container"] : "", "\n                    ").concat(tab === 5 ? (builder_module_default()).topped_margin_off : "", "\n                "),
            children: (ref3 = (!originalBuilderSections && builderComponentProps.isMobile ? {
                "1": (ref2 = clientShowMap[1]) === null || ref2 === void 0 ? void 0 : ref2.filter(function(_, index) {
                    return index < 3;
                }),
                "2": [],
                "3": [],
                "4": []
            } : clientShowMap)[tab]) === null || ref3 === void 0 ? void 0 : ref3.map(function() {
                var _$_param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ind = arguments.length > 1 ? arguments[1] : void 0;
                var idArray = _$_param.idArray, parentCls = _$_param.parentCls, container = _$_param.container, screenContainer = _$_param.screenContainer, _rowStyles = _$_param.rowStyles, backgroundAttachment = _rowStyles.backgroundAttachment, backgroundImage = _rowStyles.backgroundImage, customClassName = _$_param.customClassName, childWrapper = _$_param.childWrapper, parentAlignItems = _$_param.parentAlignItems, showOneComponent = _$_param.showOneComponent, _childVideos = _$_param.childVideos, childVideos = _childVideos === void 0 ? [] : _childVideos, backgroundVideo = _$_param.backgroundVideo, rowId = _$_param.rowId, rowStyles = (0,_object_without_properties/* default */.Z)(_$_param.rowStyles, [
                    "backgroundAttachment",
                    "backgroundImage"
                ]);
                var ref;
                var colStyles = showOneComponent ? idArray === null || idArray === void 0 ? void 0 : (ref = idArray[0]) === null || ref === void 0 ? void 0 : ref.columnStyles : {};
                var bgImage = backgroundAttachment !== "fixed" ? {
                    backgroundImage: backgroundImage
                } : {};
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: rowId,
                    className: "".concat(container, " ").concat((builder_module_default()).builder_component, " scroll-target"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Parallax, {
                        backgroundAttachment: backgroundAttachment,
                        backgroundImage: backgroundImage,
                        isMobile: builderComponentProps.isMobile,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat(parentCls, " ").concat(customClassName),
                            style: (0,_object_spread/* default */.Z)({}, rowStyles, bgImage),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoBackground, {
                                    src: backgroundVideo
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: screenContainer,
                                    style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, childWrapper, colStyles), {
                                        alignItems: parentAlignItems,
                                        width: "100%"
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoBackground, {
                                            src: showOneComponent ? childVideos[0] : backgroundVideo
                                        }),
                                        showOneComponent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BuilderJSX, {
                                            dataKey: showOneComponent
                                        }) : idArray === null || idArray === void 0 ? void 0 : idArray.map(function(param, index) {
                                            var childIdArray = param.childIdArray, showOneComponentChild = param.showOneComponent, childCls = param.childCls, secondChildCls = param.secondChildCls, columnStyles = param.columnStyles, customColumnClassName = param.customClassName, animation = param.animation, hoverAnimation = param.hoverAnimation;
                                            var columnClassname = "".concat(childCls, " ").concat((builder_module_default())[secondChildCls], " ").concat(customColumnClassName, " ").concat((builder_module_default())[hoverAnimation]);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_Column, {
                                                childIdArray: childIdArray,
                                                showOneComponentChild: showOneComponentChild,
                                                videoSource: childVideos[index],
                                                columnStyles: columnStyles,
                                                columnClassname: columnClassname,
                                                animation: animation,
                                                BuilderJSX: BuilderJSX,
                                                lcpElement: builderComponentProps.lcpElement,
                                                isMobile: builderComponentProps.isMobile
                                            }, index);
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }, ind);
            })
        })
    });
};
/* harmony default export */ var BuilderDataRender = (BuilderSection);


/***/ }),

/***/ 44487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _formModal_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74743);
/* harmony import */ var _formModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_formModal_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _FormBuilderComponent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22978);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81043);
/* harmony import */ var _store_formbuilder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11428);







var FormModal = function(param) {
    var form = param.form, recaptchaActive = param.recaptchaActive, title = param.title, productInfo = param.productInfo;
    var modalRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                dispatch((0,_store_formbuilder__WEBPACK_IMPORTED_MODULE_5__/* .setFormPopupOpen */ .YK)({
                    id: null,
                    open: false
                }));
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // useEffect(() => {
    //     if (productInfo?.sku) {
    //         const { formComponentInfo: {data: {form_builder_json = [], id: formId} = {} = {}} = {} } = form || {};
    //         let formBuilderArr = null;
    //         if (form_builder_json?.length > 0) {
    //             formBuilderArr = form_builder_json?.map((elem, index) => ({...elem, index}))
    //         }
    //         const hiddenSkuField = formBuilderArr?.find(elem => elem?.type === "hidden" && elem?.value.toLowerCase() === "sku")
    //         if (hiddenSkuField) {
    //             dispatch(setFormElementValue({
    //                 id: formId as number,
    //                 index: hiddenSkuField?.index,
    //                 fieldsForChange: {
    //                     forSku: true,
    //                     value: productInfo.sku
    //                 }
    //             }))
    //         }
    //     }
    // }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_formModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().popup_pos),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "".concat((_formModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().main_popup), " ").concat(title ? (_formModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().main_popup_title) : ""),
            ref: modalRef,
            children: [
                title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_formModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().main_popup_header),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .CloseSvg */ .sZ, {
                            style: {
                                width: "20px",
                                height: "20px",
                                cursor: "pointer"
                            },
                            onClick: function() {
                                return dispatch((0,_store_formbuilder__WEBPACK_IMPORTED_MODULE_5__/* .setFormPopupOpen */ .YK)({
                                    id: null,
                                    open: false
                                }));
                            }
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .CloseSvg */ .sZ, {
                    style: {
                        float: "right",
                        width: "20px",
                        height: "20px",
                        cursor: "pointer"
                    },
                    onClick: function() {
                        return dispatch((0,_store_formbuilder__WEBPACK_IMPORTED_MODULE_5__/* .setFormPopupOpen */ .YK)({
                            id: null,
                            open: false
                        }));
                    }
                }),
                productInfo && (productInfo === null || productInfo === void 0 ? void 0 : productInfo.image) && (productInfo === null || productInfo === void 0 ? void 0 : productInfo.name) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_formModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().main_popup_product_wrapper),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_formModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().main_popup_img_wrapper),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: (_formModal_module_scss__WEBPACK_IMPORTED_MODULE_6___default().main_popup_img),
                                src: productInfo === null || productInfo === void 0 ? void 0 : productInfo.image,
                                alt: "Product Image ".concat(productInfo === null || productInfo === void 0 ? void 0 : productInfo.sku)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                children: productInfo === null || productInfo === void 0 ? void 0 : productInfo.name
                            })
                        ]
                    })
                }) : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormBuilderComponent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    item: form,
                    recaptchaActive: recaptchaActive
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormModal);


/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ builder_FormBuilderComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/builder/FormBuilderComponent/forms.module.scss
var forms_module = __webpack_require__(93811);
var forms_module_default = /*#__PURE__*/__webpack_require__.n(forms_module);
;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/Heading.tsx



var Heading = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _subtype = _element.subtype, subtype = _subtype === void 0 ? "" : _subtype, _className = _element.className, className = _className === void 0 ? "" : _className, _label = _element.label, label = _label === void 0 ? "" : _label;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(className, " ").concat((forms_module_default())["heading_".concat(subtype)]),
        children: label
    });
};
/* harmony default export */ var FormAtoms_Heading = (Heading);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(81043);
// EXTERNAL MODULE: ./store/formbuilder/index.ts + 3 modules
var formbuilder = __webpack_require__(11428);
;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/ErrorMessages.tsx


var ErrorMessages = function(param) {
    var _errors = param.errors, errors = _errors === void 0 ? [] : _errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: errors.map(function(error) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "alert-danger",
                children: error
            }, error);
        })
    });
};
/* harmony default export */ var FormAtoms_ErrorMessages = (ErrorMessages);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/Input.tsx






var Input = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _required = _element.required, required = _required === void 0 ? false : _required, _label = _element.label, label = _label === void 0 ? "" : _label, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _placeholder = _element.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _className = _element.className, className = _className === void 0 ? "" : _className, _name = _element.name, name = _name === void 0 ? "" : _name, _value = _element.value, value = _value === void 0 ? "" : _value, _subtype = _element.subtype, subtype = _subtype === void 0 ? "" : _subtype, maxlength = _element.maxlength;
    var reduxValue = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].value) || "";
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleChangeValue = function(e) {
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                value: e.target.value
            }
        }));
    };
    var handleClasses = {
        true: "".concat(className, " ").concat((forms_module_default()).warning),
        false: className
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text,
                    children: description
                })
            ]
        }),
        false: null
    };
    var inputType = className.includes("number_type") ? "number" : subtype;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forms_module_default()).form_input,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: name,
                name: name,
                type: inputType,
                className: handleClasses["".concat(!!errors[name])],
                placeholder: placeholder,
                value: reduxValue,
                maxLength: maxlength,
                onChange: handleChangeValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_Input = (Input);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/InputNumber.tsx






var InputNumber = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _required = _element.required, required = _required === void 0 ? false : _required, _label = _element.label, label = _label === void 0 ? "" : _label, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _placeholder = _element.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _className = _element.className, className = _className === void 0 ? "" : _className, _name = _element.name, name = _name === void 0 ? "" : _name, _value = _element.value, value = _value === void 0 ? "" : _value, maxlength = _element.maxlength, min = _element.min, max = _element.max, step = _element.step;
    var reduxValue = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].value) || "";
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleChangeValue = function(e) {
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                value: e.target.value
            }
        }));
    };
    var handleClasses = {
        true: "".concat(className, " ").concat((forms_module_default()).warning),
        false: className
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text,
                    children: description
                })
            ]
        }),
        false: null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forms_module_default()).form_input_number,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: name,
                name: name,
                type: "number",
                className: handleClasses["".concat(!!errors[name])],
                placeholder: placeholder,
                value: reduxValue,
                maxLength: maxlength,
                min: min,
                max: max,
                step: step,
                onChange: handleChangeValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_InputNumber = (InputNumber);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/InputDate.tsx






var InputDate = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _required = _element.required, required = _required === void 0 ? false : _required, _label = _element.label, label = _label === void 0 ? "" : _label, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _placeholder = _element.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _className = _element.className, className = _className === void 0 ? "" : _className, _name = _element.name, name = _name === void 0 ? "" : _name, _value = _element.value, value = _value === void 0 ? "" : _value, _dateFormat = _element.dateFormat, dateFormat = _dateFormat === void 0 ? "" : _dateFormat, _startDate = _element.startDate, startDate = _startDate === void 0 ? "" : _startDate, _endDate = _element.endDate, endDate = _endDate === void 0 ? "" : _endDate;
    var reduxValue = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].value) || "";
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleChangeValue = function(e) {
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                value: e.target.value
            }
        }));
    };
    var handleClasses = {
        true: "".concat(className, " ").concat((forms_module_default()).warning),
        false: className
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text,
                    children: description
                })
            ]
        }),
        false: null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forms_module_default()).form_input_date,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: name,
                name: name,
                type: "date",
                className: handleClasses["".concat(!!errors[name])],
                placeholder: placeholder,
                value: reduxValue,
                // dateFormat={dateFormat}
                min: startDate,
                max: endDate,
                onChange: handleChangeValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_InputDate = (InputDate);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/InputFile.tsx






var InputFile = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _required = _element.required, required = _required === void 0 ? false : _required, _label = _element.label, label = _label === void 0 ? "" : _label, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _className = _element.className, className = _className === void 0 ? "" : _className, _name = _element.name, name = _name === void 0 ? "" : _name, _allowedFileExtension = _element.allowedFileExtension, allowedFileExtension = _allowedFileExtension === void 0 ? "" : _allowedFileExtension, _allowedFileSize = _element.allowedFileSize, allowedFileSize = _allowedFileSize === void 0 ? "" : _allowedFileSize, _multiple = _element.multiple, multiple = _multiple === void 0 ? false : _multiple;
    var reduxValue = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].value) || "";
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var inputRef = (0,react.useRef)(null);
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        if (!reduxValue && inputRef && inputRef.current) {
            inputRef.current.value = "";
        }
    }, [
        reduxValue
    ]);
    var handleChangeValue = function(event) {
        if (event.target.files && event.target.files[0]) {
            var file = event.target.files[0];
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.addEventListener("load", function() {
                dispatch((0,formbuilder/* setFormElementValue */.yd)({
                    id: formId,
                    index: index,
                    fieldsForChange: {
                        value: file
                    }
                }));
            });
        }
    };
    var handleClasses = {
        true: "".concat(className, " ").concat((forms_module_default()).warning),
        false: className
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text_wrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (forms_module_default()).info_text,
                        children: description
                    })
                })
            ]
        }),
        false: null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forms_module_default()).form_input,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: name,
                ref: inputRef,
                name: name,
                type: "file",
                className: handleClasses["".concat(!!errors[name])],
                accept: allowedFileExtension,
                size: +allowedFileSize,
                multiple: multiple,
                onChange: handleChangeValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_InputFile = (InputFile);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./api/shop.ts + 1 modules
var shop = __webpack_require__(65564);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
// EXTERNAL MODULE: ./atoms/Toast/useToast.ts
var useToast = __webpack_require__(54213);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-recaptcha-v3/lib/index.js + 5 modules
var lib = __webpack_require__(69498);
;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/Button.tsx














var Button = function(param) {
    var formId = param.formId, formCode = param.formCode, index = param.index, element = param.element, formData = param.formData, recaptchaActive = param.recaptchaActive;
    var _className = element.className, className = _className === void 0 ? "" : _className, _label = element.label, label = _label === void 0 ? "" : _label, _name = element.name, name = _name === void 0 ? "" : _name, _style = element.style, style = _style === void 0 ? "" : _style, _subtype = element.subtype, subtype = _subtype === void 0 ? "button" : _subtype, _value = element.value, value = _value === void 0 ? "" : _value;
    var data = (0,es/* useSelector */.v9)(function(state) {
        return (state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        }) || {
            formData: []
        }).formData;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var toast = (0,useToast/* useToast */.p)();
    var router = (0,next_router.useRouter)();
    var executeRecaptcha = (0,lib/* useReCaptcha */.CL)().executeRecaptcha;
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var _loop, handleElementValue, newData, formData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, el, _tmp, err, key;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function(key) {
                            if (Array.isArray(newData[key])) {
                                newData[key].map(function(el, index) {
                                    formData.append(key + "[" + index + "]", el);
                                });
                            } else {
                                formData.append(key, newData[key]);
                            }
                        };
                        handleElementValue = function(element) {
                            var _label = element.label, label = _label === void 0 ? "" : _label, _value = element.value, value = _value === void 0 ? "" : _value, _name = element.name, name = _name === void 0 ? "" : _name, _values = element.values, values = _values === void 0 ? [] : _values, _multiple = element.multiple, multiple = _multiple === void 0 ? false : _multiple;
                            return {
                                "header": {
                                },
                                "text": (0,_define_property/* default */.Z)({}, name, value),
                                "number": (0,_define_property/* default */.Z)({}, name, value),
                                "date": (0,_define_property/* default */.Z)({}, name, value),
                                "file": (0,_define_property/* default */.Z)({}, name, value),
                                "button": {},
                                "checkbox-group": (0,_define_property/* default */.Z)({}, name, values.filter(function(el) {
                                    return el.selected;
                                }).map(function(el) {
                                    return el.value;
                                })),
                                "radio-group": (0,_define_property/* default */.Z)({}, name, (values.find(function(el) {
                                    return el.selected;
                                }) || {
                                    value: ""
                                }).value),
                                "textarea": (0,_define_property/* default */.Z)({}, name, value),
                                "select": (0,_define_property/* default */.Z)({}, name, values.filter(function(el) {
                                    return el.selected;
                                }).map(function(el) {
                                    return el.value;
                                }))
                            };
                        };
                        newData = {};
                        formData = new FormData();
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        _iterator = data[Symbol.iterator]();
                        _state.label = 2;
                    case 2:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            5
                        ];
                        el = _step.value;
                        _tmp = [
                            {},
                            newData,
                            handleElementValue(el)[el.type],
                            el.type === "hidden" && el.forSku ? (0,_define_property/* default */.Z)({}, el.name, el.value) : {},
                            el.type === "hidden" && el.forPageUrl ? (0,_define_property/* default */.Z)({}, el.name, el.value) : {}
                        ];
                        return [
                            4,
                            (0,_async_to_generator/* default */.Z)(function() {
                                var token;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(String(recaptchaActive) === "1")) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                executeRecaptcha("form_submit")
                                            ];
                                        case 1:
                                            token = _state.sent();
                                            return [
                                                2,
                                                {
                                                    re_token: token
                                                }
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                {}
                                            ];
                                    }
                                });
                            })()
                        ];
                    case 3:
                        newData = _object_spread/* default.apply */.Z.apply(void 0, _tmp.concat(_state.sent()));
                        _state.label = 4;
                    case 4:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        return [
                            3,
                            8
                        ];
                    case 6:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 8:
                        for(var key in newData)_loop(key);
                        shop["default"].submitFormBuilder(formData, formCode).then(function(res) {
                            if (res.errors) {
                                dispatch((0,formbuilder/* setFormErrors */.FB)(res.errors));
                                toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "d-flex chek-fms",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                                        res.message
                                    ]
                                }));
                            } else {
                                dispatch((0,formbuilder/* setFormPopupOpen */.YK)({
                                    id: null,
                                    open: false
                                }));
                                if (res.type === "show_message") {
                                    toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "d-flex chek-fms",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CheckToastSvg */.xQ, {}),
                                            res.data
                                        ]
                                    }));
                                } else {
                                    router.push(res.data);
                                }
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReset = function() {
        dispatch((0,formbuilder/* addAndResetForm */.Cf)({
            id: formId,
            formData: formData
        }));
    };
    var handleOnClickByType = {
        "submit": handleSubmit,
        "reset": handleReset,
        "button": function() {}
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "".concat((forms_module_default()).form_button, " ").concat(className),
        // type={subtype}
        onClick: handleOnClickByType[subtype],
        children: label
    });
};
/* harmony default export */ var FormAtoms_Button = (Button);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/Checkbox.tsx









var Checkbox = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _className = _element.className, className = _className === void 0 ? "" : _className, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _inline = _element.inline, inline = _inline === void 0 ? false : _inline, _label = _element.label, label = _label === void 0 ? "" : _label, _name = _element.name, name = _name === void 0 ? "" : _name, _other = _element.other, other = _other === void 0 ? false : _other, _required = _element.required, required = _required === void 0 ? false : _required, _toggle = _element.toggle, toggle = _toggle === void 0 ? false : _toggle, _values = _element.values, values = _values === void 0 ? [
        {
            label: "",
            selected: false,
            value: ""
        }
    ] : _values;
    var reduxValues = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].values) || [];
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleChangeValue = function(e) {
        var newValues = reduxValues.map(function(el) {
            if (el.value === e.target.value) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                    selected: !el.selected
                });
            }
            return el;
        });
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                values: newValues
            }
        }));
    };
    var toggleCheckbox = function(label, selected, value) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).option,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).toggle_border,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((forms_module_default()).toggle, " ").concat(selected ? (forms_module_default()).checked : " "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: name + " " + value,
                                type: "checkbox",
                                name: name,
                                value: value,
                                checked: selected,
                                onChange: handleChangeValue
                            }, name + " " + value),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (forms_module_default()).check,
                                children: " "
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    htmlFor: name + " " + value,
                    children: label
                })
            ]
        }, name + " " + value);
    };
    var hasOtherOption = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_OtherInput, {
            formId: formId,
            index: index,
            name: name,
            type: "checkbox"
        }),
        false: null
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text,
                    children: description
                })
            ]
        }),
        false: null
    };
    var handleOptionsStyle = {
        true: {
            flexDirection: "row"
        },
        false: {
            flexDirection: "column"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((forms_module_default()).form_checkbox, " ").concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).options,
                style: handleOptionsStyle["".concat(inline)],
                children: [
                    reduxValues.map(function(param) {
                        var _label = param.label, label = _label === void 0 ? "" : _label, _selected = param.selected, selected = _selected === void 0 ? false : _selected, _value = param.value, value = _value === void 0 ? "" : _value;
                        var handleOther = {
                            true: {
                                true: toggleCheckbox(label, selected, value),
                                false: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (forms_module_default()).option,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            id: name + " " + value,
                                            type: "checkbox",
                                            name: name,
                                            value: value,
                                            checked: selected,
                                            onChange: handleChangeValue
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: name + " " + value,
                                            children: label
                                        })
                                    ]
                                }, name + " " + value)
                            },
                            false: {
                                true: null,
                                false: null
                            }
                        };
                        return handleOther["".concat(label !== "other")]["".concat(toggle)];
                    }),
                    hasOtherOption["".concat(other)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_Checkbox = (Checkbox);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/Radio.tsx









var Radio = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _className = _element.className, className = _className === void 0 ? "" : _className, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _inline = _element.inline, inline = _inline === void 0 ? false : _inline, _label = _element.label, label = _label === void 0 ? "" : _label, _name = _element.name, name = _name === void 0 ? "" : _name, _other = _element.other, other = _other === void 0 ? false : _other, _required = _element.required, required = _required === void 0 ? false : _required, _values = _element.values, values = _values === void 0 ? [
        {
            label: "",
            selected: false,
            value: ""
        }
    ] : _values;
    var reduxValues = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].values) || [];
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleChangeValue = function(e) {
        var newValues = reduxValues.map(function(el) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                selected: el.value === e.target.value
            });
        });
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                values: newValues
            }
        }));
    };
    var hasOtherOption = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_OtherInput, {
            formId: formId,
            index: index,
            name: name,
            type: "radio"
        }),
        false: null
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text,
                    children: description
                })
            ]
        }),
        false: null
    };
    var handleOptionsStyle = {
        true: {
            flexDirection: "row"
        },
        false: {
            flexDirection: "column"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((forms_module_default()).form_radio, " ").concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).options,
                style: handleOptionsStyle["".concat(inline)],
                children: [
                    reduxValues.map(function(param) {
                        var _label = param.label, label = _label === void 0 ? "" : _label, _selected = param.selected, selected = _selected === void 0 ? false : _selected, _value = param.value, value = _value === void 0 ? "" : _value;
                        var handleOther = {
                            true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (forms_module_default()).option,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        id: name + " " + value,
                                        type: "radio",
                                        name: name,
                                        value: value,
                                        checked: selected,
                                        onChange: handleChangeValue
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: name + " " + value,
                                        children: label
                                    })
                                ]
                            }, name + " " + value),
                            false: null
                        };
                        return handleOther["".concat(label !== "other")];
                    }),
                    hasOtherOption["".concat(other)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_Radio = (Radio);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/TextArea.tsx






var TextArea = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _required = _element.required, required = _required === void 0 ? false : _required, _label = _element.label, label = _label === void 0 ? "" : _label, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _placeholder = _element.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _className = _element.className, className = _className === void 0 ? "" : _className, _name = _element.name, name = _name === void 0 ? "" : _name, _value = _element.value, value = _value === void 0 ? "" : _value, maxlength = _element.maxlength, _rows = _element.rows, rows = _rows === void 0 ? 0 : _rows;
    var reduxValue = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].value) || "";
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleChangeValue = function(e) {
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                value: e.target.value
            }
        }));
    };
    var handleClasses = {
        true: "".concat(className, " ").concat((forms_module_default()).warning),
        false: className
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text,
                    children: description
                })
            ]
        }),
        false: null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forms_module_default()).form_text_area,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                id: name,
                name: name,
                className: handleClasses["".concat(!!errors[name])],
                placeholder: placeholder,
                value: reduxValue,
                maxLength: maxlength,
                rows: rows,
                onChange: handleChangeValue
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_TextArea = (TextArea);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/Select.tsx









var Select = function(param) {
    var formId = param.formId, index = param.index, _element = param.element, _className = _element.className, className = _className === void 0 ? "" : _className, _description = _element.description, description = _description === void 0 ? "" : _description, _descriptionShow = _element.descriptionShow, descriptionShow = _descriptionShow === void 0 ? false : _descriptionShow, _label = _element.label, label = _label === void 0 ? "" : _label, _name = _element.name, name = _name === void 0 ? "" : _name, _placeholder = _element.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _required = _element.required, required = _required === void 0 ? false : _required, _multiple = _element.multiple, multiple = _multiple === void 0 ? false : _multiple, _values = _element.values, values = _values === void 0 ? [
        {
            label: "",
            selected: false,
            value: ""
        }
    ] : _values;
    var ref;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var reduxValues = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].values) || [];
    });
    var errors = (0,es/* useSelector */.v9)(function(state) {
        return state.formBuilder.errors;
    });
    var selectRef = (0,react.useRef)(null);
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var handleEvent = function(e) {
            if (selectRef && selectRef.current && !selectRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleEvent);
        return function() {
            return document.removeEventListener("mousedown", handleEvent);
        };
    }, []);
    var handleChangeValue = function(e) {
        var newValues = reduxValues.map(function(el) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                selected: multiple ? el.value === e.target.id ? !el.selected : el.selected : el.value === e.target.id
            });
        });
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                values: newValues
            }
        }));
        setOpen(multiple);
    };
    var handleClasses = {
        true: {
            true: "".concat((forms_module_default()).select, " ").concat(className, " ").concat((forms_module_default()).warning, " ").concat((forms_module_default()).open),
            false: "".concat((forms_module_default()).select, " ").concat(className, " ").concat((forms_module_default()).warning, " ")
        },
        false: {
            true: "".concat((forms_module_default()).select, " ").concat(className, " ").concat((forms_module_default()).open),
            false: "".concat((forms_module_default()).select, " ").concat(className, "  ")
        }
    };
    var handleRequired = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (forms_module_default()).required,
            children: "*"
        }),
        false: null
    };
    var handleDescription = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (forms_module_default()).description,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (forms_module_default()).info_text,
                    children: description
                })
            ]
        }),
        false: null
    };
    var handlePlaceholder = {
        true: (ref = reduxValues.find(function(el) {
            return el.selected;
        })) === null || ref === void 0 ? void 0 : ref.label,
        false: placeholder
    };
    var handleOpen = {
        true: (forms_module_default()).open,
        false: ""
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forms_module_default()).form_select,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (forms_module_default()).label,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: name,
                        children: label
                    }),
                    handleRequired["".concat(required)],
                    handleDescription["".concat(descriptionShow)]
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(handleClasses["".concat(!!errors[name])]["".concat(open)]),
                ref: selectRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (forms_module_default()).select_button,
                        onClick: function() {
                            return setOpen(!open);
                        },
                        children: [
                            handlePlaceholder["".concat(!!reduxValues.find(function(el) {
                                return el.selected;
                            }))],
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CustomSelectArrow */.xl, {
                                className: handleOpen["".concat(open)]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (forms_module_default()).select_options,
                        children: reduxValues.map(function(param) {
                            var _label = param.label, label = _label === void 0 ? "" : _label, _selected = param.selected, selected = _selected === void 0 ? false : _selected, _value = param.value, value = _value === void 0 ? "" : _value;
                            var handleMultiple = {
                                true: {
                                    true: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((forms_module_default()).option, " ").concat(selected ? (forms_module_default()).selected : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: value,
                                            onClick: handleChangeValue,
                                            children: label
                                        })
                                    }, value),
                                    false: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((forms_module_default()).option, " ").concat(selected ? (forms_module_default()).selected : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: value,
                                            onClick: handleChangeValue,
                                            children: label
                                        })
                                    }, value)
                                },
                                false: {
                                    true: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (forms_module_default()).option,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            id: value,
                                            onClick: handleChangeValue,
                                            children: label
                                        })
                                    }, value),
                                    false: null
                                }
                            };
                            return handleMultiple["".concat(multiple)]["".concat(!selected)];
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_ErrorMessages, {
                errors: errors[name]
            })
        ]
    });
};
/* harmony default export */ var FormAtoms_Select = (Select);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/OtherInput.tsx








var OtherInput = function(param) {
    var formId = param.formId, index = param.index, name = param.name, type = param.type;
    var reduxValues = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return ((ref = state.formBuilder.forms.find(function(el) {
            return el.id === formId;
        })) === null || ref === void 0 ? void 0 : ref.formData[index].values) || [];
    });
    var ref = (0,react.useState)(false), otherChecked = ref[0], setOtherChecked = ref[1];
    var ref1 = (0,react.useState)(""), otherInputValue = ref1[0], setOtherInputValue = ref1[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        var hasOtherOption = reduxValues.find(function(el) {
            return el.label === "other";
        });
        if (!hasOtherOption) {
            setOtherChecked(false);
            setOtherInputValue("");
        }
    }, [
        reduxValues
    ]);
    var handleCheck = function(e) {
        setOtherChecked(e.target.checked);
        var hasOtherOption = reduxValues.find(function(el) {
            return el.label === "other";
        });
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                values: hasOtherOption ? reduxValues.map(function(el) {
                    if (type === "checkbox") {
                        if (el.label === "other") {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                                selected: e.target.checked
                            });
                        }
                        return el;
                    }
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                        selected: el.label === "other"
                    });
                }) : (0,_to_consumable_array/* default */.Z)(reduxValues.map(function(el) {
                    if (type === "checkbox") {
                        return el;
                    }
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                        selected: false
                    });
                })).concat([
                    {
                        label: "other",
                        value: "",
                        selected: e.target.checked
                    }
                ])
            }
        }));
    };
    var handleChangeOtherInput = function(e) {
        setOtherInputValue(e.target.value);
        dispatch((0,formbuilder/* setFormElementValue */.yd)({
            id: formId,
            index: index,
            fieldsForChange: {
                values: reduxValues.map(function(el) {
                    if (el.label === "other") {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, el), {
                            value: e.target.value
                        });
                    }
                    return el;
                })
            }
        }));
    };
    var handleOtherInput = {
        true: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
            id: "otherInput",
            type: "text",
            className: "form-control",
            value: otherInputValue,
            placeholder: "your variant",
            onChange: handleChangeOtherInput
        }),
        false: null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (forms_module_default()).option,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                id: "".concat(name, " other"),
                type: type,
                className: (forms_module_default()).other_input,
                name: name,
                onChange: handleCheck
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                htmlFor: "".concat(name, " other"),
                children: "Other"
            }),
            handleOtherInput["".concat(otherChecked || type === "radio")]
        ]
    });
};
/* harmony default export */ var FormAtoms_OtherInput = (OtherInput);

;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/FormAtoms/index.js













;// CONCATENATED MODULE: ./components/builder/FormBuilderComponent/index.tsx









var FormBuilderComponent = function(param) {
    var _item = param.item, customClassNames = _item.customClassNames, tmp = _item.convertedSettings, ref = tmp === void 0 ? {} : tmp, _styles = ref.styles, styles = _styles === void 0 ? {} : _styles, tmp1 = _item.formComponentInfo, ref1 = tmp1 === void 0 ? {} : tmp1, tmp2 = ref1.data, ref2 = tmp2 === void 0 ? {} : tmp2, id = ref2.id, code = ref2.code, _form_builder_json = ref2.form_builder_json, form_builder_json = _form_builder_json === void 0 ? [] : _form_builder_json, recaptchaActive = param.recaptchaActive, productInfo = param.productInfo;
    var chartWidthHandle = function() {
        var margin = (styles === null || styles === void 0 ? void 0 : styles.margin) || "0px";
        var splittedMargins = margin.split(" ");
        var _splittedMargins = (0,_sliced_to_array/* default */.Z)(splittedMargins, 4), tmp = _splittedMargins[0], top = tmp === void 0 ? "0px" : tmp, tmp1 = _splittedMargins[1], right = tmp1 === void 0 ? "0px" : tmp1, tmp2 = _splittedMargins[2], bottom = tmp2 === void 0 ? "0px" : tmp2, tmp3 = _splittedMargins[3], left = tmp3 === void 0 ? "0px" : tmp3;
        var isZeroMargin = [
            top,
            right,
            bottom,
            left
        ].every(function(val) {
            return val === "0px";
        });
        return isZeroMargin ? "100%" : "calc(100% - ".concat(right, " - ").concat(left, ")");
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        dispatch((0,formbuilder/* addAndResetForm */.Cf)({
            id: id,
            formData: form_builder_json
        }));
        dispatch((0,formbuilder/* setFormErrors */.FB)({}));
    }, []);
    (0,react.useEffect)(function() {
        var formBuilderArr = null;
        if ((form_builder_json === null || form_builder_json === void 0 ? void 0 : form_builder_json.length) > 0) {
            formBuilderArr = form_builder_json === null || form_builder_json === void 0 ? void 0 : form_builder_json.map(function(elem, index) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, elem), {
                    index: index
                });
            });
        }
        var hiddenSkuField = formBuilderArr === null || formBuilderArr === void 0 ? void 0 : formBuilderArr.find(function(elem) {
            return (elem === null || elem === void 0 ? void 0 : elem.type) === "hidden" && (elem === null || elem === void 0 ? void 0 : elem.value.toLowerCase()) === "sku";
        });
        var hiddenPageUrlField = formBuilderArr === null || formBuilderArr === void 0 ? void 0 : formBuilderArr.find(function(elem) {
            return (elem === null || elem === void 0 ? void 0 : elem.type) === "hidden" && (elem === null || elem === void 0 ? void 0 : elem.value.toLowerCase()) === "pageurl";
        });
        if ((productInfo === null || productInfo === void 0 ? void 0 : productInfo.sku) && hiddenSkuField) {
            dispatch((0,formbuilder/* setFormElementValue */.yd)({
                id: id,
                index: hiddenSkuField === null || hiddenSkuField === void 0 ? void 0 : hiddenSkuField.index,
                fieldsForChange: {
                    forSku: true,
                    value: productInfo.sku
                }
            }));
        }
        if (hiddenPageUrlField) {
            dispatch((0,formbuilder/* setFormElementValue */.yd)({
                id: id,
                index: hiddenPageUrlField === null || hiddenPageUrlField === void 0 ? void 0 : hiddenPageUrlField.index,
                fieldsForChange: {
                    forPageUrl: true,
                    value: window.location.href
                }
            }));
        }
    }, []);
    var handleElement = function(elem, index) {
        return {
            "header": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_Heading, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "paragraph": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_Heading, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "text": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_Input, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "number": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_InputNumber, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "date": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_InputDate, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "file": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_InputFile, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "button": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_Button, {
                formId: id,
                formCode: code,
                index: index,
                element: elem,
                formData: form_builder_json,
                recaptchaActive: recaptchaActive
            }, index),
            "checkbox-group": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_Checkbox, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "radio-group": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_Radio, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "textarea": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_TextArea, {
                formId: id,
                index: index,
                element: elem
            }, index),
            "select": /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAtoms_Select, {
                formId: id,
                index: index,
                element: elem
            }, index)
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((forms_module_default()).form, " ").concat(customClassNames),
        style: {
            margin: styles === null || styles === void 0 ? void 0 : styles.margin,
            padding: styles === null || styles === void 0 ? void 0 : styles.padding,
            width: chartWidthHandle()
        },
        children: form_builder_json.map(function(el, index) {
            return handleElement(el, index)[el.type];
        })
    });
};
/* harmony default export */ var builder_FormBuilderComponent = (FormBuilderComponent);


/***/ }),

/***/ 73519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _posts_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30406);
/* harmony import */ var _posts_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_posts_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _services_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75681);






var PostCard = function(param) {
    var _post = param.post, rightDay = _post.rightDay, image = _post.image, slug = _post.slug, name = _post.name, published_at = _post.published_at, created_at = _post.created_at, category = param.category, translationsData = param.translationsData, date_checked = param.date_checked, read_more_checked = param.read_more_checked;
    var postDate = rightDay ? rightDay : published_at ? (0,_services_utils__WEBPACK_IMPORTED_MODULE_4__/* .createRightDate */ .UE)(published_at) : (0,_services_utils__WEBPACK_IMPORTED_MODULE_4__/* .createRightDate */ .UE)(created_at);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: "/posts/".concat(category === null || category === void 0 ? void 0 : category.slug, "/").concat(slug),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_posts_module_scss__WEBPACK_IMPORTED_MODULE_5___default().postCard),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_posts_module_scss__WEBPACK_IMPORTED_MODULE_5___default().post_card_image),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: image,
                            alt: name,
                            layout: "fill",
                            loading: "lazy"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_posts_module_scss__WEBPACK_IMPORTED_MODULE_5___default().post_card_info),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_posts_module_scss__WEBPACK_IMPORTED_MODULE_5___default().post_card_name),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: name
                                })
                            }),
                            !date_checked && !read_more_checked ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_posts_module_scss__WEBPACK_IMPORTED_MODULE_5___default().post_card_read_data),
                                children: [
                                    date_checked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_posts_module_scss__WEBPACK_IMPORTED_MODULE_5___default().post_card_date),
                                        children: postDate
                                    }) : null,
                                    read_more_checked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_posts_module_scss__WEBPACK_IMPORTED_MODULE_5___default().post_card_read_more),
                                        children: translationsData === null || translationsData === void 0 ? void 0 : translationsData.ReadMore
                                    }) : null
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostCard);


/***/ }),

/***/ 91257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GQ": function() { return /* binding */ schemaBlog; },
/* harmony export */   "Rh": function() { return /* binding */ schemaCategoryPage; },
/* harmony export */   "WN": function() { return /* binding */ schemaString; },
/* harmony export */   "d8": function() { return /* binding */ schemaPages; },
/* harmony export */   "ed": function() { return /* binding */ schemaPageHeader; },
/* harmony export */   "r1": function() { return /* binding */ schemPageCart; },
/* harmony export */   "ro": function() { return /* binding */ schemaPost; }
/* harmony export */ });
/* unused harmony export schemaProduct */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63385);


var logoPath = "/stores-logo.svg";
var schemaBlog = function(domain, dbName, asPath, blogs) {
    var forBlogType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "blog";
    return {
        "@context": "https://schema.org/",
        "@type": "Blog",
        "name": "Blogs",
        "url": (0,_helper__WEBPACK_IMPORTED_MODULE_0__/* .domainUrl */ .HJ)(dbName + asPath),
        "offers": blogs.map(function(post) {
            return {
                "@type": "Page",
                "id": post.id,
                "name": forBlogType === "blog" ? post.blog_title : post.name,
                "description": forBlogType === "blog" ? post.html_content : post.short_description,
                "image": (0,_helper__WEBPACK_IMPORTED_MODULE_0__/* .domainUrl */ .HJ)("".concat(domain, "/storage/").concat(dbName, "/").concat(logoPath))
            };
        })
    };
};
var schemaPost = function(dbName, asPath, posts) {
    var _short_description;
    return {
        "@context": "https://schema.org/",
        "@type": "Post",
        "name": "Posts",
        "url": (0,_helper__WEBPACK_IMPORTED_MODULE_0__/* .domainUrl */ .HJ)(dbName + asPath),
        "offers": posts.map(function(post, index) {
            return {
                "@type": "Page",
                "id": String(index + 1),
                "name": post.name,
                "description": (_short_description = post.short_description) !== null && _short_description !== void 0 ? _short_description : post.description,
                "image": post.image
            };
        })
    };
};
var schemaPages = function(dbName, asPath, content) {
    var ref, ref1, ref2, ref3;
    return {
        "@context": "https://schema.org/",
        "@type": "Page",
        "name": "Pages",
        "url": (0,_helper__WEBPACK_IMPORTED_MODULE_0__/* .domainUrl */ .HJ)(dbName + asPath),
        "meta_description": content === null || content === void 0 ? void 0 : (ref = content.data) === null || ref === void 0 ? void 0 : ref[0].meta_description,
        "meta_keywords": content === null || content === void 0 ? void 0 : (ref1 = content.data) === null || ref1 === void 0 ? void 0 : ref1[0].meta_keywords,
        "meta_title": content === null || content === void 0 ? void 0 : (ref2 = content.data) === null || ref2 === void 0 ? void 0 : ref2[0].meta_title,
        "html_content": content === null || content === void 0 ? void 0 : (ref3 = content.data) === null || ref3 === void 0 ? void 0 : ref3[0].html_content
    };
};
var schemaCategoryPage = function(productsList, dbName) {
    return {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": "Products in Category",
        "offers": productsList === null || productsList === void 0 ? void 0 : productsList.map(function(param) {
            var tmp = param.id, productId = tmp === void 0 ? 0 : tmp, tmp1 = param.flats, ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(tmp1 === void 0 ? [] : tmp1, 1), tmp2 = ref[0], ref1 = tmp2 === void 0 ? {} : tmp2, tmp3 = ref1.name, productName = tmp3 === void 0 ? "" : tmp3, tmp4 = ref1.description, productDesc = tmp4 === void 0 ? "" : tmp4, _images = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param.images, 1), productImg = _images[0];
            return {
                "@type": "Product",
                "id": String(productId),
                "name": productName,
                "description": productDesc,
                "image": (0,_helper__WEBPACK_IMPORTED_MODULE_0__/* .domainUrl */ .HJ)("".concat(dbName).concat(productImg))
            };
        })
    };
};
var schemaProduct = function(asPath, product, dbName, domain) {
    var ref, ref1, ref2, ref3, ref4;
    var brand = (ref = product.details.find(function(el) {
        var ref;
        return ((ref = el.attribute[0]) === null || ref === void 0 ? void 0 : ref.code) === "brand";
    })) === null || ref === void 0 ? void 0 : ref.attribute_value;
    return {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": (ref1 = product === null || product === void 0 ? void 0 : product.flats[0]) === null || ref1 === void 0 ? void 0 : ref1.name,
        "description": ((ref2 = product === null || product === void 0 ? void 0 : product.flats[0]) === null || ref2 === void 0 ? void 0 : ref2.meta_description) && ((ref3 = product === null || product === void 0 ? void 0 : product.flats[0]) === null || ref3 === void 0 ? void 0 : ref3.description),
        "image": domainUrl("".concat(dbName, "/storage/").concat((ref4 = product === null || product === void 0 ? void 0 : product.images[0]) === null || ref4 === void 0 ? void 0 : ref4.path)),
        "url": domainUrl("".concat(dbName).concat(asPath)),
        "brand": {
            "@type": "Brand",
            "name": brand || domain
        },
        "review": {
            "@type": "Review",
            "name": "Organization Review",
            "reviewRating": {
                "@type": "Rating",
                "ratingValue": "0"
            },
            "author": {
                "@type": "Organization",
                "name": domain
            }
        },
        "productID": product === null || product === void 0 ? void 0 : product.id,
        "sku": product === null || product === void 0 ? void 0 : product.sku
    };
};
var schemaString = function(arr) {
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": arr.map(function(param) {
            var title = param.title, description = param.description;
            return {
                "@type": "Question",
                "name": title,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": description
                }
            };
        })
    };
};
var schemaPageHeader = function(dbName, asPath, breadcrumb) {
    return {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "name": "Breadcrumb",
        "url": (0,_helper__WEBPACK_IMPORTED_MODULE_0__/* .domainUrl */ .HJ)(dbName + asPath),
        "itemListElement": breadcrumb.map(function(item, index) {
            return {
                "name": item.title,
                "@type": "ListItem",
                "id": String(index + 1),
                "position": index + 1,
                "item": (0,_helper__WEBPACK_IMPORTED_MODULE_0__/* .domainUrl */ .HJ)(dbName + item.url)
            };
        })
    };
};
var schemPageCart = function(dbName, asPath, items) {
    var currency = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "USD";
    return {
        "@context": "https://schema.org/",
        "@type": "ShoppingCart",
        "name": "Shopping Cart",
        "url": (0,_helper__WEBPACK_IMPORTED_MODULE_0__/* .domainUrl */ .HJ)(dbName + asPath),
        "priceCurrency": currency,
        "itemListElement": items.map(function(item) {
            var _short_description;
            return {
                "@type": "Product",
                "name": item.name,
                "sku": item.sku,
                "price": item.price,
                "url": (0,_helper__WEBPACK_IMPORTED_MODULE_0__/* .domainUrl */ .HJ)(dbName + "/" + item.product.url_key),
                "image": item.product.base_image.original_image_url,
                "description": (_short_description = item.product.short_description) !== null && _short_description !== void 0 ? _short_description : item.product.description
            };
        })
    };
};


/***/ }),

/***/ 77458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gg": function() { return /* binding */ addToCartEventPixel; },
/* harmony export */   "Vr": function() { return /* binding */ openUpCrossProd; },
/* harmony export */   "x": function() { return /* binding */ handleAddCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10092);
/* harmony import */ var _store_cart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7597);
/* harmony import */ var _store_general__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26298);





var addToCartEventPixel = function(product, quantity, selectedRate) {
    if (window.fbq) {
        window.fbq("track", "AddToCart", {
            product_name: product.flats[0].name,
            product_sku: product.sku,
            product_id: product.flats[0].id,
            product_type: product.type,
            product_price: product.flats[0].price,
            product_quantity: quantity,
            currency: selectedRate.code
        });
    }
};
var handleAddCard = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var openUpCrossProd, dispatch, _data, product, quantity, cartToken, customer, selectedLocale, selectedCurrCode, optionsObject, addToast, _links, links, bundle_options, bundle_option_qty, routerPush, isProductInStock, _flats, ref, has_up_sell, has_cross_sell, url_key, addItemCallback, anywayFunc;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    openUpCrossProd = param.openUpCrossProd, dispatch = param.dispatch, _data = param.data, product = _data.product, quantity = _data.quantity, cartToken = _data.cartToken, customer = _data.customer, selectedLocale = _data.selectedLocale, selectedCurrCode = _data.selectedCurrCode, optionsObject = _data.optionsObject, addToast = _data.addToast, _links = _data.links, links = _links === void 0 ? [] : _links, bundle_options = _data.bundle_options, bundle_option_qty = _data.bundle_option_qty, routerPush = param.routerPush, isProductInStock = param.isProductInStock;
                    _flats = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(product.flats, 1), ref = _flats[0], has_up_sell = ref.has_up_sell, has_cross_sell = ref.has_cross_sell, url_key = ref.url_key;
                    addItemCallback = function() {
                        return (0,_store_cart__WEBPACK_IMPORTED_MODULE_0__/* .cartAddItem */ .rg)(product, quantity, cartToken, customer, selectedLocale, selectedCurrCode, optionsObject, addToast, links, bundle_options, bundle_option_qty);
                    };
                    anywayFunc = function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        addToCartEventPixel(product, quantity, {
                                            code: selectedCurrCode
                                        });
                                        return [
                                            4,
                                            dispatch(addItemCallback())
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            _state.sent()
                                        ];
                                }
                            });
                        });
                        return function anywayFunc() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    if (!isProductInStock) return [
                        3,
                        10
                    ];
                    if (!has_up_sell) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        openUpCrossProd()
                    ];
                case 1:
                    if (!!_state.sent()) return [
                        3,
                        2
                    ];
                    dispatch(addItemCallback());
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        openUpCrossProd()
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        9
                    ];
                case 5:
                    if (!has_cross_sell) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        openUpCrossProd()
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        4,
                        anywayFunc()
                    ];
                case 8:
                    return [
                        2,
                        _state.sent()
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    return [
                        4,
                        routerPush("/".concat(url_key))
                    ];
                case 11:
                    _state.sent();
                    _state.label = 12;
                case 12:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleAddCard(_) {
        return _ref.apply(this, arguments);
    };
}();
var openUpCrossProd = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var dispatch, productId, selectedLocale, selectedRate, product, _flats, ref, has_up_sell, has_cross_sell, callBackForUpOrCross, ref1, tmp, upResponse, ref2, tmp1, crossResponse;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    dispatch = param.dispatch, productId = param.productId, selectedLocale = param.selectedLocale, selectedRate = param.selectedRate, product = param.product;
                    _flats = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(product.flats, 1), ref = _flats[0], has_up_sell = ref.has_up_sell, has_cross_sell = ref.has_cross_sell;
                    callBackForUpOrCross = function(type) {
                        return (0,_store_cart__WEBPACK_IMPORTED_MODULE_0__/* .getUpOrCrossProd */ .xM)(productId, type, selectedLocale, selectedRate);
                    };
                    if (!parseFloat(has_up_sell)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Promise.all([
                            dispatch(callBackForUpOrCross("up-sell"))
                        ])
                    ];
                case 1:
                    ref1 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent() || [
                            []
                        ],
                        1
                    ]), tmp = ref1[0], upResponse = tmp === void 0 ? [] : tmp;
                    if (upResponse.length > 0) {
                        dispatch((0,_store_general__WEBPACK_IMPORTED_MODULE_1__/* .setPopupName */ .Sq)("upsell"));
                        dispatch((0,_store_general__WEBPACK_IMPORTED_MODULE_1__/* .setTempData */ .LH)([
                            product
                        ]));
                        return [
                            2,
                            true
                        ];
                    }
                    return [
                        2,
                        false
                    ];
                case 2:
                    if (!parseFloat(has_cross_sell)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        Promise.all([
                            dispatch(callBackForUpOrCross("cross-sell"))
                        ])
                    ];
                case 3:
                    ref2 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent() || [
                            []
                        ],
                        1
                    ]), tmp1 = ref2[0], crossResponse = tmp1 === void 0 ? [] : tmp1;
                    if (crossResponse.length > 0) {
                        dispatch((0,_store_general__WEBPACK_IMPORTED_MODULE_1__/* .setCrossValid */ .TV)(true));
                        dispatch((0,_store_general__WEBPACK_IMPORTED_MODULE_1__/* .setPopupName */ .Sq)("crossSell"));
                        dispatch((0,_store_general__WEBPACK_IMPORTED_MODULE_1__/* .setTempData */ .LH)([
                            product
                        ]));
                        return [
                            2,
                            true
                        ];
                    }
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2,
                        true
                    ];
            }
        });
    });
    return function openUpCrossProd(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 1601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useDebounce(callback, delay) {
    var timer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        clearTimeout(timer.current);
        timer.current = setTimeout(function() {
            callback.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(args));
        }, delay);
    }, [
        callback,
        delay
    ]);
}
;


/***/ }),

/***/ 84444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XZ": function() { return /* binding */ wishListRemoveAllItems; },
/* harmony export */   "c8": function() { return /* binding */ wishlistAddItem; },
/* harmony export */   "uv": function() { return /* binding */ wishlistRemoveItem; }
/* harmony export */ });
/* unused harmony exports wishlistAddItemSuccess, wishlistRemoveItemSuccess */
/* harmony import */ var _wishlistActionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46680);

function wishlistAddItemSuccess(product, locale) {
    return {
        type: _wishlistActionTypes__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_ADD_ITEM */ .jQ,
        product: product
    };
}
function wishlistRemoveItemSuccess(productId) {
    return {
        type: _wishlistActionTypes__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_REMOVE_ITEM */ .vU,
        productId: productId
    };
}
function wishlistAddItem(product, locale) {
    return function(dispatch) {
        return new Promise(function(resolve) {
            setTimeout(function() {
                dispatch(wishlistAddItemSuccess(product, locale));
                resolve();
            }, 500);
        });
    };
}
function wishlistRemoveItem(productId) {
    return function(dispatch) {
        return new Promise(function(resolve) {
            setTimeout(function() {
                dispatch(wishlistRemoveItemSuccess(productId));
                resolve();
            }, 500);
        });
    };
}
function wishListRemoveAllItems() {
    return {
        type: _wishlistActionTypes__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_REMOVE_ALL_ITEMS */ .oe
    };
}


/***/ }),

/***/ 87755:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"custom_input_checkout":"custom_fields_custom_input_checkout___1RF8","custom_input_field":"custom_fields_custom_input_field__fKb69","err_field":"custom_fields_err_field___7H_i","custom_input_label":"custom_fields_custom_input_label__t9gVl"};

/***/ }),

/***/ 84632:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block-header":"blockHeader_block-header__E_75W","block-header__title__custom":"blockHeader_block-header__title__custom__jv3eD","title-line-fms":"blockHeader_title-line-fms__y1iU4","title-name-fms":"blockHeader_title-name-fms__j9Nkd"};

/***/ }),

/***/ 31351:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"home-product-container":"products_home-product-container__8aDSV","block-products__body":"products_block-products__body__U5Da6","block-products__list":"products_block-products__list__Kbc6J","product-card-parent":"products_product-card-parent__0QJ9h","product-card":"products_product-card__sPD03","product-card__image":"products_product-card__image__MJVv5","product-card__addToCart":"products_product-card__addToCart__XdrRC","product-image__body":"products_product-image__body__g0hlL","item_overlay":"products_item_overlay__HhgFv","second_image":"products_second_image__hSpTz","hide_first_image":"products_hide_first_image__sheko","img_btn_wrapper":"products_img_btn_wrapper__IRNpd","img_wrapper":"products_img_wrapper__NL0Y8","prices":"products_prices__lxiJv","new_price":"products_new_price__9mQi7","old_price":"products_old_price__xx3OV","product-card__info":"products_product-card__info__oAVyS","product-card__name":"products_product-card__name__2KSSq","product-card-description":"products_product-card-description__TlHgR","product-card__buttons":"products_product-card__buttons__LAq2x","wishlist-icon-wrapper":"products_wishlist-icon-wrapper__YZNXE","inner-wishlist":"products_inner-wishlist__7HpTL","product-card__actions":"products_product-card__actions__PnaLZ","product-card__availability-mobile":"products_product-card__availability-mobile__dRdC4","product-card__availability":"products_product-card__availability__kSHPn","product-card__wishlist":"products_product-card__wishlist__aUI5s","wishlist-circle":"products_wishlist-circle__aSQMX","wishlist-circle-clicked":"products_wishlist-circle-clicked__3nScE","hide-for-desktop":"products_hide-for-desktop__xs9Nz","product-card__prices":"products_product-card__prices__XneBT"};

/***/ }),

/***/ 77558:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"empty__footer":"customFooter_empty__footer__o9CEa","footer_padding_off":"customFooter_footer_padding_off__thywd","copyright_border_none":"customFooter_copyright_border_none__8wv6P","site-footer":"customFooter_site-footer__j942S","footer-container":"customFooter_footer-container__sUH_2","footer-body":"customFooter_footer-body__fVU0M","footer-newsletter__title":"customFooter_footer-newsletter__title__GXREd","footer-main-info":"customFooter_footer-main-info__sJH4s","footer_text":"customFooter_footer_text__1BEJK","footer_logo":"customFooter_footer_logo__QUzjM","footer-first-column":"customFooter_footer-first-column__dJ_H_","footer-newsletter-hide":"customFooter_footer-newsletter-hide__7v3LL","footerLinks-fms":"customFooter_footerLinks-fms__t5n_c","trackingNumber-fms":"customFooter_trackingNumber-fms___7HpW","newsletter-block":"customFooter_newsletter-block__uk5dS","footer-newsletter-container":"customFooter_footer-newsletter-container__QgpnG","footer-contacts":"customFooter_footer-contacts__qIOsU","footer-contacts__contacts":"customFooter_footer-contacts__contacts__vNKYs","contactsAddress_list":"customFooter_contactsAddress_list__SiVJj","contactsAddress":"customFooter_contactsAddress__IIGuk","footer-newsletter__social-links":"customFooter_footer-newsletter__social-links__Wxgz4","social-links__list":"customFooter_social-links__list__yBzU8","social-links__item":"customFooter_social-links__item__uM5yH","social-links__link":"customFooter_social-links__link__juCrP","footer-newsletter__form":"customFooter_footer-newsletter__form__lrz6l","footer-newsletter__form-button":"customFooter_footer-newsletter__form-button__Irrcp","copyright":"customFooter_copyright__1wkwh","toTop":"customFooter_toTop__d1u8o","toTop--show":"customFooter_toTop--show__Dg2Qt","toTop__body":"customFooter_toTop__body__j5IHv","toTop__end":"customFooter_toTop__end__1Z2oC","toTop__button":"customFooter_toTop__button__W4wm2","bottom_footer":"customFooter_bottom_footer__Jf3ua","empty_menus":"customFooter_empty_menus__J87SV","empty_contacts":"customFooter_empty_contacts__YjGD5","bottom_search":"customFooter_bottom_search__Ztrvr","click-disabled":"customFooter_click-disabled__ZsHGB","bottomNavigation-wrapper":"customFooter_bottomNavigation-wrapper__BKeOr","bottom-nav-item":"customFooter_bottom-nav-item__3prmU","local-item-active":"customFooter_local-item-active__IQXjy","indicator":"customFooter_indicator__dLfUW","indicator__area":"customFooter_indicator__area__TZrrL","under_line__active":"customFooter_under_line__active__r0FQW","user_indicator":"customFooter_user_indicator__bExR_"};

/***/ }),

/***/ 72286:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mobilemenu":"customMobileMenu_mobilemenu__BOmCA","mobilemenu--open":"customMobileMenu_mobilemenu--open__l1LAv","mobilemenu__backdrop":"customMobileMenu_mobilemenu__backdrop__mQo8e","menu_backdrop":"customMobileMenu_menu_backdrop__pgZh4","mobilemenu__body":"customMobileMenu_mobilemenu__body__kVFwi","animtrue":"customMobileMenu_animtrue__uGAcM","backdrop__hide":"customMobileMenu_backdrop__hide__4uPQO","menu_backdrop__close":"customMobileMenu_menu_backdrop__close__c7aFq","menu__header":"customMobileMenu_menu__header__wvmmD","header__logo":"customMobileMenu_header__logo__0Tsbl","mobile-header__menu-button":"customMobileMenu_mobile-header__menu-button__Ze7_6","mobilemenu__content":"customMobileMenu_mobilemenu__content__woEZX","mobile-links__item-link":"customMobileMenu_mobile-links__item-link__NSwtd","mobile-links":"customMobileMenu_mobile-links__y7Zy8","mobile-links__item":"customMobileMenu_mobile-links__item__bhpdi","mobile-links__item-title":"customMobileMenu_mobile-links__item-title__Ayfx1","link-label":"customMobileMenu_link-label__JB_Dv","name-icon__container":"customMobileMenu_name-icon__container__Xxsos","icon_wrapper":"customMobileMenu_icon_wrapper__vmKYC","mobile-links__item-toggle":"customMobileMenu_mobile-links__item-toggle__ZVwu_","mobile-links__item-arrow":"customMobileMenu_mobile-links__item-arrow__BVzJB","mobile-links__item-sub-links":"customMobileMenu_mobile-links__item-sub-links__yvFny","mobile-links--level--1":"customMobileMenu_mobile-links--level--1__KBUMn","mobile-links--level--2":"customMobileMenu_mobile-links--level--2__4DKR6","mobile-links--level--3":"customMobileMenu_mobile-links--level--3__dEqAs","mobile-links--level--4":"customMobileMenu_mobile-links--level--4__joqxb","mobile-links--level--5":"customMobileMenu_mobile-links--level--5__AEfbD","mobile-links--level--6":"customMobileMenu_mobile-links--level--6__aa51L","mobile-links--level--7":"customMobileMenu_mobile-links--level--7___Ojkx","mobile-links__item--open":"customMobileMenu_mobile-links__item--open__NeEGs","mob-links__item":"customMobileMenu_mob-links__item__upApT","mobile-links__blok":"customMobileMenu_mobile-links__blok__NTmJP","mobileMenuFooter":"customMobileMenu_mobileMenuFooter__ufB8C","mobile-footer-dropdown":"customMobileMenu_mobile-footer-dropdown__JaQw7","mobile-footer-dropdown-divs":"customMobileMenu_mobile-footer-dropdown-divs__ImxIG","footer-contacts":"customMobileMenu_footer-contacts__qITZM","footer-title":"customMobileMenu_footer-title__Dw__r","footer-title-opened":"customMobileMenu_footer-title-opened__5p2Ky","mobile-footer-arrow":"customMobileMenu_mobile-footer-arrow__JmSBt","footer-contacts__contacts":"customMobileMenu_footer-contacts__contacts__3_2_0","contactsAddress":"customMobileMenu_contactsAddress__YQGN1","mobile-footer-dropdown-last-divs":"customMobileMenu_mobile-footer-dropdown-last-divs__OPkb2","footer-newsletter__social-links":"customMobileMenu_footer-newsletter__social-links__ER7nx","social-links__list":"customMobileMenu_social-links__list__EVhUq","social-links__item":"customMobileMenu_social-links__item__rcVEV","social-links__link":"customMobileMenu_social-links__link__dO1N2","mobilemenu__open":"customMobileMenu_mobilemenu__open__KTTJ8","mobileMenuFooter-fms":"customMobileMenu_mobileMenuFooter-fms__6ZqU2"};

/***/ }),

/***/ 66557:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search--location--header":"customSearch_search--location--header__Y_50Y","search__body":"customSearch_search__body__ohKgq","search__form":"customSearch_search__form__YMVW5","search__input":"customSearch_search__input__23_XT","search__border":"customSearch_search__border__ZlWjW","search__button":"customSearch_search__button__dsVCh","search__button--type--close":"customSearch_search__button--type--close__jaVFv","suggestions":"customSearch_suggestions__YYMZB","suggestions__item":"customSearch_suggestions__item__XmdeR","suggestions__item-meta":"customSearch_suggestions__item-meta__8ECGu","suggestions__list":"customSearch_suggestions__list__kKeGK","suggestions__item-image":"customSearch_suggestions__item-image__UHnWk","suggestions__item-info":"customSearch_suggestions__item-info__Ve9ml","suggestions__item-price":"customSearch_suggestions__item-price__nQ79y","search__fm_dr_Message":"customSearch_search__fm_dr_Message__mHiH4","search--has-suggestions":"customSearch_search--has-suggestions__izwMq","search--suggestions-open":"customSearch_search--suggestions-open__BU6Z7","search__suggestions":"customSearch_search__suggestions__5F8eV","suggestions__item-actions":"customSearch_suggestions__item-actions__NvbGL","search__button--type--submit":"customSearch_search__button--type--submit__syvl0","mobilemenu__content":"customSearch_mobilemenu__content__2QPzb","mob-links__item":"customSearch_mob-links__item__mHif2"};

/***/ }),

/***/ 92365:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_header":"customHeader_top_header__wANmM","first_section":"customHeader_first_section__9YebC","header_nav_menu":"customHeader_header_nav_menu__Hdswv","header_nav_menu_item":"customHeader_header_nav_menu_item__kNK49","menu__submenu":"customHeader_menu__submenu__XQrFp","header":"customHeader_header__74AaR","logo_div":"customHeader_logo_div__rfZI3","nav-panel__departments":"customHeader_nav-panel__departments__hU3VZ","departments":"customHeader_departments__jZCs9","departments__body":"customHeader_departments__body__53q7x","departments__links-wrapper":"customHeader_departments__links-wrapper__DlgKd","departments__links":"customHeader_departments__links__AliQA","departments__item__li":"customHeader_departments__item__li__Sj1oS","menu":"customHeader_menu__RTw66","departments__item__li_a":"customHeader_departments__item__li_a__CIesL","departments__link-arrow":"customHeader_departments__link-arrow__lFqcN","departments__menu":"customHeader_departments__menu__C_ern","departments__submenu":"customHeader_departments__submenu__aT741","fadeIn":"customHeader_fadeIn__GjDtg","departments__button":"customHeader_departments__button__oUGpU","category-title-fms":"customHeader_category-title-fms__12GKA","departments--opened":"customHeader_departments--opened__Coh0q","mobile-header__menu-button":"customHeader_mobile-header__menu-button__3KkTx","language-button":"customHeader_language-button__jnlxp","name-icon__container":"customHeader_name-icon__container__zGCdL","icon_wrapper":"customHeader_icon_wrapper__1m9FO","menu__li":"customHeader_menu__li__xcwTQ","menu_item__container":"customHeader_menu_item__container__iWIb6","link__button":"customHeader_link__button__7_5v4","only__link":"customHeader_only__link__6f8mb","menu__li__a":"customHeader_menu__li__a__oMsHT","wrapper__bttn":"customHeader_wrapper__bttn__B7n8i","closed":"customHeader_closed__n252B","deep__submenu":"customHeader_deep__submenu__2W1AC","opened__drop":"customHeader_opened__drop__6kyii","dropMenus__container":"customHeader_dropMenus__container__MAb25","dropMenus__body":"customHeader_dropMenus__body__li2U3","second_section":"customHeader_second_section__hzQu7","nav-panel":"customHeader_nav-panel__sBOyG","nav-panel__container":"customHeader_nav-panel__container__GXL7u","nav-panel__row":"customHeader_nav-panel__row__psx0v","site-header__search":"customHeader_site-header__search__jZMjL","nav-panel__indicators":"customHeader_nav-panel__indicators__1taLE","nav-panel__item_row":"customHeader_nav-panel__item_row__RI5Rj","indicator":"customHeader_indicator__aSkof","account-logo-svg":"customHeader_account-logo-svg__vx0PF","indicator__button":"customHeader_indicator__button__uvRhN","indicator__area":"customHeader_indicator__area__gmkwn","authenticated_item":"customHeader_authenticated_item__89F_9","company_name":"customHeader_company_name__L0Yd_","indicator__value":"customHeader_indicator__value__uVX_q","pulse":"customHeader_pulse__CLn1K","desktop_user_active__wrapper":"customHeader_desktop_user_active__wrapper__pcxB5","indicator-title-fms":"customHeader_indicator-title-fms__03ioy","indicator__dropdown":"customHeader_indicator__dropdown__H5oW5","account-menu":"customHeader_account-menu__LM_hP","account-menu__form":"customHeader_account-menu__form__2DvzA","account-menu__form-title":"customHeader_account-menu__form-title__BN82L","account-menu_loginAndPass":"customHeader_account-menu_loginAndPass__Jh2iu","account-menu__form-button":"customHeader_account-menu__form-button__0OiR_","rounded-pills":"customHeader_rounded-pills__kukdS","account-menu__form-link":"customHeader_account-menu__form-link__8KLya","new-customer":"customHeader_new-customer__4olSq","dropcart":"customHeader_dropcart__1mGO4","dropcart__products-list":"customHeader_dropcart__products-list__D3xNH","dropcart__products-list_scroll":"customHeader_dropcart__products-list_scroll__zqN_g","dropcart__product":"customHeader_dropcart__product__yaHPF","dropcart__product-image":"customHeader_dropcart__product-image__tp_XH","dropcart__product-info":"customHeader_dropcart__product-info__EgXKr","dropcart__product-name":"customHeader_dropcart__product-name__xUIg0","dropcart__product-meta":"customHeader_dropcart__product-meta__x_t7Y","dropcart__product-price":"customHeader_dropcart__product-price__bXdfo","dropcart__product-remove":"customHeader_dropcart__product-remove__eZSqu","dropcart__totals":"customHeader_dropcart__totals___LLYP","dropcart__buttons":"customHeader_dropcart__buttons___Mbo_","dropcart__buttons-link":"customHeader_dropcart__buttons-link__rDnZh","dropcart__empty":"customHeader_dropcart__empty__Ywj8w","indicator--trigger--click":"customHeader_indicator--trigger--click__INnLm","indicator--opened":"customHeader_indicator--opened__LBCmi","indicator--trigger--hover":"customHeader_indicator--trigger--hover__oTXJR","nav-panel__item-custom":"customHeader_nav-panel__item-custom__jZmes","nav-panel__account-nav":"customHeader_nav-panel__account-nav__jHw3_","account-nav__item":"customHeader_account-nav__item__YNG2e","logout":"customHeader_logout__G1ZUI","account-nav__item--active":"customHeader_account-nav__item--active__zcWLg","mobile__search":"customHeader_mobile__search__Tfzw8","renderer_header":"customHeader_renderer_header__sv2Vv","menu-none":"customHeader_menu-none__tXxLp","menu-block":"customHeader_menu-block__bRmQb","menu_item":"customHeader_menu_item__AP8Zu","menu__icon":"customHeader_menu__icon__W2GLw","mobile-header__search":"customHeader_mobile-header__search__Ob0tV","mobile-header__search--open":"customHeader_mobile-header__search--open__jtLFW","mobile_indicator__value":"customHeader_mobile_indicator__value__p7mTZ"};

/***/ }),

/***/ 474:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top-bar":"customTopBar_top-bar__s67me","top-bar-main":"customTopBar_top-bar-main__pbQ2h","topbar_buttons":"customTopBar_topbar_buttons___cZNu","language-button":"customTopBar_language-button__R7YU_","menu-none":"customTopBar_menu-none__Y2cIF","rotT_fms":"customTopBar_rotT_fms__5wTk4","menu-block":"customTopBar_menu-block__UXpPs","menu":"customTopBar_menu__1l3EG","menu_item":"customTopBar_menu_item__F2iwX","menu__icon":"customTopBar_menu__icon__7V71H","menu__title":"customTopBar_menu__title__xgHsc","mobile_currency__symbol":"customTopBar_mobile_currency__symbol__XPtqZ","mobile-links__item-title":"customTopBar_mobile-links__item-title__MLUrL","showHide":"customTopBar_showHide__aK6Xi"};

/***/ }),

/***/ 67707:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card-wrapper":"account_card-wrapper__Od1lX","card":"account_card__ZDa38","card-body":"account_card-body__kgzEe","card-title":"account_card-title__eClMA","create_an_account":"account_create_an_account___D0db","signUp-contact_person":"account_signUp-contact_person__WUIs3","sbm_button":"account_sbm_button__5Qfo4","active_state":"account_active_state__gAjz0","select_label_title":"account_select_label_title__HTUCw","select-container":"account_select-container__E6obT","checkout-select":"account_checkout-select__qeFG8","checkout-input":"account_checkout-input__awiGp","custom-select-mark":"account_custom-select-mark__pALoe","select-dots":"account_select-dots__zTw9e","form-group":"account_form-group__v4n4n","checkout-style":"account_checkout-style__fHC26","block":"account_block__vdoYk","empty_orders_list":"account_empty_orders_list__uEYGe","page__signin":"account_page__signin__Voajz","page__forgot_password":"account_page__forgot_password__mCg76","page__reset_password":"account_page__reset_password__o0zsz","account-menu__form-forgot-link":"account_account-menu__form-forgot-link__GmQ3_","signUp-position-relative":"account_signUp-position-relative__sg516","login-button":"account_login-button__ppWWG","rounded-pills":"account_rounded-pills__oDE3Y","account-nav__item":"account_account-nav__item__Uod5L","historyIcon-svg":"account_historyIcon-svg__UiLYi","logout":"account_logout__sbSw_","account-nav__item--active":"account_account-nav__item--active__BwxGH","account-nav":"account_account-nav__OPwAu","account-nav__title":"account_account-nav__title__YkaE9","account-layout-wrapper":"account_account-layout-wrapper__tmngF","account-layout":"account_account-layout__KtM4W","account-layout-desktop":"account_account-layout-desktop__G5i2l","account-nav-username":"account_account-nav-username__r_LG4","account-links-body":"account_account-links-body__8vVY3","login-ss":"account_login-ss__GtNyH","addresses-list__item":"account_addresses-list__item__Kip0F","addresses-list__item--new":"account_addresses-list__item--new__0IJ2V","addresses-list__plus":"account_addresses-list__plus__S0RBV","address-card":"account_address-card__eFeZk","address-card__body":"account_address-card__body__zx8Lg","address-card--featured":"account_address-card--featured__DZbKY","address-card__name":"account_address-card__name__vdjL4","address-card__row":"account_address-card__row__ZY_h3","address-card__row-title":"account_address-card__row-title__hPCUC","addresses-list":"account_addresses-list__22QXD","new_address_link":"account_new_address_link__ZOdMT","address-card__footer":"account_address-card__footer__csr6e","address-remove-btn":"account_address-remove-btn__WIgy6","mobile-footer-dropdowns-list":"account_mobile-footer-dropdowns-list__6YWcN","addresses-list__divider":"account_addresses-list__divider__KJUIq","address-page-body":"account_address-page-body__6R_eQ","address-page-title":"account_address-page-title__nbtyL","account-menu__form":"account_account-menu__form__BoLxP","new-adresses":"account_new-adresses__mQLpL","form-row":"account_form-row__DrFHW","edit-adresses-wrapper":"account_edit-adresses-wrapper__7Dyqu","dark-opacity":"account_dark-opacity__a38rj","card-header":"account_card-header__6nbYh","card-footer":"account_card-footer__h8FTA","add-new-address-body":"account_add-new-address-body__bYLp6","form-control":"account_form-control__RxiNa","new-adresses-select":"account_new-adresses-select__mzGdc","new-adresses_address":"account_new-adresses_address__k9IQv","order-details-info_addresses":"account_order-details-info_addresses__h08Rg","order-info-1":"account_order-info-1__so_1J","order-details-info":"account_order-details-info__SUCev","order-info-2":"account_order-info-2__e7mFb","order-header":"account_order-header__snIOl","order-header__title":"account_order-header__title__Nc507","order-header__actions":"account_order-header__actions__RprPL","back_list":"account_back_list__40e3f","order-bottom-info":"account_order-bottom-info__rbnt4","order-bottom-info-mobile":"account_order-bottom-info-mobile__Qvhk0","order-wrap-layer-title2":"account_order-wrap-layer-title2__zpm38","order-wrap-layer-title":"account_order-wrap-layer-title__90I4b","order-title-line-1":"account_order-title-line-1__XAJed","order-title-line-2":"account_order-title-line-2__VR4y2","order-details-bottom-info":"account_order-details-bottom-info__NESjB","reorder-btn-parent":"account_reorder-btn-parent__EDdpY","order-details-mobile":"account_order-details-mobile__0tSB1","card-mobile-header":"account_card-mobile-header__VXSxA","order-details-mobile-header":"account_order-details-mobile-header__DqHCB","order_title":"account_order_title__2rEbT","order_title_text":"account_order_title_text__vtbLa","orders-inner-details-mobile":"account_orders-inner-details-mobile__t9MA3","orders-inner-details-header-mobile":"account_orders-inner-details-header-mobile__YVqqR","order-inner-detail-rows":"account_order-inner-detail-rows__3fvbU","table-heading-descriptions":"account_table-heading-descriptions__gst5w","orders-products-names-mobile":"account_orders-products-names-mobile__f22pF","order-details-product":"account_order-details-product__D8QBP","order-details-name-width":"account_order-details-name-width__Owwe4","order-details-price":"account_order-details-price__sv_2o","order-details-info-mobile":"account_order-details-info-mobile__OHbf_","order-details-info-table-mobile":"account_order-details-info-table-mobile__JZwYD","reorder-btn":"account_reorder-btn__VtDga","mobile-order-info":"account_mobile-order-info__oQJV_","underline":"account_underline__m4ARJ","order__id":"account_order__id__I96vl","orders-page-mobile":"account_orders-page-mobile___Xs6X","order-history-card-mobile":"account_order-history-card-mobile__ZFOBp","order-card-mobile-top-position":"account_order-card-mobile-top-position__ySO40","table_column":"account_table_column__Ox7LY","order-card-mobile-title":"account_order-card-mobile-title__AP_VZ","order-id-mobile-href":"account_order-id-mobile-href__HA8X7","order-card-mobile-options":"account_order-card-mobile-options__qcpw2","card-table":"account_card-table__W9kAm","last_column":"account_last_column__E0GIg","dwn_tr":"account_dwn_tr__lU2xZ","dwn_column":"account_dwn_column__S2ho4","download__btn_container":"account_download__btn_container__qZLRS","download__btn":"account_download__btn__OJ5xk","link_container":"account_link_container__kS0rH","disabled__product_name":"account_disabled__product_name__8w79q","disabled__link_container":"account_disabled__link_container__66Qjw","card-table__body--merge-rows":"account_card-table__body--merge-rows__NidH6","input-fields-parent":"account_input-fields-parent__eTJGH","personal-info-card":"account_personal-info-card__ZYeRx","input-paddings":"account_input-paddings__IWewx","small__inputs__container":"account_small__inputs__container__H2Hag","card_grid":"account_card_grid__9xd4i","account-input-title":"account_account-input-title__Q5_Bv","button-change-password":"account_button-change-password__FR_dr","account-contact_person":"account_account-contact_person__Ihk06","account-save-profile":"account_account-save-profile__33nTV","reset-modal":"account_reset-modal__bEUBG","modal-title":"account_modal-title__8n8DZ","modal-href":"account_modal-href__z_9T_","order-details-info-table":"account_order-details-info-table__XT2Vj","invalid-fields":"account_invalid-fields__9o_vI","passwordChange":"account_passwordChange__EL988","we-recommend":"account_we-recommend___1DfW","modal-newpasswords":"account_modal-newpasswords__R4yvt","modalss":"account_modalss__9BCfl","modal-body":"account_modal-body__0L7wx","modal-body-forms":"account_modal-body-forms__JyAQ_","new-passwords":"account_new-passwords__WoBug","error-message-change-password":"account_error-message-change-password__VxReH","socials_content":"account_socials_content__36bRy","links_icons":"account_links_icons__7hZf5","account-menu-login":"account_account-menu-login__ode5T","social-links_line":"account_social-links_line__JwX6V","social_line":"account_social_line__LzOjt","social-line-block":"account_social-line-block__zlmhy","social_line-span":"account_social_line-span__5f2m4","active":"account_active__J856_","modal-content":"account_modal-content__7_sfO","modal-string":"account_modal-string__4WA9M","card_mobile":"account_card_mobile__MxKUM","card_desktop":"account_card_desktop__zE3aB","downloads_column_mob":"account_downloads_column_mob__CUSpF","card_discount":"account_card_discount__kjWtV","account-layout-content-margin":"account_account-layout-content-margin__JDTT_","modal-content-active-register":"account_modal-content-active-register__k3xSA","account-menu__form-forgot":"account_account-menu__form-forgot__GV6qI"};

/***/ }),

/***/ 74743:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"popup_pos":"formModal_popup_pos__KOGTy","main_popup":"formModal_main_popup___SMXw","main_popup_title":"formModal_main_popup_title__5LbMG","main_popup_header":"formModal_main_popup_header__IIE4F","main_popup_product_wrapper":"formModal_main_popup_product_wrapper__HqnSa","main_popup_img_wrapper":"formModal_main_popup_img_wrapper__v056e","main_popup_img":"formModal_main_popup_img__UlWU_"};

/***/ }),

/***/ 62314:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel":"builder_carousel_carousel__kfS6r","slick_arrow_wrapper":"builder_carousel_slick_arrow_wrapper__QGoQt","prev":"builder_carousel_prev__gHIRv","next":"builder_carousel_next__wiuMo","carousel_card_wrapper":"builder_carousel_carousel_card_wrapper___gYe0","brand_title":"builder_carousel_brand_title__aitx6","carousel_card":"builder_carousel_carousel_card___EUyB","carousel_card_image_wrapper":"builder_carousel_carousel_card_image_wrapper___W8a9","carousel_card_hover":"builder_carousel_carousel_card_hover__L4_vU","carousel_card_content":"builder_carousel_carousel_card_content__tRfNQ","testimonials":"builder_carousel_testimonials__ynOD_","carousel_card_image":"builder_carousel_carousel_card_image__sm3bw","carousel_card_title":"builder_carousel_carousel_card_title__ryHxB","carousel_card_description":"builder_carousel_carousel_card_description__wAab5","rate_wrapper":"builder_carousel_rate_wrapper__F1vtq","rating":"builder_carousel_rating__9qe1n","checked":"builder_carousel_checked__hpYHd","carousel_card_button":"builder_carousel_carousel_card_button__DZ7fa"};

/***/ }),

/***/ 46936:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropList":"dropList_dropList__ayz1H","dropLisItem":"dropList_dropLisItem__ZFm_U","dropListItemTitle":"dropList_dropListItemTitle__9rz8y","dropListItemDecr":"dropList_dropListItemDecr__m_Pvc","selectedTitle":"dropList_selectedTitle__JV7YZ","content":"dropList_content__NnmCa"};

/***/ }),

/***/ 93811:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"forms_form__cdi8_","heading_h1":"forms_heading_h1__kEFhx","heading_h2":"forms_heading_h2__LXpIQ","heading_h3":"forms_heading_h3__Ck0iY","heading_h4":"forms_heading_h4__VkTSN","heading_h5":"forms_heading_h5__8n1ba","heading_h6":"forms_heading_h6__7j2R2","form_input":"forms_form_input__mArPY","form_checkbox":"forms_form_checkbox__m4AB_","form_radio":"forms_form_radio___ilTL","form_input_number":"forms_form_input_number__vlKqC","form_input_date":"forms_form_input_date__RhzP9","form_text_area":"forms_form_text_area__0UQd3","form_select":"forms_form_select__HhNBx","label":"forms_label__YfM60","required":"forms_required__A6oea","description":"forms_description__4cmB3","info_text":"forms_info_text__Bt4NJ","form_button":"forms_form_button__lNCC4","options":"forms_options__i8cRo","option":"forms_option__FEDW5","other_input":"forms_other_input__pnz1E","toggle_border":"forms_toggle_border__cwXvy","toggle":"forms_toggle__Ry85V","check":"forms_check__LQd4A","checked":"forms_checked__BB8k9","select":"forms_select__BQCSF","select_button":"forms_select_button__HmsXF","select_options":"forms_select_options__QlcBT","open":"forms_open__LC4gq","selected":"forms_selected__bT2sN","warning":"forms_warning__MqJYO"};

/***/ }),

/***/ 78648:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cover":"hoverImage_cover__UHwk0"};

/***/ }),

/***/ 17478:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slider":"builder_slider_slider__FGuwv","slide_link":"builder_slider_slide_link__2WTFC","slide_wrapper":"builder_slider_slide_wrapper__TuieU","content_wrapper":"builder_slider_content_wrapper__NL6Gz","content":"builder_slider_content__yC3q1","content_title":"builder_slider_content_title__LvEqg","content_description":"builder_slider_content_description__9DUk5","content_button":"builder_slider_content_button__Qq14T"};

/***/ }),

/***/ 1019:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main__container":"table_main__container___9tI3","contents__table":"table_contents__table__lPUxj","content__item":"table_content__item__FZibO"};

/***/ }),

/***/ 71559:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabs_component":"tabs_tabs_component__u27Nz","tabsList":"tabs_tabsList__OXJuU","tabsListItem":"tabs_tabsListItem__pzh35","fullWidthTabs":"tabs_fullWidthTabs__xqoGP","selectedItem":"tabs_selectedItem__DcWfC","tabsListItemTitle":"tabs_tabsListItemTitle__vTObl","dropListItemDecr":"tabs_dropListItemDecr__8xLri","selectedTitle":"tabs_selectedTitle___OCsI","content":"tabs_content__4TXhh"};

/***/ }),

/***/ 20017:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"timeline-chart":"timeline_timeline-chart__z__tI","first_and_last_timeline":"timeline_first_and_last_timeline__tzSTR","timeline_heading":"timeline_timeline_heading__d0PcK","timeline_content":"timeline_timeline_content__VnhOn","point_icon":"timeline_point_icon__H_Bsp","timeline-chart-inner":"timeline_timeline-chart-inner__6F_d4","timeline-point":"timeline_timeline-point__tpCVp","timeline-label":"timeline_timeline-label__uRNIw","icon_container":"timeline_icon_container__oY8wQ","lines":"timeline_lines__6mjGY","timeline_lines":"timeline_timeline_lines__HEUp2","timeline__line":"timeline_timeline__line__8t8RO","point__line":"timeline_point__line__u_iDc"};

/***/ }),

/***/ 20279:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"backVideoBlock":"videoBackground_backVideoBlock__YQIpp","videoFrame":"videoBackground_videoFrame__Bu2Rg"};

/***/ }),

/***/ 20426:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faq_component":"builder_faq_component__Y8WRi","faqs":"builder_faqs__7PGpT","faq_component_item":"builder_faq_component_item__bDrmY","faq_title_wrapper":"builder_faq_title_wrapper__q0w6I","faq_title":"builder_faq_title__Chw9Y","arrow_faq_icon":"builder_arrow_faq_icon__ncV_J","rotated":"builder_rotated__Mg5P3","plus":"builder_plus__BofLx","open":"builder_open__ilXWp","faq_body":"builder_faq_body__SmCeA","icon_component":"builder_icon_component__D0LtI","block-products":"builder_block-products__sT1qo","b-container":"builder_b-container__iumtw","topped_margin_off":"builder_topped_margin_off__FkYCq","zg-grid-col":"builder_zg-grid-col__HDyvd","zg-row":"builder_zg-row__hLWu7","zg-dragforborder":"builder_zg-dragforborder__akYEv","builder_component":"builder_builder_component__f722A","editor_content":"builder_editor_content__HAO3Q","video_wrapper":"builder_video_wrapper__0f2Ch","home-product-container":"builder_home-product-container__nmU7O","zg-col-lg":"builder_zg-col-lg__H9V0R","zg-col-md":"builder_zg-col-md__vIYqG","zg-col-sm":"builder_zg-col-sm__lV4MC","scale":"builder_scale__X4_z_","bounce":"builder_bounce__vke3a","shake":"builder_shake__eCaos","shakeFrame":"builder_shakeFrame__pqOSU","fade-up":"builder_fade-up__e2n1j"};

/***/ }),

/***/ 30406:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"post_page_title":"posts_post_page_title__bw1yE","category-description":"posts_category-description__jR8e6","post_body":"posts_post_body__mkLnC","post_filters":"posts_post_filters__Rb27a","post_category_filters":"posts_post_category_filters__xA9Ds","post_filter":"posts_post_filter__CWGZt","post_filter_title":"posts_post_filter_title__ITiHD","post_cat_filter_body":"posts_post_cat_filter_body__r2C5K","desktop":"posts_desktop__X6209","mobile":"posts_mobile__UPYBl","post_filters_row":"posts_post_filters_row__5Pnc7","active":"posts_active__kYZ_X","post_tags_filters":"posts_post_tags_filters__qbGZ_","post_tag_filter_body":"posts_post_tag_filter_body__VM_jR","post_filters_tag":"posts_post_filters_tag__0m7xz","posts_list":"posts_posts_list__sy1vj","posts_pagination":"posts_posts_pagination__k2_t3","post_list_item":"posts_post_list_item__7sCcL","postCard":"posts_postCard__6Quhc","post_card_image":"posts_post_card_image__YHBWF","post_card_info":"posts_post_card_info__ofV51","post_card_name":"posts_post_card_name__q5pZD","post_card_read_data":"posts_post_card_read_data__vMQuL","post_card_date":"posts_post_card_date__TT5hS","post_card_read_more":"posts_post_card_read_more__o5_yW","empty_post_list":"posts_empty_post_list__xT4gM","post_container":"posts_post_container__aaoWx","post-header__title":"posts_post-header__title__VENkT","post-header__meta":"posts_post-header__meta__1mKKK","post-header__meta-item":"posts_post-header__meta-item__HFbND","post__featured":"posts_post__featured__IgRDM","tags_container":"posts_tags_container__aHX1K","tag":"posts_tag__UMm_B","typography":"posts_typography___yttp","share_container":"posts_share_container__hsXlV","share_text":"posts_share_text__7buT1","share_icons":"posts_share_icons__Dag01","products-view__empty":"posts_products-view__empty__rcjQ1","products-view__empty-title":"posts_products-view__empty-title__Uekhs","products-view__empty-subtitle":"posts_products-view__empty-subtitle__HUti7","posts_list_row_4":"posts_posts_list_row_4__VWtXW","cat_select":"posts_cat_select__S_wRA","cat_button":"posts_cat_button__STg7I","drop_down_arrow":"posts_drop_down_arrow__2ViiJ","opened":"posts_opened__K2F0p","cat_drop_down":"posts_cat_drop_down__l4ZgF","cat_option":"posts_cat_option__GNxIH","selected":"posts_selected__cZr8y","category_title":"posts_category_title__aQj_R"};

/***/ })

}]);